'use strict';


import { environment } from "src/environments/environment";
import { UiconfigModule } from "./uiconfig/uiconfig.module";
// export const BaseURL: string = environment.apiURL;
export const AdvinMaster: string = environment.AMBaseURL + '/AM';
// Reverted: identity-vs-tenant DB routing is handled backend-side by the
// [UseIdentityServer] attribute (now applied per-action, not per-controller)
// + CompanyConfigMiddleware (picks IDENTITYDBConn vs MasterDBConn per
// endpoint) - the frontend doesn't need a separate origin for these
// services, they stay on the normal AdvinMaster/ApiConfiguration path.
export const CRM: string = environment.CRMBaseURL + '/CRM';
export const SupportDesk: string = environment.SPDBaseURL + '/SPD';
export const HRMS: string = environment.HRMSBaseURL + '/HRMS';
export const ERP: string = environment.ERPBaseURL + '/ERP';
export const Notification: string = environment.NTBaseURL + '/NT'
export const PMS: string = environment.PMSBaseURL + '/PMS';
export const BIR: string = environment.BIRBaseURL + '/BIR';
export const AI: string = environment.AIBaseURL + '/AI';
export const DevOps: string = environment.DOBaseURL + '/DO';
export const Payroll: string = environment.PRBaseURL + '/PR';
export const ExternalIntegration: string = environment.EXTBaseURL + '/EXT'

// ── ServerPool: per-tenant gateway URL resolution (GET /configuration) ─────
export const ServerPoolURL: string = AdvinMaster + '/SP';
export const ServerPool_getApiConfiguration = ServerPoolURL + '/GetApiConfiguration';

// ── GAC Admin Endpoints (/EXT/ADMIN/*) ──────────────────────────────────────
const GAC_ADMIN = ExternalIntegration + '/ADMIN';
export const GAC_Admin_Providers_Read        = GAC_ADMIN + '/providers';
export const GAC_Admin_Providers_Create      = GAC_ADMIN + '/providers/create';
export const GAC_Admin_Providers_Update      = GAC_ADMIN + '/providers/update';
export const GAC_Admin_ApiConfigs_Read       = GAC_ADMIN + '/apiconfigs';
export const GAC_Admin_ApiConfigs_Create     = GAC_ADMIN + '/apiconfigs/create';
export const GAC_Admin_ApiConfigs_Update     = GAC_ADMIN + '/apiconfigs/update';
export const GAC_Admin_ApiConfigs_Delete     = GAC_ADMIN + '/apiconfigs/delete';
export const GAC_Admin_TenantLinks_Read      = GAC_ADMIN + '/tenantlinks';
export const GAC_Admin_TenantLinks_Create    = GAC_ADMIN + '/tenantlinks/create';
export const GAC_Admin_TenantLinks_Update    = GAC_ADMIN + '/tenantlinks/update';
export const GAC_Admin_TenantLinks_Delete    = GAC_ADMIN + '/tenantlinks/delete';
export const GAC_Admin_Tokens_Read           = GAC_ADMIN + '/tokens';
export const GAC_Admin_Tokens_Upsert         = GAC_ADMIN + '/tokens/upsert';
export const GAC_Admin_Tokens_Delete         = GAC_ADMIN + '/tokens/delete';

export const EPC: string = CRM + '/EPC'
export const Warehouse: String = ERP + '/WH';
export const Master: string = ERP + '/MA';
export const Billing: string = ERP + '/BI';

//#region AddressDetail API
export const AddressDetailURL: string = AdvinMaster + '/AD';
export const AddressDetail_create = AddressDetailURL + '/Create';
export const AddressDetail_update = AddressDetailURL + '/Update';
export const AddressDetail_readById = AddressDetailURL + '/ReadById';
export const AddressDetail_readAll = AddressDetailURL + '/ReadAll';
export const AddressDetail_readByMasterId = AddressDetailURL + '/ReadByMasterId';
export const AddressDetail_delete = AddressDetailURL + '/Delete';
//#endregion

//#region BranchMaster API
export const BranchMasterURL: string = AdvinMaster + '/BM';
export const BranchMaster_create = BranchMasterURL + '/Create';
export const BranchMaster_update = BranchMasterURL + '/Update';
export const BranchMaster_readById = BranchMasterURL + '/ReadById';
export const BranchMaster_readAll = BranchMasterURL + '/ReadAll';
export const BranchMaster_delete = BranchMasterURL + '/Delete';
export const BranchMaster_ReadByUserId = BranchMasterURL + '/ReadByUserId';
export const BranchMaster_GetDictionary = BranchMasterURL + '/GetDictionary';
export const BranchMaster_readyByTenantId  = BranchMasterURL + '/ReadByTenantId'
//#endregion


//#region BranchMaster API
export const BranchRelationURL: string = AdvinMaster + '/BR';
export const BranchRelation_create = BranchRelationURL + '/Create';
export const BranchRelation_update = BranchRelationURL + '/Update';
export const BranchRelation_readById = BranchRelationURL + '/ReadById';
export const BranchRelation_readAll = BranchRelationURL + '/ReadAll';
export const BranchRelation_delete = BranchRelationURL + '/Delete';
export const BranchRelation_readByTenantBranchId = BranchRelationURL + '/ReadByTenantBranchId'
//#endregion

//#region Cities API
export const CitiesURL: string = AdvinMaster + '/CT';
export const Cities_create = CitiesURL + '/Create';
export const Cities_update = CitiesURL + '/Update';
export const Cities_delete = CitiesURL + '/Delete';
export const Cities_readById = CitiesURL + '/ReadById';
export const Cities_readAll = CitiesURL + '/ReadAll';
export const Cities_readByStateId = CitiesURL + '/ReadByStateId';
export const Cities_readAllPaginated = CitiesURL + '/ReadAllPaginated'
//#endregion

//#region CompanyConfig API
export const CompanyConfigURL: string = AdvinMaster + '/CC';
export const CompanyConfig_create = CompanyConfigURL + '/Create';
export const CompanyConfig_update = CompanyConfigURL + '/Update';
export const CompanyConfig_readById = CompanyConfigURL + '/ReadById';
export const CompanyConfig_readAll = CompanyConfigURL + '/ReadAll';
export const CompanyConfig_readByCompanyId = CompanyConfigURL + '/ReadByCompanyId';
export const CompanyConfig_delete = CompanyConfigURL + '/Delete';
//#endregion

//#region CompanyMaster API
export const CompanyMasterURL: string = AdvinMaster + '/CM';
export const CompanyMaster_create = CompanyMasterURL + '/Create';
export const CompanyMaster_update = CompanyMasterURL + '/Update';
export const CompanyMaster_readAll = CompanyMasterURL + '/ReadAll';
export const CompanyMaster_readById = CompanyMasterURL + '/ReadById';
export const CompanyMaster_delete = CompanyMasterURL + '/Delete';
export const CompanyMaster_readAllPaginated = CompanyMasterURL + '/ReadAllPaginated';
export const ComapnyMaster_SearchByName = CompanyMasterURL + '/SearchByName';
export const CompanyMaster_SearchByNameLogin = CompanyMasterURL + '/SearchByNameLogin';
export const CompanyMaster_readByUserId = CompanyMasterURL + '/ReadByUserId';
export const CompanyMaster_GetDictionary = CompanyMasterURL + '/GetDictionary';
export const CompanyMaster_ReadByGSTNo = CompanyMasterURL + '/ReadByGSTNo';
//#endregion

//#region CompanyRelation API
export const CompanyRelationURL: string = AdvinMaster + '/CR';
export const CompanyRelation_create = CompanyRelationURL + '/Create';
export const CompanyRelation_update = CompanyRelationURL + '/Update';
export const CompanyRelation_readAll = CompanyRelationURL + '/ReadAll';
export const CompanyRelation_readById = CompanyRelationURL + '/ReadById';
export const CompanyRelation_readByCompanyId = CompanyRelationURL + '/ReadByCompanyId';
export const CompanyRelation_delete = CompanyRelationURL + '/Delete';
export const CompanyRelation_GetSupplierDictionary = CompanyRelationURL + '/GetSupplierDictionary'
export const CompanyRelation_ReadByGSTNO = CompanyRelationURL + '/ReadByGSTNO'
export const CompanyRelation_ReadByCName = CompanyRelationURL + '/ReadByCName'
export const CompanyRelation_BulkUpsert = CompanyRelationURL + '/BulkUpsert'
//#endregion

//#region CompanySoftwareMapping API
export const CompanySoftwareMappingURL: string = AdvinMaster + '/CSM';
export const CompanySoftwareMapping_create = CompanySoftwareMappingURL + '/Create';
export const CompanySoftwareMapping_update = CompanySoftwareMappingURL + '/Update';
export const CompanySoftwareMapping_readById = CompanySoftwareMappingURL + '/ReadById';
export const CompanySoftwareMapping_readByTenantranchId = CompanySoftwareMappingURL + '/ReadByTenantBranchId';
export const CompanySoftwareMapping_readByTenantId  = CompanySoftwareMappingURL + '/ReadByTenantId';
export const CompanySoftwareMapping_readBySoftwareId = CompanySoftwareMappingURL + '/ReadBySoftwareId';
export const CompanySoftwareMapping_delete = CompanySoftwareMappingURL + '/Delete';
//#endregion


//#region CompanyWhiteLabel API
export const CompanyWhiteLabel: string = AdvinMaster + '/CWL';
export const CompanyWhiteLabel_create = CompanyWhiteLabel + '/Create';
export const CompanyWhiteLabel_update = CompanyWhiteLabel + '/Update';
export const CompanyWhiteLabel_readAll = CompanyWhiteLabel + '/ReadAll';
export const CompanyWhiteLabel_readById = CompanyWhiteLabel + '/ReadById';
export const CompanyWhiteLabel_readByTenantId  = CompanyWhiteLabel + '/ReadByTenantId';
export const CompanyWhiteLabel_delete = CompanyWhiteLabel + '/Delete';
//#endregion

//#region ContactDetail API
export const ContactDetailURL: string = AdvinMaster + '/CD';
export const ContactDetail_create = ContactDetailURL + '/Create';
export const ContactDetail_update = ContactDetailURL + '/Update';
export const ContactDetail_readById = ContactDetailURL + '/ReadById';
export const ContactDetail_readAll = ContactDetailURL + '/ReadAll';
export const ContactDetail_readByMasterId = ContactDetailURL + '/ReadByMasterId';
export const ContactDetail_delete = ContactDetailURL + '/Delete';
//#endregion

//#region Country API
export const CountryURL: string = AdvinMaster + '/C';
export const Country_create = CountryURL + '/Create';
export const Country_update = CountryURL + '/Update';
export const Country_readById = CountryURL + '/ReadById';
export const Country_readAll = CountryURL + '/ReadAll';
export const Country_delete = CountryURL + '/Delete';
//#endregion

//region MenuFeature API
export const MenuFeatureURL: string = AdvinMaster + '/MF';
export const createMenuFeature = MenuFeatureURL + '/Create'
export const updateMenuFeature = MenuFeatureURL + '/Update'
export const readAllMenuFeature = MenuFeatureURL + '/ReadAll'
export const readByIdMenuFeature = MenuFeatureURL + '/ReadById'
export const readByMenuIdFeature = MenuFeatureURL + '/ReadByMenuId'
export const readByProjectIdFeature = MenuFeatureURL + '/ReadByProjectId'
export const deleteMenuFeature = MenuFeatureURL + '/Delete'
//endregion

//region MenuMaster API
export const MenuMasterURL: string = AdvinMaster + '/MM';
export const MenuMaster_create = MenuMasterURL + '/Create';
export const MenuMaster_update = MenuMasterURL + '/Update';
export const MenuMaster_readById = MenuMasterURL + '/ReadById';
export const MenuMaster_delete = MenuMasterURL + '/Delete';
export const MenuMaster_readBySoftwareId = MenuMasterURL + '/ReadBySoftwareId';
export const MenuMaster_readByUserId = MenuMasterURL + '/ReadByUserId';
export const MenuMaster_readAll = MenuMasterURL + '/ReadAll';
//endregion

//region Roles API
export const RolesURL: string = AdvinMaster + '/R';
export const Roles_create = RolesURL + '/Create';
export const Roles_update = RolesURL + '/Update';
export const Roles_delete = RolesURL + '/Delete';
export const Roles_getDictionary = RolesURL + '/GetDictionary';
export const Roles_readAllPaginated = RolesURL + '/ReadAllPaginated';
export const Roles_readByGroupName = RolesURL + '/ReadByGroupName';
export const Roles_readByTenantId = RolesURL + '/ReadByTenantId';
//endregion

//region SoftwareMaster API
export const SoftwareMasterURL: string = AdvinMaster + '/SM';
export const SoftwareMaster_create = SoftwareMasterURL + '/Create';
export const SoftwareMaster_update = SoftwareMasterURL + '/Update';
export const SoftwareMaster_readById = SoftwareMasterURL + '/ReadById';
export const SoftwareMaster_readAll = SoftwareMasterURL + '/ReadAll';
export const SoftwareMaster_delete = SoftwareMasterURL + '/Delete';
export const SoftwareMaster_readByUserId = SoftwareMasterURL + '/ReadByUserId';
export const SoftwareMaster_GetDictionary = SoftwareMasterURL + '/GetDictionary'
//endregion

//region SoftwareDetails API
export const SoftwareDetailsURL: string = AdvinMaster + '/SD';
export const SoftwareDetails_create = SoftwareDetailsURL + '/Create';
export const SoftwareDetails_update = SoftwareDetailsURL + '/Update';
export const SoftwareDetails_delete = SoftwareDetailsURL + '/Delete';
export const SoftwareDetails_readById = SoftwareDetailsURL + '/ReadById';
export const SoftwareDetails_readAll = SoftwareDetailsURL + '/ReadAll';
export const SoftwareDetails_readAllPaginated = SoftwareDetailsURL + '/ReadAllPaginated';
//endregion

//region State API
export const StateURL: string = AdvinMaster + '/S';
export const State_create = StateURL + '/Create';
export const State_update = StateURL + '/Update';
export const State_readById = StateURL + '/ReadByID';
export const State_readAll = StateURL + '/ReadALL';
export const State_readByCountryId = StateURL + '/ReadByCountryId';
export const State_delete = StateURL + '/delete';
//endregion

//#region SubRoles API
export const SubRolesURL: string = AdvinMaster + '/SR';
export const SubRoles_create = SubRolesURL + '/Create';
export const SubRoles_update = SubRolesURL + '/Update';
export const SubRoles_readByUserId = SubRolesURL + '/ReadByUserId';
export const SubRoles_readBySoftwareId  = SubRolesURL + '/ReadBySoftwareId';
export const SubRoles_readById = SubRolesURL + '/ReadById';
export const SubRoles_updateIsDefault = SubRolesURL + '/UpdateIsDefault';
export const SubRoles_delete = SubRolesURL + '/Delete';
export const SubRoles_readByRoleId = SubRolesURL + '/ReadByRoleId';

//#endregion

//region UserLogin API
export const UserLoginURL: string = AdvinMaster + '/UL';
export const UserLogin_create = UserLoginURL + '/Create';
export const UserLogin_update = UserLoginURL + '/Update';
export const UserLogin_delete = UserLoginURL + '/Delete';
export const UserLogin_readByUserId = UserLoginURL + '/ReadByUserId';
export const UserLogin_validateUserName = UserLoginURL + '/ValidateUserName';
export const UserLogin_auth = UserLoginURL + '/auth';
export const UserLogin_AzureAuth = UserLoginURL + '/AzureAuth';
export const UserLogin_refresh = UserLoginURL + '/Refresh';
export const UserLogin_logout = UserLoginURL + '/Logout';
export const UserLogin_validateToken = UserLoginURL + '/ValidateToken';
//endregion

//region UserMaster API
export const UserMasterURL: string = AdvinMaster + '/UM';
export const UserMaster_create = UserMasterURL + '/Create';
export const UserMaster_update = UserMasterURL + '/Update';
export const UserMaster_updateStatus = UserMasterURL + '/UpdateStatus';
export const UserMaster_readById = UserMasterURL + '/ReadById';
export const UserMaster_readAll = UserMasterURL + '/ReadAll';
export const UserMaster_readAllPaginated = UserMasterURL + '/ReadAllPaginated';
export const UserMaster_delete = UserMasterURL + '/Delete';
export const UserMaster_GetDictionary = UserMasterURL + '/GetDictionary';
export const UserMaster_GetDictionaryByRoleId = UserMasterURL + '/GetDictionaryByRoleId';
export const UserMaster_SearchByName = UserMasterURL + '/SearchByName';
//endregion

//region UserPermission API
const UserPermissionURL: string = AdvinMaster + '/UP';
export const UserPermission_create = UserPermissionURL + '/Create';
export const UserPermission_update = UserPermissionURL + '/Update';
export const UserPermission_readAll = UserPermissionURL + '/ReadAll';
export const UserPermission_readByFeatureId = UserPermissionURL + '/ReadByFeatureId';
export const UserPermission_readById = UserPermissionURL + '/ReadById';
export const UserPermission_readBySoftwareId = UserPermissionURL + '/ReadBySoftwareId';
export const UserPermission_readByUserId = UserPermissionURL + '/ReadByUserId';
export const UserPermission_readBySubRoleId = UserPermissionURL + '/ReadBySubRoleId';
export const UserPermission_delete = UserPermissionURL + '/Delete';
//endregion

//region UserRoles API
export const UserRolesURL: string = AdvinMaster + '/UR';
export const UserRoles_create = UserRolesURL + '/Create';
export const UserRoles_update = UserRolesURL + '/Update';
export const UserRoles_delete = UserRolesURL + '/Delete';
export const UserRoles_readByUserId = UserRolesURL + '/ReadByUserId';
export const UserRoles_readBySoftwareId = UserRolesURL + '/ReadBySoftwareId';
export const UserRoles_readAll = UserRolesURL + '/ReadAll';
//endregion


//region ValueList API
export const ValueListURL: string = AdvinMaster + '/VL';
export const ValueList_create = ValueListURL + '/Create';
export const ValueList_update = ValueListURL + '/Update';
export const ValueList_readById = ValueListURL + '/ReadById';
export const ValueList_readAll = ValueListURL + '/ReadAll';
export const ValueList_delete = ValueListURL + '/Delete';
export const ValueList_ReadKeyValueDictionaryByCode = ValueListURL + '/ReadKeyValueDictionaryByCode';
export const ValueList_GetFilteredKeyValueDictionaryByCode = ValueListURL + '/ReadFilteredKeyValueDictionaryByCode';
export const ValueList_GetFilteredKeyValueExtendedByCode = ValueListURL + '/ReadFilteredKeyValueExtendedByCode';
//endregion

//region ValueListItem API
export const ValueListItemURL: string = AdvinMaster + '/VLI';
export const ValueListItem_create = ValueListItemURL + '/Create';
export const ValueListItem_update = ValueListItemURL + '/Update';
export const ValueListItem_delete = ValueListItemURL + '/Delete';
export const ValueListItem_readById = ValueListItemURL + '/ReadById';
export const ValueListItem_readByValueListId = ValueListItemURL + '/ReadByValueListId';
export const ValueListItem_readByVlCode = ValueListItemURL + '/ReadByVlCode';
export const ValueListItem_readByVlName = ValueListItemURL + '/ReadByVlName';
export const ValueListItem_readByVlCodeList = ValueListItemURL + '/ReadByVlCodeList';
export const ValueListItem_readByTenantId  = ValueListItemURL + '/ReadByTenantId';


//endregion

//region IndividualMaster API
export const IndividualMasterURL: string = AdvinMaster + '/IM';
export const IndividualMaster_create = IndividualMasterURL + '/Create';
export const IndividualMaster_update = IndividualMasterURL + '/Update';
export const IndividualMaster_delete = IndividualMasterURL + '/Delete';
export const IndividualMaster_readById = IndividualMasterURL + '/ReadById';
export const IndividualMaster_readAll = IndividualMasterURL + '/ReadAll';
export const IndividualMaster_readAllPaginated = IndividualMasterURL + '/ReadAllPaginated';
export const IndividualMaster_readByUserId = IndividualMasterURL + '/ReadByUserId';
export const IndividualMaster_searchByName = IndividualMasterURL + '/SearchByName';
//endregion

//#region CustomerSubscriptions API
export const CustomerSubscriptionsURL: string = AdvinMaster + '/CUSS';
export const CustomerSubscriptions_create = CustomerSubscriptionsURL + '/Create';
export const CustomerSubscriptions_update = CustomerSubscriptionsURL + '/Update';
export const CustomerSubscriptions_delete = CustomerSubscriptionsURL + '/Delete';
export const CustomerSubscriptions_readById = CustomerSubscriptionsURL + '/ReadById';
export const CustomerSubscriptions_readByTenantId  = CustomerSubscriptionsURL + '/ReadByTenantId';
export const CustomerSubscriptions_readByPlanId = CustomerSubscriptionsURL + '/ReadByPlanId';
export const CustomerSubscriptions_status = CustomerSubscriptionsURL + '/Status';
export const CustomerSubscriptions_paymentDue = CustomerSubscriptionsURL + '/PaymentDue';
//#endregion

//#region UserLicenses API
export const UserLicensesURL: string = AdvinMaster + '/ULic';
export const UserLicenses_assign = UserLicensesURL + '/Assign';
export const UserLicenses_release = UserLicensesURL + '/Release';
export const UserLicenses_delete = UserLicensesURL + '/Delete';
export const UserLicenses_readByTenantId = UserLicensesURL + '/ReadByTenantId';
export const UserLicenses_readByUserId = UserLicensesURL + '/ReadByUserId';
export const UserLicenses_summary = UserLicensesURL + '/Summary';
//#endregion

// region SubscriptionPlan API
export const SubscriptionPlanURL: string = AdvinMaster + '/SUBP';
export const SubscriptionPlan_create = SubscriptionPlanURL + '/Create';
export const SubscriptionPlan_update = SubscriptionPlanURL + '/Update';
export const SubscriptionPlan_delete = SubscriptionPlanURL + '/Delete';
export const SubscriptionPlan_readById = SubscriptionPlanURL + '/ReadById';
export const SubscriptionPlan_readAll = SubscriptionPlanURL + '/ReadAll';
export const SubscriptionPlan_readAllPaginated = SubscriptionPlanURL + '/ReadAllPaginated';
export const SubscriptionPlan_searchByName = SubscriptionPlanURL + '/SearchByName';
// endregion

// region SubscriptionDetails API
export const SubscriptionDetailsURL: string = AdvinMaster + '/SUB';
export const SubscriptionDetails_create = SubscriptionDetailsURL + '/Create';
export const SubscriptionDetails_update = SubscriptionDetailsURL + '/Update';
export const SubscriptionDetails_delete = SubscriptionDetailsURL + '/Delete';
export const SubscriptionDetails_readById = SubscriptionDetailsURL + '/ReadById';
export const SubscriptionDetails_readByMappingId = SubscriptionDetailsURL + '/ReadByMappingId';
export const SubscriptionDetails_readBySoftwareId = SubscriptionDetailsURL + '/ReadBySoftwareId';
export const SubscriptionDetails_readBySubscriptionId = SubscriptionDetailsURL + '/ReadBySubscriptionId';
export const SubscriptionDetails_readAll = SubscriptionDetailsURL + '/ReadAll';
// endregion


//region CompanyCategory API
export const CompanyCategoryURL: string = AdvinMaster + '/CCT';
export const CompanyCategory_create = CompanyCategoryURL + '/Create';
export const CompanyCategory_update = CompanyCategoryURL + '/Update';
export const CompanyCategory_delete = CompanyCategoryURL + '/Delete';
export const CompanyCategory_readById = CompanyCategoryURL + '/ReadById';
export const CompanyCategory_readAll = CompanyCategoryURL + '/ReadAll';
//endregion

//region CompanySubCategory API
export const CompanySubCategoryURL: string = AdvinMaster + '/CSC';
export const CompanySubCategory_create = CompanySubCategoryURL + '/Create';
export const CompanySubCategory_update = CompanySubCategoryURL + '/Update'
export const CompanySubCategory_delete = CompanySubCategoryURL + '/Delete'
export const CompanySubCategory_readById = CompanySubCategoryURL + '/ReadById';
export const CompanySubCategory_readByCategoryId = CompanySubCategoryURL + '/ReadByCategoryId'
export const CompanySubCategory_readAll = CompanySubCategoryURL + '/ReadAll';
//endregion


//region LeadMaster API
export const LeadMasterURL: string = CRM + '/LM'
export const LeadMaster_create = LeadMasterURL + '/Create';
export const LeadMaster_update = LeadMasterURL + '/Update';
export const LeadMaster_delete = LeadMasterURL + '/Delete';
export const LeadMaster_readById = LeadMasterURL + '/ReadById';
export const LeadMaster_readAll = LeadMasterURL + '/ReadAll';
export const LeadMaster_readForVisit = LeadMasterURL + '/ReadForVisit';
export const LeadMaster_readByUserId = LeadMasterURL + '/ReadByUserId';
export const LeadMaster_forceClose = LeadMasterURL + '/ForceClose';
export const LeadMaster_TakeOver = LeadMasterURL + '/TakeOver';
export const LeadMaster_worklist = LeadMasterURL + '/WorkList';
export const LeadMaster_dayBook = LeadMasterURL + '/DayBook';
export const LeadMaster_getAdminDashBoard = LeadMasterURL + '/GetAdminDashboard';
export const LeadMaster_updateFollowUp = LeadMasterURL + '/UpdateFollowUp';
export const LeadMaster_WorkListCountSummary = LeadMasterURL + '/WorkListCountSummary';
export const LeadMaster_ReadByLeadOwner = LeadMasterURL + '/ReadByLeadOwner';
export const LeadMaster_ReadByLeadOwnerCountSummary = LeadMasterURL + '/ReadByLeadOwnerCountSummary';
//endregion

//region LeadDetail API
export const LeadDetailURL: string = CRM + '/LD'
export const LeadDetail_create = LeadDetailURL + '/Create';
export const LeadDetail_update = LeadDetailURL + '/Update';
export const LeadDetail_delete = LeadDetailURL + '/Delete';
export const LeadDetail_readById = LeadDetailURL + '/ReadById';
export const LeadDetail_readAll = LeadDetailURL + '/ReadAll';
export const LeadDetail_readByLeadId = LeadDetailURL + '/ReadByLeadId';

//endregion


//region LeadAssignee API
export const LeadAssigneeURL: string = CRM + '/LAG'
export const LeadAssignee_create = LeadAssigneeURL + '/Create';
export const LeadAssignee_update = LeadAssigneeURL + '/Update';
export const LeadAssignee_delete = LeadAssigneeURL + '/Delete';
export const LeadAssignee_readById = LeadAssigneeURL + '/ReadById';
export const LeadAssignee_readAll = LeadAssigneeURL + '/ReadAll';
export const LeadAssignee_readByLeadId = LeadAssigneeURL + '/ReadByLeadId';
export const LeadAssignee_assignBulk = LeadAssigneeURL + '/AssignBulk';
//endregion

//region LeadActivity API
export const LeadActivityURL: string = CRM + '/LA'
export const LeadActivity_create = LeadActivityURL + '/Create';
export const LeadActivity_update = LeadActivityURL + '/Update';
export const LeadActivity_delete = LeadActivityURL + '/Delete';
export const LeadActivity_readById = LeadActivityURL + '/ReadById';
export const LeadActivity_readAll = LeadActivityURL + '/ReadAll';
export const LeadActivity_readByLeadId = LeadActivityURL + '/ReadByLeadId';
//endregion

//region TerritoryMaster API
export const TerritoryMasterURL: string = CRM + '/TM'
export const TerritoryMaster_create = TerritoryMasterURL + '/Create';
export const TerritoryMaster_update = TerritoryMasterURL + '/Update';
export const TerritoryMaster_delete = TerritoryMasterURL + '/Delete';
export const TerritoryMaster_readById = TerritoryMasterURL + '/ReadById';
export const TerritoryMaster_readAllPaginated = TerritoryMasterURL + '/ReadAllPaginated';
export const TerritoryMaster_getDictionary = TerritoryMasterURL + '/GetDictionary';
export const TerritoryMaster_readByLocation = TerritoryMasterURL + '/ReadByLocation';
//endregion

//region TerritoryArea API
export const TerritoryAreaURL: string = CRM + '/TA'
export const TerritoryArea_create = TerritoryAreaURL + '/Create';
export const TerritoryArea_update = TerritoryAreaURL + '/Update';
export const TerritoryArea_delete = TerritoryAreaURL + '/Delete';
export const TerritoryArea_readById = TerritoryAreaURL + '/ReadById';
export const TerritoryArea_readAllPaginated = TerritoryAreaURL + '/ReadAllPaginated';
export const TerritoryArea_getDictionary = TerritoryAreaURL + '/GetDictionary';
//endregion

//region TerritoryAreaMapping API
export const TerritoryAreaMappingURL: string = CRM + '/TAM'
export const TerritoryAreaMapping_create = TerritoryAreaMappingURL + '/Create';
export const TerritoryAreaMapping_delete = TerritoryAreaMappingURL + '/Delete';
export const TerritoryAreaMapping_readByTerritoryId = TerritoryAreaMappingURL + '/ReadByTerritoryId';
//endregion

//region TerritoryEmployeeMapping API
export const TerritoryEmployeeMappingURL: string = CRM + '/TEM'
export const TerritoryEmployeeMapping_create = TerritoryEmployeeMappingURL + '/Create';
export const TerritoryEmployeeMapping_delete = TerritoryEmployeeMappingURL + '/Delete';
export const TerritoryEmployeeMapping_readByTerritoryId = TerritoryEmployeeMappingURL + '/ReadByTerritoryId';
export const TerritoryEmployeeMapping_readByUserId = TerritoryEmployeeMappingURL + '/ReadByUserId';
export const TerritoryEmployeeMapping_readByTenantId = TerritoryEmployeeMappingURL + '/ReadByTenantId';
export const TerritoryEmployeeMapping_readEligibleUsersByAreaId = TerritoryEmployeeMappingURL + '/ReadEligibleUsersByAreaId';
//endregion

//region TerritoryVisit API
export const TerritoryVisitURL: string = CRM + '/TV'
export const TerritoryVisit_checkInCheckOut = TerritoryVisitURL + '/CheckInCheckOut';
export const TerritoryVisit_getActiveVisit = TerritoryVisitURL + '/GetActiveVisit';
export const TerritoryVisit_readByMasterId = TerritoryVisitURL + '/ReadByMasterId';
export const TerritoryVisit_readByUserId = TerritoryVisitURL + '/ReadByUserId';
export const TerritoryVisit_readAllPaginated = TerritoryVisitURL + '/ReadAllPaginated';
export const TerritoryVisit_schedule = TerritoryVisitURL + '/Schedule';
export const TerritoryVisit_update = TerritoryVisitURL + '/Update';
export const TerritoryVisit_updateStatus = TerritoryVisitURL + '/UpdateStatus';
export const TerritoryVisit_saveRemarks = TerritoryVisitURL + '/SaveRemarks';
export const TerritoryVisit_readMyCompleted = TerritoryVisitURL + '/ReadMyCompleted';
export const TerritoryVisit_adminSearch = TerritoryVisitURL + '/AdminSearch';
export const TerritoryVisit_adminSummary = TerritoryVisitURL + '/AdminSummary';
export const TerritoryVisit_delete = TerritoryVisitURL + '/Delete';
export const TerritoryVisit_readMySchedule = TerritoryVisitURL + '/ReadMySchedule';
//endregion

//#region SupportTicket API
export const SupportTicket: string = SupportDesk + '/ST';
export const SupportTicket_create = SupportTicket + "/Create"
export const SupportTicket_update = SupportTicket + '/Update';
export const SupportTicket_readById = SupportTicket + '/ReadById';
export const SupportTicket_readAll = SupportTicket + '/ReadAll';
export const SupportTicket_readByTicketOwner = SupportTicket + '/ReadByTicketOwner';
export const SupportTicket_delete = SupportTicket + '/Delete';
export const SupportTicket_forceClose = SupportTicket + '/ForceClose';
export const SupportTicket_reOpen = SupportTicket + '/ReOpen';
export const SupportTicket_takeOver = SupportTicket + '/TakeOver';
export const SupportTicket_ticketWorkList = SupportTicket + '/WorkList';
export const SupportTicket_GetAdminDashboard = SupportTicket + '/GetAdminDashboard';
export const SupportTicket_readByFromCompanyId = SupportTicket + '/ReadByFromCompanyId';
export const SupportTicket_readByGuid = SupportTicket + '/ReadByGuid';
//#endregion


//region TicketActivity API
export const TicketActivityURL: string = SupportDesk + '/TA'
export const TicketActivity_create = TicketActivityURL + '/Create';
export const TicketActivity_update = TicketActivityURL + '/Update';
export const TicketActivity_delete = TicketActivityURL + '/Delete';
export const TicketActivity_readById = TicketActivityURL + '/ReadById';
export const TicketActivity_readAll = TicketActivityURL + '/ReadAll';
export const TicketActivity_readByTicketId = TicketActivityURL + '/ReadByTicketId';
//endregion

//region TicketAssignee API
export const TicketAssigneeURL: string = SupportDesk + '/TAG'
export const TicketAssignee_create = TicketAssigneeURL + '/Create';
export const TicketAssignee_update = TicketAssigneeURL + '/Update';
export const TicketAssignee_delete = TicketAssigneeURL + '/Delete';
export const TicketAssignee_readById = TicketAssigneeURL + '/ReadById';
export const TicketAssignee_readAll = TicketAssigneeURL + '/ReadAll';
export const TicketAssignee_readByTicketId = TicketAssigneeURL + '/ReadByTicketId';
export const TicketAssignee_updateStatus = TicketAssigneeURL + '/UpdateStatus';
//endregion




//#region SupportProjectMaster API
export const SupportProjectMaster: string = SupportDesk + '/SPM';
export const SupportProjectMaster_create = SupportProjectMaster + "/Create";
export const SupportProjectMaster_update = SupportProjectMaster + '/Update';
export const SupportProjectMaster_readById = SupportProjectMaster + '/ReadById';
export const SupportProjectMaster_readAll = SupportProjectMaster + '/ReadAll';
export const SupportProjectMaster_delete = SupportProjectMaster + '/Delete';
export const SupportProjectMaster_readByTenantId = SupportProjectMaster + '/ReadByTenantId'
export const SupportProjectMaster_readAllPaginated = SupportProjectMaster + '/ReadAllPaginated'
//#endregion

//#region DiscussionMaster API (client<->salesperson chat thread)
export const DiscussionMaster: string = SupportDesk + '/DM';
export const DiscussionMaster_readOrCreate = DiscussionMaster + '/ReadOrCreate';
export const DiscussionMaster_readAllForSalesPerson = DiscussionMaster + '/ReadAllForSalesPerson';
//#endregion

//#region DiscussionDetail API (chat messages)
export const DiscussionDetail: string = SupportDesk + '/DD';
export const DiscussionDetail_create = DiscussionDetail + '/Create';
export const DiscussionDetail_readByDiscussionId = DiscussionDetail + '/ReadByDiscussionId';
export const DiscussionDetail_markAsRead = DiscussionDetail + '/MarkAsRead';
//#endregion

//#region UserBranchSoftwareMapping
export const UserBranchSoftwareMapping: string = AdvinMaster + '/UBSM'
export const UserBranchSoftwareMapping_create = UserBranchSoftwareMapping + '/Create';
export const UserBranchSoftwareMapping_update = UserBranchSoftwareMapping + '/Update';
export const UserBranchSoftwareMapping_readById = UserBranchSoftwareMapping + '/ReadById';
export const UserBranchSoftwareMapping_readByUserId = UserBranchSoftwareMapping + '/ReadByUserId';
export const UserBranchSoftwareMapping_readAll = UserBranchSoftwareMapping + '/ReadAll';
export const UserBranchSoftwareMapping_delete = UserBranchSoftwareMapping + '/Delete';
//#endregion


//#region DocumentMaster
export const DocumentMasterURL: string = AdvinMaster + '/DM'
export const DocumentMaster_Upload = DocumentMasterURL + '/Upload';
//#endregion

//#region HRMS Attendance
export const HRMS_Attendance: string = HRMS + '/AT'
export const HRMS_Attendance_create = HRMS_Attendance + '/Create';
export const HRMS_Attendance_update = HRMS_Attendance + '/Update';
export const HRMS_Attendance_readById = HRMS_Attendance + '/ReadById';
export const HRMS_Attendance_readAll = HRMS_Attendance + '/ReadAll';
export const HRMS_Attendance_delete = HRMS_Attendance + '/Delete';
export const HRMS_Attendance_readByUserMonth = HRMS_Attendance + '/ReadByUserMonth';
export const HRMS_Attendance_readByIndIdByDate = HRMS_Attendance + '/ReadByIndividualIdByDate';
export const HRMS_Attendance_CheckInCheckOut = HRMS_Attendance + '/CheckInCheckOut';
export const HRMS_Attendance_ReadAllPaginatedByDate = HRMS_Attendance + '/ReadAllPaginatedByDate';
export const HRMS_Attendance_GetMonthlyAttendanceMuster = HRMS_Attendance + '/GetMonthlyAttendanceMuster';
export const HRMS_Attendance_GetMonthlyAttendanceMusterPaginated = HRMS_Attendance + '/GetMonthlyAttendanceMusterPaginated';
export const HRMS_Attendance_GetMonthlyAttendance = HRMS_Attendance + '/GetMonthlyAttendance';
export const HRMS_Attendance_readByIndId = HRMS_Attendance + '/ReadByIndId';
export const HRMS_Attendance_ReadByIndividualId = HRMS_Attendance + '/ReadByIndividualId';
export const HRMS_Attendance_BulkUpsert = HRMS_Attendance + '/BulkUpsert';
export const HRMS_Attendance_GetMonthlyAttendanceByTenantId = HRMS_Attendance + '/GetMonthlyAttendanceByTenantId';
//#endregion

//#region OPCalendar
export const OPCalendar: string = AdvinMaster + '/OPC'
export const OPCalendar_create = OPCalendar + '/Create';
export const OPCalendar_update = OPCalendar + '/Update';
export const OPCalendar_readAll = OPCalendar + '/ReadAll';
export const OPCalendar_delete = OPCalendar + '/Delete';
export const OPCalendar_readByTenantId = OPCalendar + '/ReadByTenantId';
export const OPCalendar_getMonthlyCalendarByTenant = OPCalendar + '/GetMonthlyCalendarByTenant';
export const OPCalendar_getYearlyWeekendAndHolidayListByTenant = OPCalendar + '/GetYearlyWeekendAndHolidayListByTenant';
export const OPCalendar_GetUpcomingHolidays = OPCalendar + '/GetUpcomingHolidays';
export const OPCalendar_generateCalendar = OPCalendar + '/GenerateCalendar';
//#endregion

//#region HRMS Regularization
export const HRMS_Regularization: string = HRMS + '/RG'
export const HRMS_Regularization_create = HRMS_Regularization + '/Create';
export const HRMS_Regularization_update = HRMS_Regularization + '/Update';
export const HRMS_Regularization_readById = HRMS_Regularization + '/ReadById';
export const HRMS_Regularization_readAll = HRMS_Regularization + '/ReadAll';
export const HRMS_Regularization_delete = HRMS_Regularization + '/Delete';
export const HRMS_Regularization_readByIndId = HRMS_Regularization + '/ReadByIndId';
export const HRMS_Regularization_readByManagerId = HRMS_Regularization + '/ReadByManagerId'
export const HRMS_Regularization_readByManagerIdPaginated = HRMS_Regularization + '/ReadByManagerIdPaginated'
export const HRMS_Regularization_updateStatusByManager = HRMS_Regularization + '/UpdateStatusByManager'
export const HRMS_Regularization_GetRequestCountForManager = HRMS_Regularization + '/GetRequestCountForManager'
//#endregion

//region Company Login Location API

export const CompanyLoginLocationURL: string = AdvinMaster + '/CLL';

export const CompanyLoginLocation_Create = CompanyLoginLocationURL + '/Create';
export const CompanyLoginLocation_Update = CompanyLoginLocationURL + '/Update';
export const CompanyLoginLocation_Delete = CompanyLoginLocationURL + '/Delete';
export const CompanyLoginLocation_ReadById = CompanyLoginLocationURL + '/ReadById';
export const CompanyLoginLocation_ReadByTenantId  = CompanyLoginLocationURL + '/ReadByTenantId';

//endregion
//region Staff Login Location API

export const StaffLoginLocationURL: string = AdvinMaster + '/SLL';

export const StaffLoginLocation_Create = StaffLoginLocationURL + '/Create';
export const StaffLoginLocation_Update = StaffLoginLocationURL + '/Update';
export const StaffLoginLocation_Delete = StaffLoginLocationURL + '/Delete';
export const StaffLoginLocation_ReadById = StaffLoginLocationURL + '/ReadById';
export const StaffLoginLocation_ReadByTenantId = StaffLoginLocationURL + '/ReadByTenantId';
export const StaffLoginLocation_ReadByIndId = StaffLoginLocationURL + '/ReadByIndId';
export const StaffLoginLocation_ReadByLocationId = StaffLoginLocationURL + '/ReadByLocationId';

//endregion


//#region MeetingMaster API
export const MeetingMaster: string = CRM + '/MM'
export const MeetingMaster_create = MeetingMaster + '/Create'
export const MeetingMaster_update = MeetingMaster + '/Update'
export const MeetingMaster_delete = MeetingMaster + '/Delete'
export const MeetingMaster_readById = MeetingMaster + '/ReadById'
export const MeetingMaster_readAll = MeetingMaster + '/ReadAll'
export const MeetingMaster_readByLeadId = MeetingMaster + '/ReadByLeadId'
export const MeetingMaster_readByCompnayId = MeetingMaster + '/ReadByCompanyId'
//#endregion

//#region MeetingDetail API
export const MeetingDetail: String = CRM + '/MD'
export const MeetingDetail_create = MeetingDetail + '/Create'
export const MeetingDetail_update = MeetingDetail + '/Update'
export const MeetingDetail_delete = MeetingDetail + '/Delete'
export const MeetingDetail_readbyId = MeetingDetail + '/ReadById'
export const MeetingDetail_readall = MeetingDetail + '/ReadAll'
export const MeetingDetail_createBulk = MeetingDetail + '/CreateBulk'
export const MeetingDetail_readbyMeetingId = MeetingDetail + '/ReadByMeetingId'
//#endregion

//region IndividualRelationMaster API
export const IndividualRelationURL: string = AdvinMaster + '/IR';
export const IndividualRelation_create = IndividualRelationURL + '/Create';
export const IndividualRelation_update = IndividualRelationURL + '/Update';
export const IndividualRelation_delete = IndividualRelationURL + '/Delete';
export const IndividualRelation_readById = IndividualRelationURL + '/ReadById';
export const IndividualRelation_readByIndId = IndividualRelationURL + '/ReadByIndividualId';
export const IndividualRelation_readAll = IndividualRelationURL + '/ReadAll';
//endregion


//#region ERP APIs API






//#region ERP Products API
export const Products: string = ERP + '/Prod'






//#region ItemMaster API
export const ItemMaster: string = Products + '/IM'
export const ItemMaster_Create = ItemMaster + '/Create'
export const ItemMaster_CreateBulkViaExcel = ItemMaster + '/CreateBulkViaExcel'
export const ItemMaster_BulkUpsert = ItemMaster + '/UpsertBulk'
export const ItemMaster_Update = ItemMaster + '/Update'
export const ItemMaster_Delete = ItemMaster + '/Delete'
export const ItemMaster_ReadbyId = ItemMaster + '/ReadById'
export const ItemMaster_ReadAll = ItemMaster + '/ReadAll'
export const ItemMaster_ReadAllPaginated = ItemMaster + '/ReadAllPaginated'
export const ItemMaster_UpdateBulkColumn = ItemMaster + '/UpdateBulkColumn'
export const ItemMaster_SearchByName = ItemMaster + '/SearchByName'
//#endregion

//#region ItemImage API
export const ItemImages: string = Products + '/II'
export const ItemImages_Create = ItemImages + '/Create'
export const ItemImages_Update = ItemImages + '/Update'
export const ItemImages_Delete = ItemImages + '/Delete'
export const ItemImages_ReadById = ItemImages + '/ReadById'
export const ItemImages_ReadByMasterId = ItemImages + '/ReadByMasterId'
export const ItemImages_ReadAll = ItemImages + '/ReadAll'
export const ItemImages_ReadAllPaginated = ItemImages + '/ReadAllPaginated'
//#endregion

//#region ImageMaster API
export const ImageMaster: string = Products + '/IMG'
export const ImageMaster_Create = ImageMaster + '/Create'
export const ImageMaster_Update = ImageMaster + '/Update'
export const ImageMaster_Delete = ImageMaster + '/Delete'
export const ImageMaster_ReadById = ImageMaster + '/ReadById'
export const ImageMaster_ReadByMasterId = ImageMaster + '/ReadByMasterId'
export const ImageMaster_ReadAll = ImageMaster + '/ReadAll'
//#endregion

//#region ItemPrice API
export const ItemPrice: string = Products + '/IP'
export const ItemPrice_create = ItemPrice + '/Create'
export const ItemPrice_Update = ItemPrice + '/Update'
export const ItemPrice_delete = ItemPrice + '/Delete'
export const ItemPrice_readbyId = ItemPrice + '/ReadById'
export const ItemPrice_readAll = ItemPrice + '/ReadAll'
export const ItemPrice_ReadByItemId = ItemPrice + '/ReadByItemId'

//#endregion


//#region ItemMasterUIC API
const ItemMasterUIC: string = Products + '/IMUIC';

export const ItemMasterUIC_Create = ItemMasterUIC + '/Create';
export const ItemMasterUIC_Update = ItemMasterUIC + '/Update';
export const ItemMasterUIC_Delete = ItemMasterUIC + '/Delete';
export const ItemMasterUIC_ReadByBranchId = ItemMasterUIC + '/ReadByBranchId';
export const ItemMasterUIC_ReadById = ItemMasterUIC + '/ReadById';
export const ItemMasterUIC_ReadAll = ItemMasterUIC + '/ReadAll';
//#endregion


export const HRMS_AttendanceRule: string = HRMS + '/AR';
// HRMSRules
export const HRMS_AR_HR_Create = HRMS_AttendanceRule + '/HR/Create';
export const HRMS_AR_HR_ReadAll = HRMS_AttendanceRule + '/HR/ReadAll';
export const HRMS_AR_HR_ReadById = HRMS_AttendanceRule + '/HR/ReadById';
export const HRMS_AR_HR_Update = HRMS_AttendanceRule + '/HR/Update';
export const HRMS_AR_HR_Delete = HRMS_AttendanceRule + '/HR/Delete';
// TenantHRMSRules
export const HRMS_AR_THR_CreateGroup    = HRMS_AttendanceRule + '/THR/CreateGroup';
export const HRMS_AR_THR_Create         = HRMS_AttendanceRule + '/THR/Create';
export const HRMS_AR_THR_Update         = HRMS_AttendanceRule + '/THR/Update';
export const HRMS_AR_THR_Delete         = HRMS_AttendanceRule + '/THR/Delete';
export const HRMS_AR_THR_ReadById       = HRMS_AttendanceRule + '/THR/ReadById';
export const HRMS_AR_THR_ReadByTenantId = HRMS_AttendanceRule + '/THR/ReadByTenantId';
export const HRMS_AR_THR_ReadAll        = HRMS_AttendanceRule + '/THR/ReadAll';

//#region HRMS Loan Management
export const HRMS_LMM: string          = HRMS + '/LMM';
export const HRMS_LMM_LM: string       = HRMS_LMM + '/LM';   // LoanMaster prefix
export const HRMS_LMM_LR: string       = HRMS_LMM + '/LR';   // LoanRepayment prefix
// LoanMaster
export const HRMS_LM_LoanMaster_Apply                    = HRMS_LMM_LM + '/Apply';
export const HRMS_LM_LoanMaster_Create                   = HRMS_LMM_LM + '/Create';
export const HRMS_LM_LoanMaster_Approve                  = HRMS_LMM_LM + '/Approve';
export const HRMS_LM_LoanMaster_Reject                   = HRMS_LMM_LM + '/Reject';
export const HRMS_LM_LoanMaster_Delete                   = HRMS_LMM_LM + '/Delete';
export const HRMS_LM_LoanMaster_ReadById                 = HRMS_LMM_LM + '/ReadById';
export const HRMS_LM_LoanMaster_ReadByTenant             = HRMS_LMM_LM + '/ReadByTenant';
export const HRMS_LM_LoanMaster_ReadByIndId              = HRMS_LMM_LM + '/ReadByIndId';
export const HRMS_LM_LoanMaster_GetActiveEMIsByPayPeriod = HRMS_LMM_LM + '/GetActiveEMIsByPayPeriod';
// LoanRepayment
export const HRMS_LM_LoanRepayment_ReadByLoanId          = HRMS_LMM_LR + '/ReadByLoanId';
export const HRMS_LM_LoanRepayment_MarkPaid              = HRMS_LMM_LR + '/MarkPaid';
export const HRMS_LM_LoanRepayment_Delete                = HRMS_LMM_LR + '/Delete';
//#endregion

//#region HRMS Designation
export const HRMS_Designations: string = HRMS + '/DSG'
export const HRMS_Designations_create = HRMS_Designations + '/Create';
export const HRMS_Designations_update = HRMS_Designations + '/Update';
export const HRMS_Designations_delete = HRMS_Designations + '/Delete';
export const HRMS_Designations_readAll = HRMS_Designations + '/ReadAll';
export const HRMS_Designations_readById = HRMS_Designations + '/ReadById';
export const HRMS_Designations_readAllPaginated = HRMS_Designations + '/ReadAllPaginated';
export const HRMS_Designations_readByTenantId = HRMS_Designations + '/ReadByTenantId';
export const HRMS_Designations_GetDictionary = HRMS_Designations + '/GetDictionary';
//#endregion

//#region HRMS InterviewMaster
export const InterviewMaster: string = HRMS + '/IM';
export const InterviewMaster_create = InterviewMaster + '/Create';
export const InterviewMaster_update = InterviewMaster + '/Update';
export const InterviewMaster_delete = InterviewMaster + '/Delete';
export const InterviewMaster_readById = InterviewMaster + '/ReadById';
export const InterviewMaster_readByIndId = InterviewMaster + '/ReadByIndId';
export const InterviewMaster_readAll = InterviewMaster + '/ReadAll';
export const InterviewMaster_readAllPaginated = InterviewMaster + '/ReadAllPaginated';


//#region HRMS InterviewDetail
export const InterviewDetail: string = HRMS + '/ID';

export const InterviewDetail_create = InterviewDetail + '/Create';
export const InterviewDetail_update = InterviewDetail + '/Update';
export const InterviewDetail_delete = InterviewDetail + '/Delete';
export const InterviewDetail_readById = InterviewDetail + '/ReadById';
export const InterviewDetail_readByInterviewId = InterviewDetail + '/ReadByInterviewId';
export const InterviewDetail_readAll = InterviewDetail + '/ReadAll';
//#endregion


//region AlertServiceMaster API
export const AlertServiceMasterURL: string = Notification + '/ASM';
export const AlertServiceMaster_create = AlertServiceMasterURL + '/Create';
export const AlertServiceMaster_update = AlertServiceMasterURL + '/Update';
export const AlertServiceMaster_delete = AlertServiceMasterURL + '/Delete';
export const AlertServiceMaster_readById = AlertServiceMasterURL + '/ReadById';
export const AlertServiceMaster_readAll = AlertServiceMasterURL + '/ReadAll';
export const AlertServiceMaster_ReadAllPaginated = AlertServiceMasterURL + '/ReadAllPaginated';
export const AlertServiceMaster_UpdateStatus = AlertServiceMasterURL + '/UpdateStatus';
//endregion

//region EmailConfig API
export const EmailConfig: string = Notification + '/EC';
export const EmailConfig_create = EmailConfig + '/Create';
export const EmailConfig_update = EmailConfig + '/Update';
export const EmailConfig_delete = EmailConfig + '/Delete';
export const EmailConfig_readById = EmailConfig + '/ReadById';
export const EmailConfig_readAll = EmailConfig + '/ReadAll';
export const EmailConfig_ReadAllPaginated = EmailConfig + '/ReadAllPaginated';
export const EmailConfig_updatePassword = EmailConfig + '/UpdatePassword'
//endregion

//region WhatsAppConfig API
export const WhatsAppConfigURL: string = Notification + '/WAC';
export const WhatsAppConfig_create = WhatsAppConfigURL + '/Create';
export const WhatsAppConfig_update = WhatsAppConfigURL + '/Update';
export const WhatsAppConfig_delete = WhatsAppConfigURL + '/Delete';
export const WhatsAppConfig_readById = WhatsAppConfigURL + '/ReadById';
export const WhatsAppConfig_readAll = WhatsAppConfigURL + '/ReadAll';
export const WhatsAppConfig_readAllPaginated = WhatsAppConfigURL + '/ReadAllPaginated';
export const WhatsAppConfig_embeddedSignup = WhatsAppConfigURL + '/EmbeddedSignup';
//endregion

//region WhatsApp Inbox API (Notification/WhatsAppMessage)
export const WhatsAppMessageURL: string = Notification + '/WAM';
export const WhatsAppMessage_contactList = WhatsAppMessageURL + '/ContactList';
export const WhatsAppMessage_messageList = WhatsAppMessageURL + '/MessageList';
export const WhatsAppMessage_markRead = WhatsAppMessageURL + '/MarkRead';
export const WhatsAppMessage_send = WhatsAppMessageURL + '/Send';
export const WhatsAppMessage_media = WhatsAppMessageURL + '/Media';
//endregion

//region DBConfig API
export const DBConfigURL: string = Notification + '/DBCM';
export const DBConfig_create = DBConfigURL + '/Create';
export const DBConfig_update = DBConfigURL + '/Update';
export const DBConfig_delete = DBConfigURL + '/Delete';
export const DBConfig_readById = DBConfigURL + '/ReadById';
export const DBConfig_readAll = DBConfigURL + '/ReadAll';
export const DBConfig_readAllPaginated = DBConfigURL + '/ReadAllPaginated';
export const DBConfig_updatePassword = DBConfigURL + '/UpdatePassword';
//endregion

//region SmsConfig API
export const SmsConfig: string = Notification + '/SMS';
export const SmsConfig_create = SmsConfig + '/Create';
export const SmsConfig_update = SmsConfig + '/Update';
export const SmsConfig_delete = SmsConfig + '/Delete';
export const SmsConfig_readById = SmsConfig + '/ReadById';
export const SmsConfig_readAll = SmsConfig + '/ReadAll';
export const SmsConfig_readAllPaginated = SmsConfig + '/ReadAllPaginated';
export const SmsConfig_readByTenantId = SmsConfig + '/ReadByTenantId';
export const SmsConfig_readByRequest = SmsConfig + '/ReadByRequest';
//endregion


//region AlertsSchedular API
export const AlertsSchedularURL: string = Notification + '/AS';
export const AlertsSchedular_create = AlertsSchedularURL + '/Create';
export const AlertsSchedular_update = AlertsSchedularURL + '/Update';
export const AlertsSchedular_delete = AlertsSchedularURL + '/Delete';
export const AlertsSchedular_readById = AlertsSchedularURL + '/ReadById';
export const AlertsSchedular_readAll = AlertsSchedularURL + '/ReadAll';
export const AlertsSchedular_readAllPaginated = AlertsSchedularURL + '/ReadAllPaginated';
//endregion

//region AlertServiceMaster API
export const AlertsServiceVariablesURL: string = Notification + '/ASV';
export const AlertsServiceVariables_create = AlertsServiceVariablesURL + '/Create';
export const AlertsServiceVariables_update = AlertsServiceVariablesURL + '/Update';
export const AlertsServiceVariables_delete = AlertsServiceVariablesURL + '/Delete';
export const AlertsServiceVariables_readById = AlertsServiceVariablesURL + '/ReadById';
export const AlertsServiceVariables_readAll = AlertsServiceVariablesURL + '/ReadAll';
export const AlertsServiceVariables_ReadAllByServiceId = AlertsServiceVariablesURL + '/ReadAllByServiceId'
//endregion

//region AlertServiceMaster API
export const AlertsServiceSchedularURL: string = Notification + '/ASS';
export const AlertsServiceSchedular_create = AlertsServiceSchedularURL + '/Create';
export const AlertsServiceSchedular_update = AlertsServiceSchedularURL + '/Update';
export const AlertsServiceSchedular_delete = AlertsServiceSchedularURL + '/Delete';
export const AlertsServiceSchedular_readById = AlertsServiceSchedularURL + '/ReadById';
export const AlertsServiceSchedular_readAll = AlertsServiceSchedularURL + '/ReadAll';
export const AlertsServiceSchedular_readByServiceId = AlertsServiceSchedularURL + '/ReadByServiceId'
//endregion

//region NotificationMaster API
export const NotificationMasterURL: string = Notification + '/NM';
export const notificationMaster_readAllPaginated = NotificationMasterURL + '/ReadAllPaginated';
export const notificationMaster_Create = NotificationMasterURL + '/Create';
export const notificationMaster_UpdateStatusById = NotificationMasterURL + '/UpdateStatusById';
export const notificationMaster_getBellNotificationsByUserId = NotificationMasterURL + '/GetBellNotificationsByUserId';
export const notificationMaster_markAsRead = NotificationMasterURL + '/MarkAsRead';
//endregion

//region PushNotificationConfig API
export const PushNotificationConfigURL: string = Notification + '/PNC';
export const pushNotificationConfig_healthCheck = PushNotificationConfigURL + '/healthCheck';
export const pushNotificationConfig_Register = PushNotificationConfigURL + '/Register';
export const pushNotificationConfig_Unregister = PushNotificationConfigURL + '/Unregister';
export const pushNotificationConfig_ReadById = PushNotificationConfigURL + '/ReadById';
export const pushNotificationConfig_SendMessage = PushNotificationConfigURL + '/SendMessage';
//endregion


//region Customer List API

export const CustomerListUIC: string = Master + '/CLUIC';

export const CustomerListUIC_Create = CustomerListUIC + '/Create';
export const CustomerListUIC_Update = CustomerListUIC + '/Update';
export const CustomerListUIC_Delete = CustomerListUIC + '/Delete';
export const CustomerListUIC_ReadByCompanyId = CustomerListUIC + '/ReadByCompanyId';
export const CustomerListUIC_ReadById = CustomerListUIC + '/ReadById';
export const CustomerListUIC_ReadAll = CustomerListUIC + '/ReadAll';


export const CustomerData_ReadAll = CustomerListUIC + 'DataReadAll'
export const CustomerData_ReadAllPaginated = CustomerListUIC + '/ReadAllPaginated'
//endregion



//region Customer Form API
export const CustomerFormUIC: string = Master + '/CUIC';

export const CustomerFormUIC_Create = CustomerFormUIC + '/Create';
export const CustomerFormUIC_Update = CustomerFormUIC + '/Update';
export const CustomerFormUIC_Delete = CustomerFormUIC + '/Delete';
export const CustomerFormUIC_ReadByCompanyId = CustomerFormUIC + '/ReadByCompanyId';
export const CustomerFormUIC_ReadById = CustomerFormUIC + '/ReadById';
export const CustomerFormUIC_ReadAll = CustomerFormUIC + '/ReadAll';
//endregion

//region Supplier List API
export const SupplierListUIC: string = Master + '/SLUIC';

export const SupplierListUIC_Create = SupplierListUIC + '/Create';
export const SupplierListUIC_Update = SupplierListUIC + '/Update';
export const SupplierListUIC_Delete = SupplierListUIC + '/Delete';
export const SupplierListUIC_ReadByCompanyId = SupplierListUIC + '/ReadByCompanyId';
export const SupplierListUIC_ReadById = SupplierListUIC + '/ReadById';
export const SupplierListUIC_ReadAll = SupplierListUIC + '/ReadAll';


export const SupplierData_ReadAll = SupplierListUIC + 'DataReadAll'
export const SupplierData_ReadAllPaginated = SupplierListUIC + '/ReadAllPaginated'
//endregion


//region Support Form API
export const SupplierFormUIC: string = Master + '/SUIC';

export const SupplierFormUIC_Create = SupplierFormUIC + '/Create';
export const SupplierFormUIC_Update = SupplierFormUIC + '/Update';
export const SupplierFormUIC_Delete = SupplierFormUIC + '/Delete';
export const SupplierFormUIC_ReadByCompanyId = SupplierFormUIC + '/ReadByCompanyId';
export const SupplierFormUIC_ReadById = SupplierFormUIC + '/ReadById';
export const SupplierFormUIC_ReadAll = SupplierFormUIC + '/ReadAll';
//endregion

//region Vendor List API
export const VendorListUIC: string = Master + '/VLUIC';
export const VendorListUIC_Create = VendorListUIC + '/Create';
export const VendorListUIC_Update = VendorListUIC + '/Update';
export const VendorListUIC_Delete = VendorListUIC + '/Delete';
export const VendorListUIC_ReadByCompanyId = VendorListUIC + '/ReadByCompanyId';
export const VendorListUIC_ReadById = VendorListUIC + '/ReadById';
export const VendorListUIC_ReadAll = VendorListUIC + '/ReadAll';


export const VendorData_ReadAll = VendorListUIC + 'DataReadAll'
export const VendorData_ReadAllPaginated = VendorListUIC + '/ReadAllPaginated'
//endregion


//region Vendor Form API
export const VendorFormUIC: string = Master + '/VUIC';

export const VendorFormUIC_Create = VendorFormUIC + '/Create';
export const VendorFormUIC_Update = VendorFormUIC + '/Update';
export const VendorFormUIC_Delete = VendorFormUIC + '/Delete';
export const VendorFormUIC_ReadByCompanyId = VendorFormUIC + '/ReadByCompanyId';
export const VendorFormUIC_ReadById = VendorFormUIC + '/ReadById';
export const VendorFormUIC_ReadAll = VendorFormUIC + '/ReadAll';
//endregion


//region Generic List API
export const GenericListUIC: string = AdvinMaster + '/GLUIC';
export const GenericListUIC_Create = GenericListUIC + '/Create';
export const GenericListUIC_Update = GenericListUIC + '/Update';
export const GenericListUIC_Delete = GenericListUIC + '/Delete';
export const GenericListUIC_ReadByTenantId = GenericListUIC + '/ReadByTenantId';
export const GenericListUIC_ReadById = GenericListUIC + '/ReadById';
export const GenericListUIC_ReadAll = GenericListUIC + '/ReadAll';
export const GenericListUIC_ReadAllPaginated = GenericListUIC + '/ReadAllPaginated'
export const GenericListUIC_ReorderDisplaySeq = GenericListUIC + '/ReorderDisplaySeq'
export const GenericListData_ReadAllPaginated = GenericListUIC + '/ReadDataPaginated'
export const GenericListData_ReadDataById = GenericListUIC + '/ReadDataById'
export const GenericListUIC_Clone = GenericListUIC + '/Clone'
export const GenericListUIC_ReadConfigByTenantId = GenericListUIC + '/ReadConfigByTenantId'
export const GenericListUIC_CommonClone = GenericListUIC + '/CommonClone'
//endregion

//region DocConfig API
export const DocConfig: string = AdvinMaster + '/DocConfig';
export const DocConfig_Master_Create                      = DocConfig + '/Master/Create';
export const DocConfig_Master_Update                      = DocConfig + '/Master/Update';
export const DocConfig_Master_Delete                      = DocConfig + '/Master/Delete';
export const DocConfig_Master_ReadByTenantId              = DocConfig + '/Master/ReadByTenantId';
export const DocConfig_Master_ReadById                    = DocConfig + '/Master/ReadById';
export const DocConfig_Detail_Create                      = DocConfig + '/Detail/Create';
export const DocConfig_Detail_Update                      = DocConfig + '/Detail/Update';
export const DocConfig_Detail_Delete                      = DocConfig + '/Detail/Delete';
export const DocConfig_Detail_ReadByDocConfigId           = DocConfig + '/Detail/ReadByDocConfigId';
export const DocConfig_Detail_ReadByTenantIdAndMasterType = DocConfig + '/Detail/ReadByTenantIdAndMasterType';
//endregion

//region Generic List API
export const GenericFormUIC: string = AdvinMaster + '/GFUIC';
export const GenericFormUIC_Create = GenericFormUIC + '/Create';
export const GenericFormUIC_Update = GenericFormUIC + '/Update';
export const GenericFormUIC_Delete = GenericFormUIC + '/Delete';
export const GenericFormUIC_ReadByTenantId = GenericFormUIC + '/ReadByTenantId';
export const GenericFormUIC_ReadById = GenericFormUIC + '/ReadById';
export const GenericFormUIC_ReadAll = GenericFormUIC + '/ReadAll';
export const GenericFormUIC_Clone = GenericFormUIC + '/Clone';
export const GenericFormUIC_ReadConfigByTenantId = GenericFormUIC + '/ReadConfigByTenantId';

//endregion

export const EmailMarketingDetail: string = CRM + '/EMD';
export const EmailMarketingDetail_Create = EmailMarketingDetail + '/Create';
export const EmailMarketingDetail_Update = EmailMarketingDetail + '/Update';
export const EmailMarketingDetail_Delete = EmailMarketingDetail + '/Delete';
export const EmailMarketingDetail_DeleteAll = EmailMarketingDetail + '/DeleteAll';
export const EmailMarketingDetail_ReadByCompanyId = EmailMarketingDetail + '/ReadByCompanyId';
export const EmailMarketingDetail_ReadById = EmailMarketingDetail + '/ReadById';
export const EmailMarketingDetail_ReadAll = EmailMarketingDetail + '/ReadAll'
export const EmailMarketingDetail_UploadBulkCheck = EmailMarketingDetail + '/UploadBulkCheck'
export const EmailMarketingDetail_UploadBulkExecute = EmailMarketingDetail + '/UploadBulkExecute'
export const EmailMarketingDetail_ReadByEmailGroup = EmailMarketingDetail + '/ReadByEmailGroup'
export const EmailMarketingDetail_GetEmailGroups = EmailMarketingDetail + '/GetEmailGroups'

//endregion

//#region HRMS Departments
export const HRMS_Departments: string = HRMS + '/DPT'
export const HRMS_Departments_create = HRMS_Departments + '/Create';
export const HRMS_Departments_update = HRMS_Departments + '/Update';
export const HRMS_Departments_delete = HRMS_Departments + '/Delete';
export const HRMS_Departments_readAll = HRMS_Departments + '/ReadAll';
export const HRMS_Departments_readById = HRMS_Departments + '/ReadById';
export const HRMS_Departments_readByTenantId = HRMS_Departments + '/ReadByTenantId';
export const HRMS_Departments_GetDictionary = HRMS_Departments + '/GetDictionary';
export const HRMS_Departments_readAllPaginated = HRMS_Departments + '/ReadAllPaginated';
export const HRMS_Departments_SearchByDName = HRMS_Departments + '/SearchByDName';
//#endregion

//#region HRMS BiometricDevice
export const HRMS_BiometricDeviceURL: string = HRMS + '/BMD';
export const HRMS_BiometricDevice_create = HRMS_BiometricDeviceURL + '/Create';
export const HRMS_BiometricDevice_update = HRMS_BiometricDeviceURL + '/Update';
export const HRMS_BiometricDevice_delete = HRMS_BiometricDeviceURL + '/Delete';
export const HRMS_BiometricDevice_readByDeviceId = HRMS_BiometricDeviceURL + '/ReadByDeviceId';
export const HRMS_BiometricDevice_readAll = HRMS_BiometricDeviceURL + '/ReadAll';
export const HRMS_BiometricDevice_readByTenantId = HRMS_BiometricDeviceURL + '/ReadByTenantId';
export const HRMS_BiometricDevice_updateOnlineStatus = HRMS_BiometricDeviceURL + '/UpdateOnlineStatus';
export const HRMS_BiometricDevice_testConnection = HRMS_BiometricDeviceURL + '/TestConnection';
export const HRMS_BiometricDevice_mapping_getByDevice  = HRMS_BiometricDeviceURL + '/EmployeeMapping/GetByDevice';
export const HRMS_BiometricDevice_mapping_upsert       = HRMS_BiometricDeviceURL + '/EmployeeMapping/Upsert';
export const HRMS_BiometricDevice_mapping_delete       = HRMS_BiometricDeviceURL + '/EmployeeMapping/Delete';
export const HRMS_BiometricDevice_mapping_getUnmappedUsers = HRMS_BiometricDeviceURL + '/EmployeeMapping/GetUnmappedUsers';
export const HRMS_BiometricDevice_mapping_getRecentPunch   = HRMS_BiometricDeviceURL + '/EmployeeMapping/GetRecentPunch';
export const HRMS_BiometricDevice_mapping_getUnmappedStaff = HRMS_BiometricDeviceURL + '/EmployeeMapping/GetUnmappedStaff';
export const HRMS_BiometricDevice_mapping_getByEmployee    = HRMS_BiometricDeviceURL + '/EmployeeMapping/GetByEmployee';
export const HRMS_BiometricDevice_mapping_assignPin        = HRMS_BiometricDeviceURL + '/EmployeeMapping/AssignPin';
export const HRMS_BiometricDevice_commandQueue_create      = HRMS_BiometricDeviceURL + '/CommandQueue/Create';
export const HRMS_BiometricDevice_enrollFingerprint        = HRMS_BiometricDeviceURL + '/EnrollFingerprint';
//#endregion

//region IndividualHierarchy API
export const IndHierarchyURL: string = HRMS + '/IH';
export const IndHierarchy_create = IndHierarchyURL + '/Create';
export const IndHierarchy_update = IndHierarchyURL + '/Update';
export const IndHierarchy_delete = IndHierarchyURL + '/Delete';
export const IndHierarchy_readById = IndHierarchyURL + '/ReadById';
export const IndHierarchy_readAll = IndHierarchyURL + '/ReadAll';
export const IndHierarchy_readByIndId = IndHierarchyURL + '/ReadByIndId';
export const IndHierarchy_readByUserId = IndHierarchyURL + '/ReadByUserId';
export const IndHierarchy_GetManagerDictionary = IndHierarchyURL + '/GetManagerDictionary';
//endregion

//region Accounts API
export const Accounts: string = ERP + '/ACCT/ACC';
export const Accounts_Create = Accounts + '/Create';
export const Accounts_Update = Accounts + '/Update';
export const Accounts_Delete = Accounts + '/Delete';
export const Accounts_ReadById = Accounts + '/ReadById';
export const Accounts_ReadAll = Accounts + '/ReadAll'
//endregion


//region AmcMaster API
export const AmcMasterURL: string = Billing + '/AM';
export const AmcMaster_Create = AmcMasterURL + '/Create';
export const AmcMaster_Update = AmcMasterURL + '/Update';
export const AmcMaster_Delete = AmcMasterURL + '/Delete';
export const AmcMaster_ReadById = AmcMasterURL + '/ReadById';
export const AmcMaster_ReadByCompanyId = AmcMasterURL + '/ReadByCompanyId';
export const AmcMaster_ReadByClienId = AmcMasterURL + '/ReadByClientId';
export const AmcMaster_ReadAll = AmcMasterURL + '/ReadAll';
//endregion

//region AmcDetail API
export const AmcDetailURL: string = Billing + '/AD';
export const AmcDetail_Create = AmcDetailURL + '/Create';
export const AmcDetail_Update = AmcDetailURL + '/Update';
export const AmcDetail_Delete = AmcDetailURL + '/Delete';
export const AmcDetail_ReadById = AmcDetailURL + '/ReadById';
export const AmcDetail_ReadAll = AmcDetailURL + '/ReadAll';
export const AmcDetail_ReadByAmcId = AmcDetailURL + '/ReadByAmcId';
export const AmcDetail_ReadByItemId = AmcDetailURL + '/ReadByItemId';
//endregion

//region Vouchers API
export const Vouchers: string = ERP + '/ACCT/VOC';
export const Vouchers_Create = Vouchers + '/Create';
export const Vouchers_Update = Vouchers + '/Update';
export const Vouchers_Delete = Vouchers + '/Delete';
export const Vouchers_ReadById = Vouchers + '/ReadById';
export const Vouchers_ReadAll = Vouchers + '/ReadAll'
//endregion


//region Bank Detail APIs
export const BankDetail: string = AdvinMaster + '/BD';
export const BankDetail_Create = BankDetail + '/Create';
export const BankDetail_Update = BankDetail + '/Update';
export const BankDetail_Delete = BankDetail + '/Delete';
export const BankDetail_ReadById = BankDetail + '/ReadById';
export const BankDetail_ReadAll = BankDetail + '/ReadAll'
export const BankDetail_GetBankName = BankDetail + '/GetBankName'
export const BankDetail_GetBranchName = BankDetail + '/GetBranchName'
export const BankDetail_ReadByMasterId = BankDetail + '/ReadByMasterId';
//endregion

//region QuotationMaster API
export const QuotationMasterURL: string = CRM + '/QM'
export const QuotationMaster_create = QuotationMasterURL + '/Create';
export const QuotationMaster_update = QuotationMasterURL + '/Update';
export const QuotationMaster_delete = QuotationMasterURL + '/Delete';
export const QuotationMaster_readAll = QuotationMasterURL + '/ReadAll';
export const QuotationMaster_readById = QuotationMasterURL + '/ReadById';
export const QuotationMaster_readByCompanyId = QuotationMasterURL + '/ReadByCompanyId';
export const QuotationMaster_CloneAndCreate = QuotationMasterURL + '/CloneAndCreate';
export const QuotationMaster_SearchByQuotationNumber = QuotationMasterURL + '/SearchByQuotationNumber';
export const QuotationMaster_GetMaxVersionNo = QuotationMasterURL + '/GetMaxVersionNo';
export const QuotationMaster_updateStatus = QuotationMasterURL + '/UpdateStatus';
export const QuotationMaster_createIndentFromQuotation = QuotationMasterURL + '/CreateIndentFromQuotation';
//endregion


//region QuotationMasterOtherDetails API
export const QuotationOtherChargesMasterURL: string = CRM + '/QOC'
export const QuotationOtherDetail_create = QuotationOtherChargesMasterURL + '/Create';
export const QuotationOtherDetail_update = QuotationOtherChargesMasterURL + '/Update';
export const QuotationOtherDetail_delete = QuotationOtherChargesMasterURL + '/Delete';
export const QuotationOtherDetail_readById = QuotationOtherChargesMasterURL + '/ReadById';
export const QuotationOtherDetail_readByQuotationId = QuotationOtherChargesMasterURL + '/ReadByQuotationId';
export const QuotationOtherDetail_readAll = QuotationOtherChargesMasterURL + '/ReadAll';
//endregion


//region HRMS LeaveTypes APIs
export const HRMS_LeaveTypes: string = HRMS + '/LT';
export const HRMS_LeaveTypes_Create: string = HRMS_LeaveTypes + '/Create';
export const HRMS_LeaveTypes_Update: string = HRMS_LeaveTypes + '/Update';
export const HRMS_LeaveTypes_Delete: string = HRMS_LeaveTypes + '/Delete';
export const HRMS_LeaveTypes_ReadAll: string = HRMS_LeaveTypes + '/ReadAll';
export const HRMS_LeaveTypes_ReadById: string = HRMS_LeaveTypes + '/ReadByID';
export const HRMS_LeaveTypes_ReadByTenantId: string = HRMS_LeaveTypes + '/ReadByTenantId';
//endregion

//region HRMS PolicyMaster (Policy Setup) APIs
export const HRMS_PolicyMaster: string = HRMS + '/PM';
export const HRMS_PolicyMaster_Create: string = HRMS_PolicyMaster + '/Create';
export const HRMS_PolicyMaster_Update: string = HRMS_PolicyMaster + '/Update';
export const HRMS_PolicyMaster_Delete: string = HRMS_PolicyMaster + '/Delete';
export const HRMS_PolicyMaster_ReadById: string = HRMS_PolicyMaster + '/ReadById';
export const HRMS_PolicyMaster_ReadByTenantId: string = HRMS_PolicyMaster + '/ReadByTenantId';
export const HRMS_PolicyMaster_SeedFromCatalog: string = HRMS_PolicyMaster + '/SeedFromCatalog';
//endregion

//region HRMS PolicyDetail APIs
export const HRMS_PolicyDetail: string = HRMS + '/PD';
export const HRMS_PolicyDetail_Create: string = HRMS_PolicyDetail + '/Create';
export const HRMS_PolicyDetail_Update: string = HRMS_PolicyDetail + '/Update';
export const HRMS_PolicyDetail_Delete: string = HRMS_PolicyDetail + '/Delete';
export const HRMS_PolicyDetail_ReadById: string = HRMS_PolicyDetail + '/ReadById';
export const HRMS_PolicyDetail_ReadByTenantId: string = HRMS_PolicyDetail + '/ReadByTenantId';
export const HRMS_PolicyDetail_ReadByPolicyId: string = HRMS_PolicyDetail + '/ReadByPolicyId';
//endregion

//region HRMS PolicyRuleTypeMaster (predefined rule-type catalog) APIs
export const HRMS_PolicyRuleTypeMaster: string = HRMS + '/PRTM';
export const HRMS_PolicyRuleTypeMaster_Create: string = HRMS_PolicyRuleTypeMaster + '/Create';
export const HRMS_PolicyRuleTypeMaster_Update: string = HRMS_PolicyRuleTypeMaster + '/Update';
export const HRMS_PolicyRuleTypeMaster_Delete: string = HRMS_PolicyRuleTypeMaster + '/Delete';
export const HRMS_PolicyRuleTypeMaster_ReadById: string = HRMS_PolicyRuleTypeMaster + '/ReadById';
export const HRMS_PolicyRuleTypeMaster_ReadAll: string = HRMS_PolicyRuleTypeMaster + '/ReadAll';
//endregion

//region HRMS EmployeePolicyMapping APIs
export const HRMS_EmployeePolicyMapping: string = HRMS + '/EPM';
export const HRMS_EmployeePolicyMapping_Create: string = HRMS_EmployeePolicyMapping + '/Create';
export const HRMS_EmployeePolicyMapping_Update: string = HRMS_EmployeePolicyMapping + '/Update';
export const HRMS_EmployeePolicyMapping_Delete: string = HRMS_EmployeePolicyMapping + '/Delete';
export const HRMS_EmployeePolicyMapping_ReadById: string = HRMS_EmployeePolicyMapping + '/ReadById';
export const HRMS_EmployeePolicyMapping_ReadByTenantId: string = HRMS_EmployeePolicyMapping + '/ReadByTenantId';
export const HRMS_EmployeePolicyMapping_ReadByIndId: string = HRMS_EmployeePolicyMapping + '/ReadByIndId';
export const HRMS_EmployeePolicyMapping_BulkCreate: string = HRMS_EmployeePolicyMapping + '/BulkCreate';
export const HRMS_EmployeePolicyMapping_ApplyPolicyChange: string = HRMS_EmployeePolicyMapping + '/ApplyPolicyChange';
export const HRMS_EmployeePolicyMapping_ReadByPolicyId: string = HRMS_EmployeePolicyMapping + '/ReadByPolicyId';
export const HRMS_EmployeePolicyMapping_ReadUnassignedStaff: string = HRMS_EmployeePolicyMapping + '/ReadUnassignedStaff';
//endregion

//region HRMS EmployeePolicyDetail APIs
export const HRMS_EmployeePolicyDetail: string = HRMS + '/EPD';
export const HRMS_EmployeePolicyDetail_Create: string = HRMS_EmployeePolicyDetail + '/Create';
export const HRMS_EmployeePolicyDetail_Update: string = HRMS_EmployeePolicyDetail + '/Update';
export const HRMS_EmployeePolicyDetail_Delete: string = HRMS_EmployeePolicyDetail + '/Delete';
export const HRMS_EmployeePolicyDetail_ReadById: string = HRMS_EmployeePolicyDetail + '/ReadById';
export const HRMS_EmployeePolicyDetail_ReadByTenantId: string = HRMS_EmployeePolicyDetail + '/ReadByTenantId';
export const HRMS_EmployeePolicyDetail_ReadByEmployeePolicyMappingId: string = HRMS_EmployeePolicyDetail + '/ReadByEmployeePolicyMappingId';
//endregion

//region HRMS GlobalPolicyRules (Global Rule Catalog) APIs
export const HRMS_GlobalPolicyRules: string = HRMS + '/GPR';
export const HRMS_GlobalPolicyRules_Create: string = HRMS_GlobalPolicyRules + '/Create';
export const HRMS_GlobalPolicyRules_Update: string = HRMS_GlobalPolicyRules + '/Update';
export const HRMS_GlobalPolicyRules_Delete: string = HRMS_GlobalPolicyRules + '/Delete';
export const HRMS_GlobalPolicyRules_ReadById: string = HRMS_GlobalPolicyRules + '/ReadById';
export const HRMS_GlobalPolicyRules_ReadByTenantId: string = HRMS_GlobalPolicyRules + '/ReadByTenantId';
export const HRMS_GlobalPolicyRules_ReadByCategory: string = HRMS_GlobalPolicyRules + '/ReadByCategory';
//endregion

//region HRMS LeaveApplications APIs
export const HRMS_LeaveApplications: string = HRMS + '/LA';
export const HRMS_LeaveApplications_Create: string = HRMS_LeaveApplications + '/Create';
export const HRMS_LeaveApplications_Update: string = HRMS_LeaveApplications + '/Update';
export const HRMS_LeaveApplications_Delete: string = HRMS_LeaveApplications + '/Delete';
export const HRMS_LeaveApplications_ReadById: string = HRMS_LeaveApplications + '/ReadById';
export const HRMS_LeaveApplications_ReadAll: string = HRMS_LeaveApplications + '/ReadAll'
export const HRMS_LeaveApplications_ReadByIndId: string = HRMS_LeaveApplications + '/ReadByIndId';
export const HRMS_LeaveApplications_ReadBalanceByIndId: string = HRMS_LeaveApplications + '/ReadBalanceByIndId';
//end region

//region HRMS LeaveLedger APIs
export const HRMS_LeaveLedger: string = HRMS + '/LL';
export const HRMS_LeaveLedger_Create: string = HRMS_LeaveLedger + '/Create';
export const HRMS_LeaveLedger_Update: string = HRMS_LeaveLedger + '/Update';
export const HRMS_LeaveLedger_Delete: string = HRMS_LeaveLedger + '/Delete';
export const HRMS_LeaveLedger_ReadById: string = HRMS_LeaveLedger + '/ReadById';
export const HRMS_LeaveLedger_ReadAll: string = HRMS_LeaveLedger + '/ReadAll'
export const HRMS_LeaveLedger_ReadByIndId: string = HRMS_LeaveLedger + '/ReadByIndId';
export const HRMS_LeaveLedger_ReadByLeaveTypeId: string = HRMS_LeaveLedger + '/ReadByLeaveTypeId';
export const HRMS_LeaveLedger_BulkUpsert: string = HRMS_LeaveLedger + '/UpsertBulk';
export const HRMS_LeaveLedger_ReadByTenantId: string = HRMS_LeaveLedger + '/ReadByTenantId';
export const HRMS_LeaveLedger_ReadYearlyUtilization: string = HRMS_LeaveLedger + '/ReadYearlyUtilization';
//endregion

export const HRMS_LeaveApplications_ReadByManagerId: string = HRMS_LeaveApplications + '/ReadByManagerId';

//#region HRMS Face Recognition
export const HRMS_Face: string = HRMS + '/FR';
export const HRMS_Face_GetCheckInRequirements      = HRMS_Face + '/GetCheckInRequirements';
export const HRMS_Face_Enroll                      = HRMS_Face + '/Enroll';
export const HRMS_Face_RecognizeAndCheckIn         = HRMS_Face + '/RecognizeAndCheckIn';
export const HRMS_Face_StaffFaceRecog_Upsert       = HRMS_Face + '/StaffFaceRecog/Upsert';
export const HRMS_Face_StaffFaceRecog_ReadByIndId  = HRMS_Face + '/StaffFaceRecog/ReadByIndId';
export const HRMS_Face_DeleteProfile               = HRMS_Face + '/DeleteProfile';
export const HRMS_Face_Admin_FaceSetupMode_Upsert  = HRMS_Face + '/Admin/FaceSetupMode/Upsert';
// Face Attendance Kiosk (v2) — FaceRecognition microservice, Kiosk/Identify + Kiosk/Today
export const HRMS_Face_Kiosk_Identify             = HRMS_Face + '/Kiosk/Identify';
export const HRMS_Face_Kiosk_Today                = HRMS_Face + '/Kiosk/Today';
//#endregion

//region Voucher Entries APIs
export const VoucherEntries: string = ERP + '/ACCT/VOCE';
export const VoucherEntries_Create = VoucherEntries + '/Create';
export const VoucherEntries_Update = VoucherEntries + '/Update';
export const VoucherEntries_Delete = VoucherEntries + '/Delete';
export const VoucherEntries_ReadById = VoucherEntries + '/ReadById';
export const VoucherEntries_ReadByVoucherId = VoucherEntries + '/ReadByVoucherId'
export const VoucherEntries_ReadByAccountId = VoucherEntries + '/ReadByAccountId'
export const VoucherEntries_ReadAll = VoucherEntries + '/ReadAll';
export const VoucherEntriesBulk_Create = VoucherEntries + '/CreateBulk'
export const VoucherEntries_UpdateBulk = VoucherEntries + '/UpdateBulk'
//endregion

//region AccountingReports API
export const AccountReports: string = ERP + '/ACCT/ACR';
export const GetBalanceSheet = AccountReports + '/GetBalanceSheet';
export const GetDayBook = AccountReports + '/GetDayBook';
export const GetLedgerReport = AccountReports + '/GetLedgerReport';
export const GetProfitAndLoss = AccountReports + '/GetProfitAndLoss';
export const GetTrialBalance = AccountReports + '/GetTrialBalanceByGroup'
//endregion

//region QuotationDetail API
export const QuotationDetailURL: string = CRM + '/QD'
export const QuotationDetail_create = QuotationDetailURL + '/Create';
export const QuotationDetail_update = QuotationDetailURL + '/Update';
export const QuotationDetail_delete = QuotationDetailURL + '/Delete';
export const QuotationDetail_readAll = QuotationDetailURL + '/ReadAll';
export const QuotationDetail_readById = QuotationDetailURL + '/ReadById';
export const QuotationDetail_readByQuotationId = QuotationDetailURL + '/ReadByQuotationId';
export const QuotationDetail_readByMasterType = QuotationDetailURL + '/ReadByMasterType';
export const QuotationDetail_readByQuotationIdForImport = QuotationDetailURL + '/ReadByQuotationIdForImport';
export const QuotationDetail_UpsertBulk = QuotationDetailURL + '/UpsertBulk';
//endregion

//region PurchaseMaster API
export const PurchaseMasterURL: string = Billing + '/PM';
export const PurchaseMaster_Create = PurchaseMasterURL + '/Create';
export const PurchaseMaster_Update = PurchaseMasterURL + '/Update';
export const PurchaseMaster_Delete = PurchaseMasterURL + '/Delete';
export const PurchaseMaster_ReadAll = PurchaseMasterURL + '/ReadAll';
export const PurchaseMaster_ReadById = PurchaseMasterURL + '/ReadById';
export const PurchaseMaster_ReadByTenantId = PurchaseMasterURL + '/ReadByTenantId'
export const PurchaseMaster_ReadByOrderId = PurchaseMasterURL + '/ReadByOrderId';
export const PurchaseMaster_SearchByInvoiceNo = PurchaseMasterURL + '/SearchByInvoiceNo';
export const PurchaseMaster_ReadBySupplierCompanyId = PurchaseMasterURL + '/ReadBySupplierCompanyId';
//endregion

//region SalesMaster API
export const SalesMasterURL: string = Billing + '/SM';
export const SalesMaster_Create = SalesMasterURL + '/Create';
export const SalesMaster_Update = SalesMasterURL + '/Update';
export const SalesMaster_Delete = SalesMasterURL + '/Delete';
export const SalesMaster_ReadById = SalesMasterURL + '/ReadById';
export const SalesMaster_ReadByMasterId = SalesMasterURL + '/ReadByMasterId';
export const SalesMaster_ReadAll = SalesMasterURL + '/ReadAll';
export const SalesMaster_ReadByOrderId = SalesMasterURL + '/ReadByOrderId';
export const SalesMaster_SearchByInvoiceNo = SalesMasterURL + '/SearchByInvoiceNo';
export const SalesMaster_ReadByProjectId = SalesMasterURL + '/ReadByProjectId';
export const SalesMaster_ReadByBilledCompanyId = SalesMasterURL + '/ReadByBilledCompanyId';
export const SalesMaster_CloneAndCreate = SalesMasterURL + '/CloneAndCreate';
export const SalesMaster_ExportTally = SalesMasterURL + '/ExportTally';
//endregion

//region TallyExport API
export const TallyExportURL: string = ExternalIntegration + '/TEC';
export const TallyExportConfig_Create = TallyExportURL + '/Create';
export const TallyExportConfig_Update = TallyExportURL + '/Update';
export const TallyExportConfig_Delete = TallyExportURL + '/Delete';
export const TallyExportConfig_ReadById = TallyExportURL + '/ReadById';
export const TallyExportConfig_ReadByTenantId = TallyExportURL + '/ReadByTenantId';
export const TallyLedgerMapping_Create = TallyExportURL + '/Mapping/Create';
export const TallyLedgerMapping_Update = TallyExportURL + '/Mapping/Update';
export const TallyLedgerMapping_Delete = TallyExportURL + '/Mapping/Delete';
export const TallyLedgerMapping_ReadByConfigId = TallyExportURL + '/Mapping/ReadByConfigId';
export const TallyExport_ExportTally = ExternalIntegration + '/TE/ExportTally';
//endregion

//region SalesDetail API
export const SalesDetailURL: string = Billing + '/SD';
export const SalesDetail_Create = SalesDetailURL + '/Create';
export const SalesDetail_Update = SalesDetailURL + '/Update';
export const SalesDetail_Delete = SalesDetailURL + '/Delete';
export const SalesDetail_ReadyById = SalesDetailURL + '/ReadById';
export const SalesDetail_ReadAll = SalesDetailURL + '/ReadAll';
export const SalesDetail_ReadByInvoiceId = SalesDetailURL + '/ReadByInvoiceId';
export const SalesDetail_ReadByItemId = SalesDetailURL + '/ReadByItemId';
export const SalesDetail_ReadByInvoiceIdForImport = SalesDetailURL + '/ReadByInvoiceIdForImport';
export const SalesDetail_UpsertBulk = SalesDetailURL + '/UpsertBulk';
//endregion


//region Sales Detail Datalist API 
export const SalesDetailDatalistURL: string = Billing + '/SDD';
export const SalesDetailDatalist_Create = SalesDetailDatalistURL + "/Create";
export const SalesDetailDatalist_Update = SalesDetailDatalistURL + "/Update";
export const SalesDetailDatalist_Delete = SalesDetailDatalistURL + "/Delete";
export const SalesDetailDatalist_ReadById = SalesDetailDatalistURL + "/ReadById";
export const SalesDetailDatalist_ReadByDatalistId = SalesDetailDatalistURL + "/ReadByDatalistId";
//endregion


//region PurchaseDetail API
export const PurchaseDetailURL: string = Billing + '/PD';
export const PurchaseDetail_Create = PurchaseDetailURL + '/Create';
export const PurchaseDetail_Update = PurchaseDetailURL + '/Update';
export const PurchaseDetail_Delete = PurchaseDetailURL + '/Delete';
export const PurchaseDetail_ReadAll = PurchaseDetailURL + '/ReadAll';
export const PurchaseDetail_ReadById = PurchaseDetailURL + '/ReadById';
export const PurchaseDetail_ReadByInvoiceId = PurchaseDetailURL + '/ReadByInvoiceId'
export const PurchaseDetail_ReadByItemId = PurchaseDetailURL + '/ReadByItemId';
export const PurchaseDetail_ReadByInvoiceIdForImport = PurchaseDetailURL + '/ReadByInvoiceIdForImport';
export const PurchaseDetail_UpsertBulk = PurchaseDetailURL + '/UpsertBulk';
//endregion

//region PurchaseInvoiceOtherCharges API
export const PurchaseInvoiceOtherChargesURL: string = Billing + '/PIOC';
export const PurchaseInvoiceOtherCharges_Create = PurchaseInvoiceOtherChargesURL + '/Create';
export const PurchaseInvoiceOtherCharges_Update = PurchaseInvoiceOtherChargesURL + '/Update';
export const PurchaseInvoiceOtherCharges_Delete = PurchaseInvoiceOtherChargesURL + '/Delete';
export const PurchaseInvoiceOtherCharges_ReadAll = PurchaseInvoiceOtherChargesURL + '/ReadAll';
export const PurchaseInvoiceOtherCharges_ReadById = PurchaseInvoiceOtherChargesURL + '/ReadById';
export const PurchaseInvoiceOtherCharges_ReadByInvoiceId = PurchaseInvoiceOtherChargesURL + '/ReadByInvoiceId'
export const PurchaseInvoiceOtherCharges_ReadByItemId = PurchaseInvoiceOtherChargesURL + '/ReadByItemId';
export const PurchaseInvoiceOtherCharges_ReadByInvoiceIdForImport = PurchaseInvoiceOtherChargesURL + '/ReadByInvoiceIdForImport';
//endregion

//region SalesRelease API 
export const SalesReleaseURL: string = Billing + '/SR';
export const SalesRelease_Create = SalesReleaseURL + '/Create';
export const SalesRelease_Update = SalesReleaseURL + '/Update';
export const SalesRelease_Delete = SalesReleaseURL + '/Delete';
export const SalesRelease_ReadAll = SalesReleaseURL + '/ReadAll';
export const SalesRelease_ReadById = SalesReleaseURL + '/ReadById';
export const SalesRelease_ReadByTenantId = SalesReleaseURL + '/ReadByTenantId';
export const SalesRelease_SearchByReleaseNo = SalesReleaseURL + '/SearchByReleaseNo';
//endregion

//region SalesReleaseDetail API 
export const SalesReleaseDetailURL: string = Billing + '/SRD';
export const SalesReleaseDetail_Create = SalesReleaseDetailURL + '/Create';
export const SalesReleaseDetail_Update = SalesReleaseDetailURL + '/Update';
export const SalesReleaseDetail_Delete = SalesReleaseDetailURL + '/Delete';
export const SalesReleaseDetail_ReadAll = SalesReleaseDetailURL + '/ReadAll';
export const SalesReleaseDetail_ReadById = SalesReleaseDetailURL + '/ReadById';
export const SalesReleaseDetail_ReadByItemId = SalesReleaseDetailURL + '/ReadByItemId';
export const SalesReleaseDetail_ReadByReleaseId = SalesReleaseDetailURL + '/ReadByReleaseId';
export const SalesReleaseDetail_ReadByReleaseIdForImport = SalesReleaseDetailURL + '/ReadByReleaseIdForImport';
export const SalesReleaseDetail_CreateBulk = SalesReleaseDetailURL + '/CreateBulk';
export const SalesReleaseDetail_UpsertBulk = SalesReleaseDetailURL + '/UpsertBulk';
//endregion

//region SalesOrder API
export const SalesOrderURL: string = Billing + '/SO';
export const SalesOrder_Create = SalesOrderURL + '/Create';
export const SalesOrder_Update = SalesOrderURL + '/Update';
export const SalesOrder_Delete = SalesOrderURL + '/Delete';
export const SalesOrder_ReadById = SalesOrderURL + '/ReadById';
export const SalesOrder_ReadAll = SalesOrderURL + '/ReadAll';
export const SalesOrder_ReadByAgentId = SalesOrderURL + '/ReadByAgentId';
export const SalesOrder_ReadByTenantId = SalesOrderURL + '/ReadByTenantId';
export const SalesOrder_ReadByProjectId = SalesOrderURL + '/ReadByProjectId';
export const SalesOrder_SearchByOrderNo = SalesOrderURL + '/SearchByOrderNo';
//endregion

//region SalesOrderDetail API
export const SalesOrderDetailURL: string = Billing + '/SOD';
export const SalesOrderDetail_Create = SalesOrderDetailURL + '/Create';
export const SalesOrderDetail_Update = SalesOrderDetailURL + '/Update';
export const SalesOrderDetail_Delete = SalesOrderDetailURL + '/Delete';
export const SalesOrderDetail_ReadById = SalesOrderDetailURL + '/ReadById';
export const SalesOrderDetail_ReadAll = SalesOrderDetailURL + '/ReadAll';
export const SalesOrderDetail_ReadBySalesOrderId = SalesOrderDetailURL + '/ReadBySalesOrderId';
export const SalesOrderDetail_ReadByItemId = SalesOrderDetailURL + '/ReadByItemId';
export const SalesOrderDetail_ReadBySalesOrderIdForImport = SalesOrderDetailURL + '/ReadBySalesOrderIdForImport';
export const SalesOrderDetail_UpsertBulk = SalesOrderDetailURL + '/UpsertBulk';
//endregion

// region SalesOrderOtherCharges API
export const SalesOrderOtherChargesURL: string = Billing + '/SOOC';
export const SalesOrderOtherCharges_Create = SalesOrderOtherChargesURL + '/Create';
export const SalesOrderOtherCharges_Update = SalesOrderOtherChargesURL + '/Update';
export const SalesOrderOtherCharges_Delete = SalesOrderOtherChargesURL + '/Delete';
export const SalesOrderOtherCharges_ReadById = SalesOrderOtherChargesURL + '/ReadById';
export const SalesOrderOtherCharges_ReadBySalesOrderId = SalesOrderOtherChargesURL + '/ReadBySalesOrderId';
// endregion



//region PaymentMaster API
export const PaymentMasterURL: string = Billing + '/PMT'
export const PaymentsMaster_Create = PaymentMasterURL + '/Create'
export const PaymentsMaster_Update = PaymentMasterURL + '/Update'
export const PaymentsMaster_Delete = PaymentMasterURL + '/Delete'
export const PaymentsMaster_ReadById = PaymentMasterURL + '/ReadById'
export const PaymentsMaster_ReadAll = PaymentMasterURL + '/ReadAll'
export const PaymentsMaster_ReadByTenantId = PaymentMasterURL + '/ReadByTenantId'
export const PaymentsMaster_ReadByBilledCompanyId = PaymentMasterURL + '/ReadByBilledCompanyId'
//endregion

//region PaymentDetail API
export const PaymentDetailURL: string = Billing + '/PMTD'
export const PaymentsDetail_Create = PaymentDetailURL + '/Create'
export const PaymentsDetail_Update = PaymentDetailURL + '/Update'
export const PaymentsDetail_Delete = PaymentDetailURL + '/Delete'
export const PaymentsDetail_ReadById = PaymentDetailURL + '/ReadById'
export const PaymentsDetail_ReadAll = PaymentDetailURL + '/ReadAll'
export const PaymentsDetail_ReadByPaymentId = PaymentDetailURL + '/ReadByPaymentId'
export const PaymentsDetail_ReadByMasterId = PaymentDetailURL + '/ReadByMasterId'
export const PaymentsDetail_ReadByTransactionType = PaymentDetailURL + '/ReadByTransactionType'
//endregion

//#region PurchaseRelease API
export const PurchaseReleaseURL: string = Billing + '/PR'
export const PurchaseRelease_Create = PurchaseReleaseURL + '/Create'
export const PurchaseRelease_Update = PurchaseReleaseURL + '/Update'
export const PurchaseRelease_Delete = PurchaseReleaseURL + '/Delete'
export const PurchaseRelease_ReadbyId = PurchaseReleaseURL + '/ReadById'
export const PurchaseRelease_ReadAll = PurchaseReleaseURL + '/ReadAll'
export const PurchaseRelease_ReadByTenantId = PurchaseReleaseURL + '/ReadByTenantId'
export const PurchaseRelease_SearchByReleaseNo = PurchaseReleaseURL + '/SearchByReleaseNo'
//#endregion

//region PurchaseReleaseDetail API 
export const PurchaseReleaseDetailURL: string = Billing + '/PRD';
export const PurchaseReleaseDetail_Create = PurchaseReleaseDetailURL + '/Create';
export const PurchaseReleaseDetail_Update = PurchaseReleaseDetailURL + '/Update';
export const PurchaseReleaseDetail_Delete = PurchaseReleaseDetailURL + '/Delete';
export const PurchaseReleaseDetail_ReadAll = PurchaseReleaseDetailURL + '/ReadAll';
export const PurchaseReleaseDetail_ReadById = PurchaseReleaseDetailURL + '/ReadById';
export const PurchaseReleaseDetail_ReadByItemId = PurchaseReleaseDetailURL + '/ReadByItemId';
export const PurchaseReleaseDetail_ReadByReleaseId = PurchaseReleaseDetailURL + '/ReadByReleaseId';
export const PurchaseReleaseDetail_ReadByReleaseIdForImport = PurchaseReleaseDetailURL + '/ReadByReleaseIdForImport';
export const PurchaseReleaseDetail_ReadByInvoiceIdForImport = PurchaseReleaseDetailURL + '/ReadByInvoiceIdForImport';
export const PurchaseReleaseDetail_CreateBulk = PurchaseReleaseDetailURL + '/CreateBulk';
export const PurchaseReleaseDetail_UpsertBulk = PurchaseReleaseDetailURL + '/UpsertBulk';
//endregion
//region PurchaseOrder API 
export const PurchaseOrderURL: string = Billing + '/PO';

export const PurchaseOrder_Create = PurchaseOrderURL + '/Create';
export const PurchaseOrder_Update = PurchaseOrderURL + '/Update';
export const PurchaseOrder_UpdateStatus = PurchaseOrderURL + '/UpdateStatus';
export const PurchaseOrder_Delete = PurchaseOrderURL + '/Delete';
export const PurchaseOrder_ReadById = PurchaseOrderURL + '/ReadById';
export const PurchaseOrder_ReadByTenantId = PurchaseOrderURL + '/ReadByTenantId';
export const PurchaseOrder_ReadByAgentId = PurchaseOrderURL + '/ReadByAgentId';
export const PurchaseOrder_SearchByPurchaseOrderNo = PurchaseOrderURL + '/SearchByPurchaseOrderNo';
//endregion
//region PurchaseOrderDetail API 

export const PurchaseOrderDetailURL: string = Billing + '/POD';

export const PurchaseOrderDetail_Create = PurchaseOrderDetailURL + '/Create';
export const PurchaseOrderDetail_Update = PurchaseOrderDetailURL + '/Update';
export const PurchaseOrderDetail_Delete = PurchaseOrderDetailURL + '/Delete';
export const PurchaseOrderDetail_ReadById = PurchaseOrderDetailURL + '/ReadById';
export const PurchaseOrderDetail_ReadByPurchaseOrderId = PurchaseOrderDetailURL + '/ReadByPurchaseOrderId';
export const PurchaseOrderDetail_ReadByPurchaseOrderIdForImport = PurchaseOrderDetailURL + '/ReadByPurchaseOrderIdForImport';
export const PurchaseOrderDetail_ReadByItemId = PurchaseOrderDetailURL + '/ReadByItemId';
export const PurchaseOrderDetail_CreateBulk = PurchaseOrderDetailURL + '/CreateBulk';
export const PurchaseOrderDetail_UpsertBulk = PurchaseOrderDetailURL + '/UpsertBulk';



//endregion

//region PurchaseOrderDetail API

export const PurchaseOtherChargesURL: string = Billing + '/POOC';

export const PurchaseOtherCharges_Create = PurchaseOtherChargesURL + '/Create';
export const PurchaseOtherCharges_Update = PurchaseOtherChargesURL + '/Update';
export const PurchaseOtherCharges_Delete = PurchaseOtherChargesURL + '/Delete';

export const PurchaseOtherCharges_ReadById = PurchaseOtherChargesURL + '/ReadById';
export const PurchaseOtherCharges_ReadByPurchaseOrderId = PurchaseOtherChargesURL + '/ReadByPurchaseOrderId';

//endregion
//region CreditnoteMaster API
export const CreditNoteMasterURL: string = Billing + '/CNM';
export const CreditNoteMaster_Create = CreditNoteMasterURL + '/Create';
export const CreditNoteMaster_Update = CreditNoteMasterURL + '/Update';
export const CreditNoteMaster_ReadById = CreditNoteMasterURL + '/ReadById';
export const CreditNoteMaster_ReadByTenantId = CreditNoteMasterURL + '/ReadByTenantId';
export const CreditNoteMaster_Delete = CreditNoteMasterURL + '/Delete';
export const CreditNoteMaster_SearchByCreditNoteNo = CreditNoteMasterURL + '/SearchByCreditNoteNo';
//endregion


//region Debitnotemaster api
export const DebitNoteMasterURL: string = Billing + '/DNM';
export const DebitNoteMaster_Create = DebitNoteMasterURL + '/Create';
export const DebitNoteMaster_Update = DebitNoteMasterURL + '/Update';
export const DebitNoteMaster_Delete = DebitNoteMasterURL + '/Delete';
export const DebitNoteMaster_ReadById = DebitNoteMasterURL + '/ReadyById';
export const DebitNoteMaster_ReadByTenantId = DebitNoteMasterURL + '/ReadyByTenantId';
export const DebitNoteMaster_SearchByDebitNoteNo = DebitNoteMasterURL + '/SearchByDebitNoteNo';
//endregion


//region Debitnotemaster api
export const JobWorkInMasterURL: string = Billing + '/JWIM';
export const JobWorkInMaster_Create = JobWorkInMasterURL + '/Create';
export const JobWorkInMaster_Update = JobWorkInMasterURL + '/Update';
export const JobWorkInMaster_Delete = JobWorkInMasterURL + '/Delete';
export const JobWorkInMaster_ReadById = JobWorkInMasterURL + '/ReadById';
export const JobWorkInMaster_ReadByTenantId = JobWorkInMasterURL + '/ReadByTenantId';
export const JobWorkInMaster_ReadByAgentId = JobWorkInMasterURL + '/ReadByAgentId';
export const JobWorkInMaster_ReadByJobWorkerId = JobWorkInMasterURL + '/ReadByJobWorkerId';
export const JobWorkInMaster_ReadByTransportId = JobWorkInMasterURL + '/ReadByTransportId';
export const JobWorkInMaster_ReadByJWOId = JobWorkInMasterURL + '/ReadByJWOId';
//endregion


//region Debitnotemaster api
export const JobWorkInDetailURL: string = Billing + '/JWID';
export const JobWorkInDetail_Create = JobWorkInDetailURL + '/Create';
export const JobWorkInDetail_Update = JobWorkInDetailURL + '/Update';
export const JobWorkInDetail_Delete = JobWorkInDetailURL + '/Delete';
export const JobWorkInDetail_ReadById = JobWorkInDetailURL + '/ReadById';
export const JobWorkInDetail_ReadByItemId = JobWorkInDetailURL + '/ReadByItemId';
export const JobWorkInDetail_ReadByJWIId = JobWorkInDetailURL + '/ReadByJWIId';
export const JobWorkInDetail_BulkUpsert = JobWorkInDetailURL + '/BulkUpsert';
//endregion

// region JWIWastageDetail api  (Job Work In wastage lines — separate table/service)
export const JWIWastageDetailURL: string = Billing + '/JWIW';
export const JWIWastageDetail_Create = JWIWastageDetailURL + '/Create';
export const JWIWastageDetail_Update = JWIWastageDetailURL + '/Update';
export const JWIWastageDetail_Delete = JWIWastageDetailURL + '/Delete';
export const JWIWastageDetail_ReadById = JWIWastageDetailURL + '/ReadById';
export const JWIWastageDetail_ReadByItemId = JWIWastageDetailURL + '/ReadByItemId';
export const JWIWastageDetail_ReadByJWIId = JWIWastageDetailURL + '/ReadByJWIId';
//endregion





// region Credit_detail api
export const CreditDetailURL: string = Billing + '/CND';
export const CreditDetail_Create = CreditDetailURL + '/Create';
export const CreditDetail_Update = CreditDetailURL + '/Update';
export const CreditDetail_Delete = CreditDetailURL + '/Delete';
export const CreditDetail_ReadByCreditNoteId = CreditDetailURL + '/ReadByCreditNoteId';
export const CreditDetail_ReadById = CreditDetailURL + '/ReadById';
export const CreditDetail_ReadByItemId = CreditDetailURL + '/ReadByItemId';
export const CreditDetail_UpsertBulk = CreditDetailURL + '/UpsertBulk';
export const CreditDetail_ReadByCreditNoteIdForImport = CreditDetailURL + '/ReadByCreditNoteIdForImport';

//endregion


// region Debit_detail api
export const DebitDetailURL: string = Billing + '/DND';
export const DebitDetail_Create = DebitDetailURL + '/Create';
export const DebitDetail_Update = DebitDetailURL + '/Update';
export const DebitDetail_Delete = DebitDetailURL + '/Delete';
export const DebitDetail_ReadById = DebitDetailURL + '/ReadById';
export const DebitDetail_ReadByItemId = DebitDetailURL + '/ReadByItemId';
export const DebitDetail_ReadByDebitNoteId = DebitDetailURL + '/ReadByDebitNoteId'
export const DebitDetail_ReadByDebitNoteIdForImport = DebitDetailURL + '/ReadByDebitNoteIdForImport';
export const DebitDetail_UpsertBulk = DebitDetailURL + '/UpsertBulk';
//endregion

//region JobWorkOutMaster API
export const JobWorkOutMasterURL: string = Billing + '/JWOM';
export const JobWorkOut_Create = JobWorkOutMasterURL + '/Create';
export const JobWorkOut_Update = JobWorkOutMasterURL + '/Update';
export const JobWorkOut_Delete = JobWorkOutMasterURL + '/Delete';
export const JobWorkOut_ReadById = JobWorkOutMasterURL + '/ReadById';
export const JobWorkOut_ReadAll = JobWorkOutMasterURL + '/ReadAll';
export const JobWorkOut_ReadByTenantId = JobWorkOutMasterURL + '/ReadByTenantId';
export const JobWorkOut_ReadByAgentId = JobWorkOutMasterURL + '/ReadByAgentId';
export const JobWorkOut_ReadByJobWorkerId = JobWorkOutMasterURL + '/ReadByJobWorkerId';
export const JobWorkOut_ReadByOrderId = JobWorkOutMasterURL + '/ReadByOrderId';
export const JobWorkOut_ReadByTransportId = JobWorkOutMasterURL + '/ReadByTransportId';
export const JobWorkOut_SearchByName = JobWorkOutMasterURL + '/SearchByName';
export const JobWorkOut_GenerateDetailsFromPlan = JobWorkOutMasterURL + '/GenerateDetailsFromPlan';
export const JobWorkOut_GetReconciliation = JobWorkOutMasterURL + '/GetReconciliation';
export const JobWorkOut_UpdateStatus = JobWorkOutMasterURL + '/UpdateStatus';
export const JobWorkOut_ProductionStatusByItem = JobWorkOutMasterURL + '/ProductionStatusByItem';
export const JobWorkOut_ReadByItemId = JobWorkOutMasterURL + '/ReadByItemId';
//endregion

//region JWOOutDetail API
export const JWOOutDetailURL: string = Billing + '/JOD';
export const JWOOutDetail_Create = JWOOutDetailURL + '/Create';
export const JWOOutDetail_Update = JWOOutDetailURL + '/Update';
export const JWOOutDetail_Delete = JWOOutDetailURL + '/Delete';
export const JWOOutDetail_ReadAll = JWOOutDetailURL + '/ReadAll';
export const JWOOutDetail_ReadById = JWOOutDetailURL + '/ReadById';
export const JWOOutDetail_ReadByItemId = JWOOutDetailURL + '/ReadByItemId';
export const JWOOutDetail_ReadByJWOId = JWOOutDetailURL + '/ReadByJWOId';
export const JWOOutDetail_BulkUpsert = JWOOutDetailURL + '/BulkUpsert';
//endregion

//region JWOInDetail API
export const JWOInDetailURL: string = Billing + '/JID';
export const JWOInDetail_Create = JWOInDetailURL + '/Create';
export const JWOInDetail_Update = JWOInDetailURL + '/Update';
export const JWOInDetail_Delete = JWOInDetailURL + '/Delete';
export const JWOInDetail_ReadAll = JWOInDetailURL + '/ReadAll';
export const JWOInDetail_ReadById = JWOInDetailURL + '/ReadById';
export const JWOInDetail_ReadByItemId = JWOInDetailURL + '/ReadByItemId';
export const JWOInDetail_ReadByJWOId = JWOInDetailURL + '/ReadByJWOId';
export const JWOInDetail_BulkUpsert = JWOInDetailURL + '/BulkUpsert';
//endregion

//region InstructionsMaster API
export const InstructionsMasterURL: string = Billing + '/IM';
export const InstructionsMaster_Create = InstructionsMasterURL + '/Create';
export const InstructionsMaster_Update = InstructionsMasterURL + '/Update';
export const InstructionsMaster_Delete = InstructionsMasterURL + '/Delete';
export const InstructionsMaster_ReadById = InstructionsMasterURL + '/ReadById';
export const InstructionsMaster_ReadByMasterId = InstructionsMasterURL + '/ReadByMasterId'
//endregion

//region InstructionsMaster API
export const UnSubscribeAlertsURL: string = CRM + '/UA';
export const UnSubscribeAlerts_Create = UnSubscribeAlertsURL + '/Create';
export const UnSubscribeAlerts_Update = UnSubscribeAlertsURL + '/Update';
export const UnSubscribeAlerts_Delete = UnSubscribeAlertsURL + '/Delete';
export const UnSubscribeAlerts_ReadById = UnSubscribeAlertsURL + '/ReadById';
export const UnSubscribeAlerts_ReadByMasterId = UnSubscribeAlertsURL + '/ReadByMasterId'
//endregion

//region PrintTemplate API
export const PrintTemplateURL: string = AdvinMaster + '/PT';
export const PrintTemplate_Create = PrintTemplateURL + '/Create';
export const PrintTemplate_Update = PrintTemplateURL + '/Update';
export const PrintTemplate_Delete = PrintTemplateURL + '/Delete';
export const PrintTemplate_ReadAll = PrintTemplateURL + '/ReadAll';
export const PrintTemplate_ReadById = PrintTemplateURL + '/ReadById';
export const PrintTemplate_ReadByTenantId = PrintTemplateURL + '/ReadByTenantId'
//end region


//region PortMaster API
export const PortMasterURL: string = AdvinMaster + '/PM';
export const PortMaster_Create = PortMasterURL + '/Create';
export const PortMaster_Update = PortMasterURL + '/Update';
export const PortMaster_Delete = PortMasterURL + '/Delete';
export const PortMaster_ReadAll = PortMasterURL + '/ReadAll';
export const PortMaster_ReadAllPaginated = PortMasterURL + '/ReadAllPaginated';
export const PortMaster_ReadById = PortMasterURL + '/ReadById';
//end region

//region LabelMaster API
export const LabelMasterURL: string = Billing + '/LM';
export const LabelMaster_Create = LabelMasterURL + '/Create';
export const LabelMaster_Update = LabelMasterURL + '/Update';
export const LabelMaster_Delete = LabelMasterURL + '/Delete';
export const LabelMaster_ReadById = LabelMasterURL + '/ReadById';
export const LabelMaster_ReadAll = LabelMasterURL + '/ReadAll';
export const LabelMaster_ReadAllPaginated = LabelMasterURL + '/ReadAllPaginated';
//endregion


//region LabelDetail API
export const LabelDetailURL: string = Billing + '/LD';
export const LabelDetail_ReadAllPaginated = LabelDetailURL + '/ReadAllPaginated';
export const LabelDetail_Update = LabelDetailURL + '/Update';
export const LabelDetail_ReadById = LabelDetailURL + '/ReadById';
export const LabelDetail_ReadByLabelId = LabelDetailURL + '/ReadByLabelId';
export const LabelDetail_ReadByProductId = LabelDetailURL + '/ReadByProductId';
export const LabelDetail_ReadAll = LabelDetailURL + '/ReadAll';
export const LabelDetail_Delete = LabelDetailURL + '/Delete';
export const LabelDetail_Create = LabelDetailURL + '/Create';
//endregion

//region PrintMaster API
export const PrintMasterURL: string = Billing + '/PRT';
export const PrintMaster_PrintSaleInvoice = PrintMasterURL + '/PrintSalesInvoice';
export const PrintMaster_PrintItemLabel = PrintMasterURL + '/PrintItemLabel';
export const PrintMaster_PrintSaleQuotation = PrintMasterURL + '/PrintSalesQuotation';
export const PrintMaster_PrintDynamicSQL = PrintMasterURL + '/PrintDynamicSQL';
export const PrintMaster_PurchaseChallan = PrintMasterURL + '/PrintPurchaseChallan';
export const PrintMaster_SaleChallan = PrintMasterURL + '/PrintSaleChallan';
export const PrintMaster_SaleRelease = PrintMasterURL + '/PrintSaleRelease';
export const PrintMaster_JobWorkerOut = PrintMasterURL + '/PrintJobWorkerOut';
export const PrintMaster_CreditNote = PrintMasterURL + '/PrintCreditNote';
export const PrintMaster_DebitNote = PrintMasterURL + '/PrintDebitNote';
export const PrintMaster_PurchaseInvoice = PrintMasterURL + '/PrintPurchaseInvoice';
export const PrintMaster_PurchaseOrder = PrintMasterURL + '/PrintPurchaseOrder';
export const PrintMaster_PurchaseIndent = PrintMasterURL + '/PrintPurchaseIndent';
export const PrintMaster_PaySlip = PrintMasterURL + '/PrintPaySlip';
export const PrintMaster_SalesIndent = PrintMasterURL + '/PrintSalesIndent';
export const PrintMaster_SalesOrder = PrintMasterURL + '/PrintSalesOrder';
export const PrintMaster_Receipt = PrintMasterURL + '/PrintReceipt';
export const PrintMaster_Payment = PrintMasterURL + '/PrintPayment';
export const PrintMaster_DynamicSQLExecutor = PrintMasterURL + '/DynamicSQLExecutor';


//endregion


//region SiteMaster API
export const SiteMasterURL: string = CRM + "/SM";
export const SiteMaster_Create = SiteMasterURL + '/Create';
export const SiteMaster_Update = SiteMasterURL + '/Update';
export const SiteMaster_Delete = SiteMasterURL + '/Delete';
export const SiteMaster_ReadById = SiteMasterURL + '/ReadById';
export const SiteMaster_ReadAll = SiteMasterURL + '/ReadAll';
export const SiteMaster_ReadAllPaginated = SiteMasterURL + '/ReadAllPaginated';
//end region


//region labeldesignMaster API
export const DesignURL: string = AdvinMaster + "/LD";
export const Design_Create = DesignURL + '/Create';
export const Design_Update = DesignURL + '/Update';
export const Design_Delete = DesignURL + '/Delete';
export const Design_ReadAll = DesignURL + '/ReadAll';
export const Design_ReadById = DesignURL + '/ReadById';
export const Design_ReadByTenantId = DesignURL + '/ReadByTenantId';
//end region

//region labeldesignMaster API
export const HotelTableMasterURL: string = ERP + "/HTM";
export const HotelTableMaster_Create = HotelTableMasterURL + '/Create';
export const HotelTableMaster_Update = HotelTableMasterURL + '/Update';
export const HotelTableMaster_UpdateStatus = HotelTableMasterURL + '/UpdateStatus';
export const HotelTableMaster_Delete = HotelTableMasterURL + '/Delete';
export const HotelTableMaster_ReadAll = HotelTableMasterURL + '/ReadAll';
export const HotelTableMaster_ReadById = HotelTableMasterURL + '/ReadById';
export const HotelTableMaster_ReadByTenantId = HotelTableMasterURL + '/ReadByTenantId';
//end region

//region ReceiptMaster API
export const ReceiptMasterURL: string = Billing + "/RM";
export const ReceiptMaster_Create = ReceiptMasterURL + '/Create';
export const ReceiptMaster_Update = ReceiptMasterURL + '/Update';
export const ReceiptMaster_Delete = ReceiptMasterURL + '/Delete';
export const ReceiptMaster_ReadAll = ReceiptMasterURL + '/ReadAll';
export const ReceiptMaster_ReadById = ReceiptMasterURL + '/ReadById';
export const ReceiptMaster_ReadByInvoiceId = ReceiptMasterURL + '/ReadByInvoiceId';
export const ReceiptMaster_ReadByCompanyId = ReceiptMasterURL + '/ReadByCompanyId';
//end region

//region ReceiptMaster API
export const ReceiptDetailURL: string = Billing + "/RD";
export const ReceiptDetail_Create = ReceiptDetailURL + '/Create';
export const ReceiptDetail_Update = ReceiptDetailURL + '/Update';
export const ReceiptDetail_Delete = ReceiptDetailURL + '/Delete';
export const ReceiptDetail_ReadAll = ReceiptDetailURL + '/ReadAll';
export const ReceiptDetail_ReadById = ReceiptDetailURL + '/ReadById';
export const ReceiptDetail_ReadByReceiptId = ReceiptDetailURL + '/ReadByReceiptId';
export const ReceiptDetail_ReadByInvoiceId = ReceiptDetailURL + '/ReadByInvoiceId';
export const ReceiptDetail_ReadByMasterId = ReceiptDetailURL + '/ReadByMasterId';
export const ReceiptDetail_GetTransactionsByType = ReceiptDetailURL + '/GetTransactionsByType';
//end region

//region SizeMaster API
export const SizeMasterURL: string = AdvinMaster + "/SZM";
export const SizeMaster_Create = SizeMasterURL + '/Create';
export const SizeMaster_Update = SizeMasterURL + '/Update';
export const SizeMaster_Delete = SizeMasterURL + '/Delete';
export const SizeMaster_ReadAll = SizeMasterURL + '/ReadAll';
export const SizeMaster_ReadById = SizeMasterURL + '/ReadById';
export const SizeMaster_ReadByTenantId = SizeMasterURL + '/ReadByTenantId';
export const SizeMaster_SearchByName = SizeMasterURL + '/SearchByName'
//end region

//region CompanyDocumentNumber API
export const CompanyDocumentNumberURL: string = AdvinMaster + "/CDN";
export const CompanyDocumentNumber_Create = CompanyDocumentNumberURL + '/Create';
export const CompanyDocumentNumber_Update = CompanyDocumentNumberURL + '/Update';
export const CompanyDocumentNumber_Delete = CompanyDocumentNumberURL + '/Delete';
export const CompanyDocumentNumber_ReadAll = CompanyDocumentNumberURL + '/ReadAll';
export const CompanyDocumentNumber_ReadById = CompanyDocumentNumberURL + '/ReadById';
export const CompanyDocumentNumber_ReadByTenantId = CompanyDocumentNumberURL + '/ReadByTenantId';
export const CompanyDocumentNumber_GetMaxNumberByDocType = CompanyDocumentNumberURL + '/GetMaxNumberByDocType';
export const CompanyDocumentNumber_UpdateByDocType = CompanyDocumentNumberURL + '/UpdateByDocType'
export const CompanyDocumentNumber_GetBulkMaxNumberByDocType = CompanyDocumentNumberURL + '/GetBulkMaxNumberByDocType';
//end region

//region TenantPrintNameConfig API
export const TenantPrintNameConfigURL: string = AdvinMaster + "/TPNC";
export const TenantPrintNameConfig_Create = TenantPrintNameConfigURL + '/Create';
export const TenantPrintNameConfig_Update = TenantPrintNameConfigURL + '/Update';
export const TenantPrintNameConfig_Delete = TenantPrintNameConfigURL + '/Delete';
export const TenantPrintNameConfig_ReadAll = TenantPrintNameConfigURL + '/ReadAll';
export const TenantPrintNameConfig_ReadById = TenantPrintNameConfigURL + '/ReadById';
export const TenantPrintNameConfig_ReadByTenantId = TenantPrintNameConfigURL + '/ReadByTenantId';
export const TenantPrintNameConfig_UpsertByDocType = TenantPrintNameConfigURL + '/UpsertByDocType';
export const TenantPrintNameConfig_GetPrintNameByDocType = TenantPrintNameConfigURL + '/GetPrintNameByDocType';
//end region

//region DestinationMaster API
export const DestinationMasterURL: string = ERP + '/DM';
export const DestinationMaster_Create = DestinationMasterURL + '/Create';
export const DestinationMaster_Update = DestinationMasterURL + '/Update';
export const DestinationMaster_Delete = DestinationMasterURL + '/Delete';
export const DestinationMaster_ReadAll = DestinationMasterURL + '/ReadAll';
export const DestinationMaster_ReadById = DestinationMasterURL + '/ReadById';
export const DestinationMaster_ReadByTenantId = DestinationMasterURL + '/ReadByTenantId';
//end region

//region ConsignmentMaster API 
export const ConsignmentMasterURL: string = ERP + '/CM';
export const ConsignmentMaster_Create = ConsignmentMasterURL + '/Create';
export const ConsignmentMaster_Update = ConsignmentMasterURL + '/Update';
export const ConsignmentMaster_Delete = ConsignmentMasterURL + '/Delete';
export const ConsignmentMaster_ReadAll = ConsignmentMasterURL + '/ReadAll';
export const ConsignmentMaster_ReadById = ConsignmentMasterURL + '/ReadById';
export const ConsignmentMaster_ReadByTenantId = ConsignmentMasterURL + '/ReadByTenantId';
export const ConsignmentMaster_ReadByOrderNo = ConsignmentMasterURL + '/ReadByOrderNo';
export const ConsignmentMaster_ReadByDriverId = ConsignmentMasterURL + '/ReadByDriverId';
export const ConsignmentMaster_ReadByBrokerId = ConsignmentMasterURL + '/ReadByBrokerId';
//end region


//region ConsignmentCharges API
export const ConsignmentChargesURL: string = ERP + '/CC';
export const ConsignmentCharges_Create = ConsignmentChargesURL + '/Create';
export const ConsignmentCharges_Update = ConsignmentChargesURL + '/Update';
export const ConsignmentCharges_Delete = ConsignmentChargesURL + '/Delete';
export const ConsignmentCharges_ReadAll = ConsignmentChargesURL + '/ReadAll';
export const ConsignmentCharges_ReadById = ConsignmentChargesURL + '/ReadById';
export const ConsignmentCharges_ReadByConsignmentId = ConsignmentChargesURL + '/ReadByConsignmentId';
//end region


//region ConsignmentEWayBill API
export const ConsignmentEWayBillsURL: string = ERP + '/CEB';
export const ConsignmentEWayBills_Create = ConsignmentEWayBillsURL + '/Create';
export const ConsignmentEWayBills_Update = ConsignmentEWayBillsURL + '/Update';
export const ConsignmentEWayBills_Delete = ConsignmentEWayBillsURL + '/Delete';
export const ConsignmentEWayBills_ReadAll = ConsignmentEWayBillsURL + '/ReadAll';
export const ConsignmentEWayBills_ReadById = ConsignmentEWayBillsURL + '/ReadById';
export const ConsignmentEWayBills_ReadByConsignmentId = ConsignmentEWayBillsURL + '/ReadByConsignmentId';
//end region

//region DocMaster API
export const DocMasterURL: string = AdvinMaster + '/DCM';
export const DocMaster_Create: string = DocMasterURL + '/Create';
export const DocMaster_Update: string = DocMasterURL + '/Update';
export const DocMaster_ReadById: string = DocMasterURL + '/ReadById';
export const DocMaster_Delete: string = DocMasterURL + '/Delete';
export const DocMaster_ReadAll: string = DocMasterURL + '/ReadAll';
export const DocMaster_ReadByDocType: string = DocMasterURL + '/ReadByDocType';
export const DocMaster_ReadByMasterId: string = DocMasterURL + '/ReadByMasterId';
//end region


//region MsItemMaster API
export const MsItemMasterURL: string = ERP + "/MIM";
export const MsItemMaster_Create = MsItemMasterURL + '/Create';
export const MsItemMaster_Update = MsItemMasterURL + '/Update';
export const MsItemMaster_Delete = MsItemMasterURL + '/Delete';
export const MsItemMaster_ReadAll = MsItemMasterURL + '/ReadAll';
export const MsItemMaster_ReadById = MsItemMasterURL + '/ReadById';
export const MsItemMaster_ReadByTenantId = MsItemMasterURL + '/ReadByTenantId';
export const MsItemMaster_ReadAllPaginated = MsItemMasterURL + '/ReadAllPaginated';
export const MsItemMaster_ReadByItemNo = MsItemMasterURL + '/ReadByItemNo';
export const MsItemMaster_SearchByName = MsItemMasterURL + '/SearchByName';
//end region

//region MSPriceMaster API
export const MSPriceMasterURL: string = ERP + "/MPM";
export const MSPriceMaster_Create = MSPriceMasterURL + '/Create';
export const MSPriceMaster_Update = MSPriceMasterURL + '/Update';
export const MSPriceMaster_Delete = MSPriceMasterURL + '/Delete';
export const MSPriceMaster_ReadAll = MSPriceMasterURL + '/ReadAll';
export const MSPriceMaster_ReadById = MSPriceMasterURL + '/ReadById';
export const MSPriceMaster_ReadByItemId = MSPriceMasterURL + '/ReadByItemId';
//end region

//region Company Email Temaplate
export const CompanyEmailTemplateURL: string = AdvinMaster + "/CET";
export const CompanyEmailTemplate_Create = CompanyEmailTemplateURL + '/Create';
export const CompanyEmailTemplate_Update = CompanyEmailTemplateURL + '/Update';
export const CompanyEmailTemplate_Delete = CompanyEmailTemplateURL + '/Delete';
export const CompanyEmailTemplate_ReadAll = CompanyEmailTemplateURL + '/ReadAll';
export const CompanyEmailTemplate_ReadById = CompanyEmailTemplateURL + '/ReadById';
export const CompanyEmailTemplate_ReadByTenantId = CompanyEmailTemplateURL + '/ReadByTenantId';
export const CompanyEmailTemplate_ReadAllPaginated = CompanyEmailTemplateURL + '/ReadAllPaginated';
//end region


//region Company Email Temaplate
export const CompanyEmailTemplateVariableURL: string = AdvinMaster + "/CTV";
export const CompanyEmailTemplateVariable_Create = CompanyEmailTemplateVariableURL + '/Create';
export const CompanyEmailTemplateVariable_Update = CompanyEmailTemplateVariableURL + '/Update';
export const CompanyEmailTemplateVariable_Delete = CompanyEmailTemplateVariableURL + '/Delete';
export const CompanyEmailTemplateVariable_ReadAll = CompanyEmailTemplateVariableURL + '/ReadAll';
export const CompanyEmailTemplateVariable_ReadById = CompanyEmailTemplateVariableURL + '/ReadById';
export const CompanyEmailTemplateVariable_ReadByTemplateID = CompanyEmailTemplateVariableURL + '/ReadByTemplateId';
//end region


//region MSPriceMaster API
export const MsItemFilesURL: string = ERP + "/MSIF";
export const MsItemFiles_Create = MsItemFilesURL + '/Create';
export const MsItemFiles_Update = MsItemFilesURL + '/Update';
export const MsItemFiles_Delete = MsItemFilesURL + '/Delete';
export const MsItemFiles_ReadAll = MsItemFilesURL + '/ReadAll';
export const MsItemFiles_ReadById = MsItemFilesURL + '/ReadById';
export const MsItemFiles_ReadByItemId = MsItemFilesURL + '/ReadByItemId';
//end region


//region SampleMaster API
export const SampleMasterURL: string = Products + "/SM";
export const SampleMaster_Create = SampleMasterURL + '/Create';
export const SampleMaster_Update = SampleMasterURL + '/Update';
export const SampleMaster_Delete = SampleMasterURL + '/Delete';
export const SampleMaster_ReadAll = SampleMasterURL + '/ReadAll';
export const SampleMaster_ReadById = SampleMasterURL + '/ReadById';
export const SampleMaster_ReadByItemId = SampleMasterURL + '/ReadByItemId';
export const SampleMaster_ReadByItemNo = SampleMasterURL + '/ReadByItemNo';
//end region

//region SampleDetail API
export const SampleDetailURL: string = Products + "/SD";
export const SampleDetail_Create = SampleDetailURL + '/Create';
export const SampleDetail_Update = SampleDetailURL + '/Update';
export const SampleDetail_Delete = SampleDetailURL + '/Delete';
export const SampleDetail_ReadAll = SampleDetailURL + '/ReadAll';
export const SampleDetail_ReadById = SampleDetailURL + '/ReadById';
export const SampleDetail_ReadBySampleId = SampleDetailURL + '/ReadBySampleId';
//end region


//region ProductServiceMapping APIs
export const ProductServiceMappingURL: string = Products + '/PSM';
export const ProductServiceMapping_Create = ProductServiceMappingURL + '/Create';
export const ProductServiceMapping_Update = ProductServiceMappingURL + '/Update';
export const ProductServiceMapping_Delete = ProductServiceMappingURL + '/Delete';
export const ProductServiceMapping_ReadById = ProductServiceMappingURL + '/ReadById';
export const ProductServiceMapping_ReadByProductId = ProductServiceMappingURL + '/ReadByProductId';
//end region


//region MsItemStockMaster API
export const MsItemStockMasterURL: string = ERP + "/MSSM";
export const MsItemStockMaster_Create = MsItemStockMasterURL + '/Create';
export const MsItemStockMaster_Update = MsItemStockMasterURL + '/Update';
export const MsItemStockMaster_Delete = MsItemStockMasterURL + '/Delete';
export const MsItemStockMaster_ReadAll = MsItemStockMasterURL + '/ReadAll';
export const MsItemStockMaster_ReadById = MsItemStockMasterURL + '/ReadById';
export const MsItemStockMaster_ReadByItemId = MsItemStockMasterURL + '/ReadByItemId';
export const MsItemStockMaster_ReadByTenantId = MsItemStockMasterURL + '/ReadByTenantId';
//end region


//region TemplateMaster API
export const TemplateMasterURL: string = PMS + "/TM";
export const TemplateMaster_Create = TemplateMasterURL + '/Create';
export const TemplateMaster_Update = TemplateMasterURL + '/Update';
export const TemplateMaster_Delete = TemplateMasterURL + '/Delete';
export const TemplateMaster_ReadAll = TemplateMasterURL + '/ReadAll';
export const TemplateMaster_ReadById = TemplateMasterURL + '/ReadById';
export const TemplateMaster_ReadByExistingTemplateId = TemplateMasterURL + '/ReadByExistingTemplateId';
export const TemplateMaster_ReadByTenantId = TemplateMasterURL + '/ReadByTenantId';
export const TemplateMaster_ReadAllPaginated = TemplateMasterURL + '/ReadAllPaginated';
//end region

//region TemplateDetail API
export const TemplateDetailURL: string = PMS + "/TD";
export const TemplateDetail_Create = TemplateDetailURL + '/Create';
export const TemplateDetail_Update = TemplateDetailURL + '/Update';
export const TemplateDetail_Delete = TemplateDetailURL + '/Delete';
export const TemplateDetail_ReadAll = TemplateDetailURL + '/ReadAll';
export const TemplateDetail_ReadById = TemplateDetailURL + '/ReadById';
export const TemplateDetail_ReadByParentDetailId = TemplateDetailURL + '/ReadByParentDetailId';
export const TemplateDetail_ReadByTemplateId = TemplateDetailURL + '/ReadByTemplateId';
export const TemplateDetail_PrintMasterByTemplateId = TemplateDetailURL + '/PrintMasterByTemplateId';
//end region


//region Template Detail Task Estimate  API
export const TemplateDetailTaskEstimateURL: string = PMS + "/TDTE";
export const TemplateDetailTaskEstimate_Create = TemplateDetailTaskEstimateURL + '/Create';
export const TemplateDetailTaskEstimate_Update = TemplateDetailTaskEstimateURL + '/Update';
export const TemplateDetailTaskEstimate_Delete = TemplateDetailTaskEstimateURL + '/Delete';
export const TemplateDetailTaskEstimate_ReadAll = TemplateDetailTaskEstimateURL + '/ReadAll';
export const TemplateDetailTaskEstimate_ReadById = TemplateDetailTaskEstimateURL + '/ReadById';
export const TemplateDetailTaskEstimate_ReadByDetailId = TemplateDetailTaskEstimateURL + '/ReadByDetailId';
export const TemplateDetailTaskEstimate_ReadByTemplateId = TemplateDetailTaskEstimateURL + '/ReadByTemplateId';
export const TemplateDetailTaskEstimate_RolledUpByTemplateId = TemplateDetailTaskEstimateURL + '/RolledUpByTemplateId';
//end region

//region Template Milestone API
export const TemplateMilestone_URL: string = PMS + "/TMS";
export const TemplateMilestoneCreate = TemplateMilestone_URL + '/Create';
export const TemplateMilestoneUpdate = TemplateMilestone_URL + '/Update';
export const TemplateMilestoneDelete = TemplateMilestone_URL + '/Delete';
export const TemplateMilestoneReadAll = TemplateMilestone_URL + '/ReadAll';
export const TemplateMilestoneReadById = TemplateMilestone_URL + '/ReadById';
export const TemplateMilestoneReadByTemplateId = TemplateMilestone_URL + '/ReadByTemplateId';
export const TemplateMilestoneReadByDetailId = TemplateMilestone_URL + '/ReadByDetailId';
//end region

//region Template PhaseGate API
export const TemplatePhaseGate_URL: string = PMS + "/TPG";
export const TemplatePhaseGateCreate = TemplatePhaseGate_URL + '/Create';
export const TemplatePhaseGateUpdate = TemplatePhaseGate_URL + '/Update';
export const TemplatePhaseGateDelete = TemplatePhaseGate_URL + '/Delete';
export const TemplatePhaseGateReadAll = TemplatePhaseGate_URL + '/ReadAll';
export const TemplatePhaseGateReadById = TemplatePhaseGate_URL + '/ReadById';
export const TemplatePhaseGateReadByUnlockPGId = TemplatePhaseGate_URL + '/ReadByUnlockPGId';
export const TemplatePhaseGateReadByDetailId = TemplatePhaseGate_URL + '/ReadByDetailId';
export const TemplatePhaseGateReadByTemplateId = TemplatePhaseGate_URL + '/ReadByTemplateId';
//end region


//region Template Detail Dependency API
export const TemplateDependency_URL: string = PMS + "/TDD";
export const TemplateDependencyCreate = TemplateDependency_URL + '/Create';
export const TemplateDependencyUpdate = TemplateDependency_URL + '/Update';
export const TemplateDependencyDelete = TemplateDependency_URL + '/Delete';
export const TemplateDependencyReadAll = TemplateDependency_URL + '/ReadAll';
export const TemplateDependencyReadById = TemplateDependency_URL + '/ReadById';
export const TemplateDependencyReadByDetailId = TemplateDependency_URL + '/ReadByDetailId';
export const TemplateDependencyReadByDependedOn = TemplateDependency_URL + '/ReadByDependedOn';
export const TemplateDependencyReadByTemplateId = TemplateDependency_URL + '/ReadByTemplateId';
//end region

//region Template Detail CheckList API
export const TemplateDetailChecklistURL: string = PMS + "/TDCL";
export const TemplateDetailChecklist_Create = TemplateDetailChecklistURL + '/Create';
export const TemplateDetailChecklist_Update = TemplateDetailChecklistURL + '/Update';
export const TemplateDetailChecklist_Delete = TemplateDetailChecklistURL + '/Delete';
export const TemplateDetailChecklist_ReadAll = TemplateDetailChecklistURL + '/ReadAll';
export const TemplateDetailChecklist_ReadById = TemplateDetailChecklistURL + '/ReadById';
export const TemplateDetailChecklist_ReadByDetailId = TemplateDetailChecklistURL + '/ReadByDetailId';
export const TemplateDetailChecklist_ReadByTemplateId = TemplateDetailChecklistURL + '/ReadByTemplateId';
//end region

//region TemplateDatalist API
export const TemplateDatalistURL: string = PMS + "/TDDL";
export const TemplateDatalist_Create = TemplateDatalistURL + '/Create';
export const TemplateDatalist_Update = TemplateDatalistURL + '/Update';
export const TemplateDatalist_Delete = TemplateDatalistURL + '/Delete';
export const TemplateDatalist_ReadAll = TemplateDatalistURL + '/ReadAll';
export const TemplateDatalist_ReadById = TemplateDatalistURL + '/ReadById';
export const TemplateDatalist_ReadByDetailId = TemplateDatalistURL + '/ReadByDetailId';
export const TemplateDatalist_ReadByTemplateId = TemplateDatalistURL + '/ReadByTemplateId';
//endregion

//region ProjectDatalist API
export const ProjectDatalistURL: string = PMS + "/PDDL";
export const ProjectDatalist_Create = ProjectDatalistURL + '/Create';
export const ProjectDatalist_Update = ProjectDatalistURL + '/Update';
export const ProjectDatalist_Delete = ProjectDatalistURL + '/Delete';
export const ProjectDatalist_ReadAll = ProjectDatalistURL + '/ReadAll';
export const ProjectDatalist_ReadById = ProjectDatalistURL + '/ReadById';
export const ProjectDatalist_ReadByDetailId = ProjectDatalistURL + '/ReadByDetailId';
export const ProjectDatalist_ReadByProjectId = ProjectDatalistURL + '/ReadByProjectId';
//endregion



//region Project Detail CheckList API
export const ProjectDetailChecklistURL: string = PMS + "/PDCL";
export const ProjectDetailChecklist_Create = ProjectDetailChecklistURL + '/Create';
export const ProjectDetailChecklist_Update = ProjectDetailChecklistURL + '/Update';
export const ProjectDetailChecklist_Delete = ProjectDetailChecklistURL + '/Delete';
export const ProjectDetailChecklist_ReadAll = ProjectDetailChecklistURL + '/ReadAll';
export const ProjectDetailChecklist_ReadById = ProjectDetailChecklistURL + '/ReadById';
export const ProjectDetailChecklist_ReadByDetailId = ProjectDetailChecklistURL + '/ReadByDetailId';
export const ProjectDetailChecklist_ReadByProjectId = ProjectDetailChecklistURL + '/ReadByProjectId';
//end region



//region Project Master API
export const ProjectMasterURL: string = PMS + "/PM";
export const ProjectMaster_Create = ProjectMasterURL + '/Create';
export const ProjectMaster_Update = ProjectMasterURL + '/Update';
export const ProjectMaster_Delete = ProjectMasterURL + '/Delete';
export const ProjectMaster_ReadAll = ProjectMasterURL + '/ReadAll';
export const ProjectMaster_ReadById = ProjectMasterURL + '/ReadById';
export const ProjectMaster_ReadByTemplateId = ProjectMasterURL + '/ReadByTemplateId';
export const ProjectMaster_ReadByTenantId = ProjectMasterURL + '/ReadByTenantId';
export const ProjectMaster_ReadAllPaginated = ProjectMasterURL + '/ReadAllPaginated';
export const ProjectMaster_SearchByName = ProjectMasterURL + '/SearchByName';
export const ProjectMaster_ReadByMasterId = ProjectMasterURL + '/ReadByMasterId';
//end region

//region Project Detail API
export const ProjectDetailURL: string = PMS + "/PD";
export const ProjectDetail_Create = ProjectDetailURL + '/Create';
export const ProjectDetail_Update = ProjectDetailURL + '/Update';
export const ProjectDetail_Delete = ProjectDetailURL + '/Delete';
export const ProjectDetail_ReadAll = ProjectDetailURL + '/ReadAll';
export const ProjectDetail_ReadById = ProjectDetailURL + '/ReadById';
export const ProjectDetail_ReadByProjectId = ProjectDetailURL + '/ReadByProjectId';
export const ProjectDetail_ReadAllPaginated = ProjectDetailURL + '/ReadAllPaginated';
export const ProjectDetail_ReadByParentDetailId = ProjectDetailURL + '/ReadByParentDetailId';
export const ProjectDetail_RolledUpDates = ProjectDetailURL + '/RolledUpDates';
export const ProjectDetail_GetAllMilestone = ProjectDetailURL + '/GetAllMilestone';
export const ProjectDetail_PrintMasterByProjectId = ProjectDetailURL + '/PrintMasterByProjectId';
//end region

//region Project Detail Task Estimate  API
export const ProjectDetail_EstimateURL: string = PMS + "/PDE";
export const ProjectDetail_Estimate_Create = ProjectDetail_EstimateURL + '/Create';
export const ProjectDetail_Estimate_Update = ProjectDetail_EstimateURL + '/Update';
export const ProjectDetail_Estimate_Delete = ProjectDetail_EstimateURL + '/Delete';
export const ProjectDetail_Estimate_ReadAll = ProjectDetail_EstimateURL + '/ReadAll';
export const ProjectDetail_Estimate_ReadById = ProjectDetail_EstimateURL + '/ReadById';
export const ProjectDetail_Estimate_ReadByDetailId = ProjectDetail_EstimateURL + '/ReadByDetailId';
export const ProjectDetail_Estimate_ReadByProjectId = ProjectDetail_EstimateURL + '/ReadByProjectId';
//end region

//region Project Milestone API
export const ProjectMilestone_URL: string = PMS + "/PMS";
export const ProjectMilestoneCreate = ProjectMilestone_URL + '/Create';
export const ProjectMilestoneUpdate = ProjectMilestone_URL + '/Update';
export const ProjectMilestoneDelete = ProjectMilestone_URL + '/Delete';
export const ProjectMilestoneReadAll = ProjectMilestone_URL + '/ReadAll';
export const ProjectMilestoneReadById = ProjectMilestone_URL + '/ReadById';
export const ProjectMilestoneReadByProjectId = ProjectMilestone_URL + '/ReadByProjectId';
export const ProjectMilestoneReadByDetailId = ProjectMilestone_URL + '/ReadByDetailId';
//end region

//region Project PhaseGate API
export const ProjectPhaseGate_URL: string = PMS + "/PDPG";
export const ProjectPhaseGateCreate = ProjectPhaseGate_URL + '/Create';
export const ProjectPhaseGateUpdate = ProjectPhaseGate_URL + '/Update';
export const ProjectPhaseGateDelete = ProjectPhaseGate_URL + '/Delete';
export const ProjectPhaseGateReadAll = ProjectPhaseGate_URL + '/ReadAll';
export const ProjectPhaseGateReadById = ProjectPhaseGate_URL + '/ReadById';
export const ProjectPhaseGateReadByUnlockPGId = ProjectPhaseGate_URL + '/ReadByUnlockPGId';
export const ProjectPhaseGateReadByDetailId = ProjectPhaseGate_URL + '/ReadByDetailId';
export const ProjectPhaseGateReadByProjectId = ProjectPhaseGate_URL + '/ReadByProjectId';
//end region

//region Project Detail Dependency API
export const ProjectDetailDependency_URL: string = PMS + "/PDD";
export const ProjectDetailDependencyCreate = ProjectDetailDependency_URL + '/Create';
export const ProjectDetailDependencyUpdate = ProjectDetailDependency_URL + '/Update';
export const ProjectDetailDependencyDelete = ProjectDetailDependency_URL + '/Delete';
export const ProjectDetailDependencyReadAll = ProjectDetailDependency_URL + '/ReadAll';
export const ProjectDetailDependencyReadById = ProjectDetailDependency_URL + '/ReadById';
export const ProjectDetailDependencyReadByDetailId = ProjectDetailDependency_URL + '/ReadByDetailId';
export const ProjectDetailDependencyReadByDependedOn = ProjectDetailDependency_URL + '/ReadByDependedOn';
export const ProjectDetailDependencyReadByProjectId = ProjectDetailDependency_URL + '/ReadByProjectId';
//end region

//region Project Detail User Mapping Estimate API
export const ProjectDetailUserMappingEstimate_URL: string = PMS + "/PDUM";
export const ProjectDetailUserMappingEstimate_Create = ProjectDetailUserMappingEstimate_URL + '/Create';
export const ProjectDetailUserMappingEstimate_Update = ProjectDetailUserMappingEstimate_URL + '/Update';
export const ProjectDetailUserMappingEstimate_Delete = ProjectDetailUserMappingEstimate_URL + '/Delete';
export const ProjectDetailUserMappingEstimate_ReadAll = ProjectDetailUserMappingEstimate_URL + '/ReadAll';
export const ProjectDetailUserMappingEstimate_ReadById = ProjectDetailUserMappingEstimate_URL + '/ReadById';
export const ProjectDetailUserMappingEstimate_ReadByDetailId = ProjectDetailUserMappingEstimate_URL + '/ReadByDetailId';
export const ProjectDetailUserMappingEstimate_ReadByUserId = ProjectDetailUserMappingEstimate_URL + '/ReadByUserId';
export const ProjectDetailUserMappingEstimate_ReadMyTasks  = ProjectDetailUserMappingEstimate_URL + '/ReadMyTasks';
//endregion

//region Project Detail Cost API
export const ProjectDetailCost_URL: string = PMS + "/PDC";
export const ProjectDetailCost_Create = ProjectDetailCost_URL + '/Create';
export const ProjectDetailCost_Update = ProjectDetailCost_URL + '/Update';
export const ProjectDetailCost_Delete = ProjectDetailCost_URL + '/Delete';
export const ProjectDetailCost_ReadAll = ProjectDetailCost_URL + '/ReadAll';
export const ProjectDetailCost_ReadById = ProjectDetailCost_URL + '/ReadById';
export const ProjectDetailCost_ReadByDetailId = ProjectDetailCost_URL + '/ReadByDetailId';
export const ProjectDetailCost_ReadByProjectId = ProjectDetailCost_URL + '/ReadByProjectId';
//endregion

//region Template Cost API
export const TemplateCost_URL: string = PMS + "/TDC";
export const TemplateCost_Create = TemplateCost_URL + '/Create';
export const TemplateCost_Update = TemplateCost_URL + '/Update';
export const TemplateCost_Delete = TemplateCost_URL + '/Delete';
export const TemplateCost_ReadAll = TemplateCost_URL + '/ReadAll';
export const TemplateCost_ReadById = TemplateCost_URL + '/ReadById';
export const TemplateCost_ReadByDetailId = TemplateCost_URL + '/ReadByDetailId';
export const TemplateCost_ReadByTemplateId = TemplateCost_URL + '/ReadByTemplateId';
//endregion


//region Template Datalist Option API
export const TemplateDatalistOption_URL: string = PMS + "/TDDLO";
export const TemplateDatalistOption_Create = TemplateDatalistOption_URL + '/Create';
export const TemplateDatalistOption_Update = TemplateDatalistOption_URL + '/Update';
export const TemplateDatalistOption_Delete = TemplateDatalistOption_URL + '/Delete';
export const TemplateDatalistOption_ReadAll = TemplateDatalistOption_URL + '/ReadAll';
export const TemplateDatalistOption_ReadById = TemplateDatalistOption_URL + '/ReadById';
export const TemplateDatalistOption_ReadByDatalistId = TemplateDatalistOption_URL + '/ReadByDatalistId';
//endregion

//region Project Datalist Option API
export const ProjectDatalistOption_URL: string = PMS + "/PDDLO";
export const ProjectDatalistOption_Create = ProjectDatalistOption_URL + '/Create';
export const ProjectDatalistOption_Update = ProjectDatalistOption_URL + '/Update';
export const ProjectDatalistOption_Delete = ProjectDatalistOption_URL + '/Delete';
export const ProjectDatalistOption_ReadAll = ProjectDatalistOption_URL + '/ReadAll';
export const ProjectDatalistOption_ReadById = ProjectDatalistOption_URL + '/ReadById';
export const ProjectDatalistOption_ReadByDatalistId = ProjectDatalistOption_URL + '/ReadByDatalistId';
//endregion


//region BI Report Master API
export const BIReportComponent_URL: string = BIR + "/RC";
export const BIReportComponentCreate = BIReportComponent_URL + '/Create';
export const BIReportComponentUpdate = BIReportComponent_URL + '/Update';
export const BIReportComponentDelete = BIReportComponent_URL + '/Delete';
export const BIReportComponentReadAll = BIReportComponent_URL + '/ReadAll';
export const BIReportComponentReadById = BIReportComponent_URL + '/ReadById';
//end region


//region BI Report Master API
export const BIReportMaster_URL: string = BIR + "/RM";
export const BIReportMasterCreate = BIReportMaster_URL + '/Create';
export const BIReportMasterUpdate = BIReportMaster_URL + '/Update';
export const BIReportMasterDelete = BIReportMaster_URL + '/Delete';
export const BIReportMasterReadAll = BIReportMaster_URL + '/ReadAll';
export const BIReportMasterReadById = BIReportMaster_URL + '/ReadById';
export const BIReportMasterReadByCompanyId = BIReportMaster_URL + '/ReadByCompanyId';
//end region


//region BI Report Detail API
export const BIReportDetail_URL: string = BIR + "/RD";
export const BIReportDetailCreate: string = BIReportDetail_URL + '/Create';
export const BIReportDetailUpdate: string = BIReportDetail_URL + '/Update';
export const BIReportDetailDelete: string = BIReportDetail_URL + '/Delete';
export const BIReportDetailReadAll: string = BIReportDetail_URL + '/ReadAll';
export const BIReportDetailReadById: string = BIReportDetail_URL + '/ReadById';
export const BIReportDetailReadByComponentId: string = BIReportDetail_URL + '/ReadByComponentId';
export const BIReportDetailReadByDBConnId: string = BIReportDetail_URL + '/ReadByDBConnId';
export const BIReportDetailReadByReportId: string = BIReportDetail_URL + '/ReadByReportId';
//end region


//region Scheme Master API
export const SchemeMaster_URL: string = ERP + '/SM';
export const SchemeMaster_Create: string = SchemeMaster_URL + '/Create';
export const SchemeMaster_Update = SchemeMaster_URL + '/Update';
export const SchemeMaster_Delete = SchemeMaster_URL + '/Delete';
export const SchemeMaster_ReadById = SchemeMaster_URL + '/ReadById';
export const SchemeMaster_ReadByIndId = SchemeMaster_URL + '/ReadByIndId';
export const SchemeMaster_ReadByTenantId = SchemeMaster_URL + '/ReadByTenantId';
export const SchemeMaster_ReadAll = SchemeMaster_URL + '/ReadAll';
export const SchemeMaster_ReadAllPaginated = SchemeMaster_URL + '/ReadAllPaginated'
//end region

//region Scheme Detail API
export const SchemeDetail_URL: string = ERP + '/SD';
export const SchemeDetail_Create = SchemeDetail_URL + '/Create';
export const SchemeDetail_Update = SchemeDetail_URL + '/Update';
export const SchemeDetail_Delete = SchemeDetail_URL + '/Delete';
export const SchemeDetail_ReadById = SchemeDetail_URL + '/ReadById';
export const SchemeDetail_ReadBySchemeId = SchemeDetail_URL + '/ReadBySchemeId';
export const SchemeDetail_ReadAll = SchemeDetail_URL + '/ReadAll';
export const SchemeDetail_ReadAllPaginated = SchemeDetail_URL + '/ReadAllPaginated';
//end region

//region Vechile Master API
export const VehicleMaster_URL: string = ERP + '/VA';
export const VehicleMaster_Create = VehicleMaster_URL + '/Create';
export const VehicleMaster_Update = VehicleMaster_URL + '/Update';
export const VehicleMaster_Delete = VehicleMaster_URL + '/Delete';
export const VehicleMaster_ReadById = VehicleMaster_URL + '/ReadById';
export const VehicleMaster_ReadAll = VehicleMaster_URL + '/ReadAll';
//endRegion

//region Vehicle Route Master API (HPGM voyage)
export const VehicleRouteMaster_URL: string = ERP + '/VRM';
export const VehicleRouteMaster_Create = VehicleRouteMaster_URL + '/Create';
export const VehicleRouteMaster_Update = VehicleRouteMaster_URL + '/Update';
export const VehicleRouteMaster_Delete = VehicleRouteMaster_URL + '/Delete';
export const VehicleRouteMaster_ReadById = VehicleRouteMaster_URL + '/ReadById';
export const VehicleRouteMaster_ReadByTenantId = VehicleRouteMaster_URL + '/ReadByTenantId';
//endRegion

//region Vehicle Route Detail API (HPGM voyage POD rows)
export const VehicleRouteDetail_URL: string = ERP + '/VRD';
export const VehicleRouteDetail_Create = VehicleRouteDetail_URL + '/Create';
export const VehicleRouteDetail_Update = VehicleRouteDetail_URL + '/Update';
export const VehicleRouteDetail_Delete = VehicleRouteDetail_URL + '/Delete';
export const VehicleRouteDetail_ReadById = VehicleRouteDetail_URL + '/ReadById';
export const VehicleRouteDetail_ReadByRouteId = VehicleRouteDetail_URL + '/ReadByRouteId';
//endRegion

//region ObjectConfigMaster API
export const ObjectConfigMaster_URL: string = AdvinMaster + '/OCM';
export const ObjectConfigMaster_Create = ObjectConfigMaster_URL + '/Create';
export const ObjectConfigMaster_Update = ObjectConfigMaster_URL + '/Update';
export const ObjectConfigMaster_Delete = ObjectConfigMaster_URL + '/Delete';
export const ObjectConfigMaster_ReadAll = ObjectConfigMaster_URL + '/ReadAll';
export const ObjectConfigMaster_ReadById = ObjectConfigMaster_URL + '/ReadById';
export const ObjectConfigMaster_ReadByMenuId = ObjectConfigMaster_URL + '/ReadByMenuId';
//endRegion

//region CompanyPageConfig API
export const CompanyPageConfig_URL: string = AdvinMaster + '/CPC';
export const CompanyPageConfig_Create = CompanyPageConfig_URL + '/Create';
export const CompanyPageConfig_Update = CompanyPageConfig_URL + '/Update';
export const CompanyPageConfig_Delete = CompanyPageConfig_URL + '/Delete';
export const CompanyPageConfig_ReadAll = CompanyPageConfig_URL + '/ReadAll';
export const CompanyPageConfig_ReadById = CompanyPageConfig_URL + '/ReadById';
export const CompanyPageConfig_ReadByTenantId  = CompanyPageConfig_URL + '/ReadByTenantId';
//endRegion

//region SmsTemplate API
export const SmsTemplate_URL: string = Notification + '/SMST';
export const SmsTemplate_Create = SmsTemplate_URL + '/Create';
export const SmsTemplate_Update = SmsTemplate_URL + '/Update';
export const SmsTemplate_ReadById = SmsTemplate_URL + '/ReadById';
export const SmsTemplate_Delete = SmsTemplate_URL + '/Delete';
export const SmsTemplate_ReadByTenantId = SmsTemplate_URL + '/ReadByTenantId';
export const SmsTemplate_ReadAll = SmsTemplate_URL + '/ReadAll';
//endRegion

//region AI APIS
export const OpenAI_URL: string = AI + '/OA/GPT'
export const AskGPT = OpenAI_URL + '/AskChatGPT';
export const SmsTemplate_ReadAllPaginated = SmsTemplate_URL + '/ReadAllPaginated';
//endRegion

//region WhatsappTemplate API
export const WhatsappTemplate_URL: string = Notification + '/WAT';
export const WhatsappTemplate_Create = WhatsappTemplate_URL + '/Create';
export const WhatsappTemplate_Delete = WhatsappTemplate_URL + '/Delete';
export const WhatsappTemplate_ReadAllMetaTemplates = WhatsappTemplate_URL + '/ReadAllMetaTemplates';


//endRegion

//region ObjectConfigMapping APIS
export const ObjectConfigMapping_URL: string = AdvinMaster + '/OCMP';
export const ObjectConfigMapping_Create: string = ObjectConfigMapping_URL + '/Create';
export const ObjectConfigMapping_Update: string = ObjectConfigMapping_URL + '/Update';
export const ObjectConfigMapping_Delete: string = ObjectConfigMapping_URL + '/Delete';
export const ObjectConfigMapping_ReadAll: string = ObjectConfigMapping_URL + '/ReadAll';
export const ObjectConfigMapping_ReadById: string = ObjectConfigMapping_URL + '/ReadById';
export const ObjectConfigMapping_ReadByCompanyId: string = ObjectConfigMapping_URL + '/ReadByCompanyId';
export const ObjectConfigMapping_ReadByObjectId: string = ObjectConfigMapping_URL + '/ReadByObjectId';
export const ObjectConfigMapping_ReadByMenuId: string = ObjectConfigMapping_URL + '/ReadByMenuId';
export const ObjectConfigMapping_ReadByMenuCode: string = ObjectConfigMapping_URL + '/ReadByMenuCode'
//endRegion

//region SalesInvoiceOtherCharges APIS
export const SalesInvoiceOtherChargesMasterURL: string = Billing + '/SOC'
export const SalesInvoiceOtherCharges_create = SalesInvoiceOtherChargesMasterURL + "/Create";
export const SalesInvoiceOtherCharges_update = SalesInvoiceOtherChargesMasterURL + "/Update";
export const SalesInvoiceOtherCharges_delete = SalesInvoiceOtherChargesMasterURL + "/Delete";
export const SalesInvoiceOtherCharges_readById = SalesInvoiceOtherChargesMasterURL + "/ReadById";
export const SalesInvoiceOtherCharges_readByInvoiceId = SalesInvoiceOtherChargesMasterURL + "/ReadByInvoiceId";
export const SalesInvoiceOtherCharges_readAll = SalesInvoiceOtherChargesMasterURL + "/ReadAll";
//endRegion

//region DevOps = Team API
export const TeamMasterURL: string = DevOps + '/TM'
export const TeamMaster_Create = TeamMasterURL + "/Create";
export const TeamMaster_Update = TeamMasterURL + "/Update";
export const TeamMaster_Delete = TeamMasterURL + "/Delete";
export const TeamMaster_ReadById = TeamMasterURL + "/ReadById";
export const TeamMaster_ReadByCompanyId = TeamMasterURL + "/ReadByCompanyId";
export const TeamMaster_ReadAll = TeamMasterURL + "/ReadAll";
export const TeamMaster_ReadAllPaginated = TeamMasterURL + "/ReadAllPaginated";
//endRegion

//region DevOps = Team Detail API
export const TeamDetailURL: string = DevOps + '/TD'
export const TeamDetail_Create = TeamDetailURL + "/Create";
export const TeamDetail_Update = TeamDetailURL + "/Update";
export const TeamDetail_Delete = TeamDetailURL + "/Delete";
export const TeamDetail_ReadById = TeamDetailURL + "/ReadById";
export const TeamDetail_ReadByTeamId = TeamDetailURL + "/ReadByTeamId";
export const TeamDetail_ReadAll = TeamDetailURL + "/ReadAll";
//endRegion

//region DevOps = TeamBacklog Detail API
export const TeamBacklogURL: string = DevOps + '/TBL'
export const TeamBacklog_Create = TeamBacklogURL + "/Create";
export const TeamBacklog_Update = TeamBacklogURL + "/Update";
export const TeamBacklog_Delete = TeamBacklogURL + "/Delete";
export const TeamBacklog_ReadById = TeamBacklogURL + "/ReadById";
export const TeamBacklog_ReadByTeamId = TeamBacklogURL + "/ReadByTeamId";
export const TeamBacklog_ReadAll = TeamBacklogURL + "/ReadAll";
export const TeamBacklog_ReadByCompanyId = TeamBacklogURL + "/ReadByCompanyId";
export const TeamBacklog_ReadByProjectId = TeamBacklogURL + "/ReadByProjectId";
export const TeamBacklog_ReadAllPaginated = TeamBacklogURL + "/ReadAllPaginated";
//endRegion

//#region PmsPrint API
export const PmsPrintURL: string = AdvinMaster + '/PRM';
export const PmsPrint_Create = PmsPrintURL + '/Create';
export const PmsPrint_Update = PmsPrintURL + '/Update';
export const PmsPrint_Delete = PmsPrintURL + '/Delete';
export const PmsPrint_ReadAll = PmsPrintURL + '/ReadAll';
export const PmsPrint_ReadById = PmsPrintURL + '/ReadById';
export const PmsPrint_ReadByCompanyId = PmsPrintURL + '/ReadByCompanyId';
export const PmsPrint_ReadByMasterId = PmsPrintURL + '/ReadByMasterId';
export const PmsPrint_ReadByTemplateId = PmsPrintURL + '/ReadByTemplateId';
//#endregion

//region DevOps = BacklogTask API
export const BacklogTaskURL: string = DevOps + '/BLT'
export const BacklogTask_Create = BacklogTaskURL + "/Create";
export const BacklogTask_Update = BacklogTaskURL + "/Update";
export const BacklogTask_Delete = BacklogTaskURL + "/Delete";
export const BacklogTask_ReadAll = BacklogTaskURL + "/ReadAll";
export const BacklogTask_ReadById = BacklogTaskURL + "/ReadById";
export const BacklogTask_ReadByBacklogId = BacklogTaskURL + "/ReadByBacklogId";
//endRegion

//region DevOps = BacklogDiscussion API
export const BacklogDiscussionURL: string = DevOps + '/BLT'
export const BacklogDiscussion_Create = BacklogDiscussionURL + "/Create";
export const BacklogDiscussion_Update = BacklogDiscussionURL + "/Update";
export const BacklogDiscussion_Delete = BacklogDiscussionURL + "/Delete";
export const BacklogDiscussion_ReadAll = BacklogDiscussionURL + "/ReadAll";
export const BacklogDiscussion_ReadById = BacklogDiscussionURL + "/ReadById";
export const BacklogDiscussion_ReadByBacklogId = BacklogDiscussionURL + "/ReadByBacklogId";
//endRegion

//#region PmsPrint API
export const CustomHtmlMasterURL: string = AdvinMaster + '/CUS';
export const CustomHtmlMaster_Create = CustomHtmlMasterURL + '/Create';
export const CustomHtmlMaster_Update = CustomHtmlMasterURL + '/Update';
export const CustomHtmlMaster_Delete = CustomHtmlMasterURL + '/Delete';
export const CustomHtmlMaster_ReadAll = CustomHtmlMasterURL + '/ReadAll';
export const CustomHtmlMaster_ReadById = CustomHtmlMasterURL + '/ReadById';
export const CustomHtmlMaster_ReadByTenantId = CustomHtmlMasterURL + '/ReadByTenantId';
export const CustomHtmlMaster_ReadByMasterId = CustomHtmlMasterURL + '/ReadByMasterId';
export const CustomHtmlMaster_ReadByTemplateId = CustomHtmlMasterURL + '/ReadByTemplateId';
export const CustomHtmlMaster_ReadAllPaginated = CustomHtmlMasterURL + '/ReadAllPaginated';
export const CustomHtmlMaster_ReadByParentDivId = CustomHtmlMasterURL + '/ReadByParentDivId';
//#endregion

//#region Payroll - Component API
export const Payroll_ComponentURL: string = Payroll + '/CN';
export const Payroll_Component_Create = Payroll_ComponentURL + '/Create';
export const Payroll_Component_Update = Payroll_ComponentURL + '/Update';
export const Payroll_Component_Delete = Payroll_ComponentURL + '/Delete';
export const Payroll_Component_ReadAll = Payroll_ComponentURL + '/ReadAll';
export const Payroll_Component_ReadById = Payroll_ComponentURL + '/ReadById';
export const Payroll_Component_ReadByTenantId = Payroll_ComponentURL + '/ReadByTenantId';
//#endRegion

//#region EmployeePackage API
export const EmployeePackageURL: string = Payroll + '/EP';
export const Employee_Package_Create = EmployeePackageURL + '/Create';
export const Employee_Package_Update = EmployeePackageURL + '/Update';
export const Employee_Package_Delete = EmployeePackageURL + '/Delete';
export const Employee_Package_ReadById = EmployeePackageURL + '/ReadById';
export const Employee_Package_ReadAll = EmployeePackageURL + '/ReadAll';
export const Employee_Package_ReadByTenantId = EmployeePackageURL + '/ReadByTenantId';
export const Employee_Package_ReadByEmployeeId = EmployeePackageURL + '/ReadByEmployeeId';
//#endregion

//#region PackageDetail API
export const PackageDetailURL: string = Payroll + '/PD';
export const Package_Detail_Create = PackageDetailURL + '/Create';
export const Package_Detail_Update = PackageDetailURL + '/Update';
export const Package_Detail_Delete = PackageDetailURL + '/Delete';
export const Package_Detail_ReadById = PackageDetailURL + '/ReadById';
export const Package_Detail_ReadAll = PackageDetailURL + '/ReadAll';
export const Package_Detail_ReadByPackageId = PackageDetailURL + '/ReadByPackageId';
export const Package_Detail_ReadByComponentId = PackageDetailURL + '/ReadByComponentId';
//#endregion

//#region PackageMaster API
export const PackageMasterURL: string = Payroll + '/PM';
export const Package_Master_Create = PackageMasterURL + '/Create';
export const Package_Master_Update = PackageMasterURL + '/Update';
export const Package_Master_Delete = PackageMasterURL + '/Delete';
export const Package_Master_ReadById = PackageMasterURL + '/ReadById';
export const Package_Master_ReadAll = PackageMasterURL + '/ReadAll';
export const Package_Master_ReadByDesignationId = PackageMasterURL + '/ReadByDesignationId';
export const Package_Master_ReadByTenantId = PackageMasterURL + '/ReadByTenantId';
//#endregion

//#region Shift Master  API
export const ShiftMasterURL: string = HRMS + '/SM';
export const ShiftMaster_Create = ShiftMasterURL + '/Create';
export const ShiftMaster_Update = ShiftMasterURL + '/Update';
export const ShiftMaster_Delete = ShiftMasterURL + '/Delete';
export const ShiftMaster_ReadAll = ShiftMasterURL + '/ReadAll';
export const ShiftMaster_ReadById = ShiftMasterURL + '/ReadById';
export const ShiftMaster_ReadByTenantId = ShiftMasterURL + '/ReadByTenantId';


//#region Shift Detail API
export const ShiftDetailURL: string = HRMS + '/SD';
export const ShiftDetail_Create = ShiftDetailURL + '/Create';
export const ShiftDetail_Update = ShiftDetailURL + '/Update';
export const ShiftDetail_Delete = ShiftDetailURL + '/Delete';
export const ShiftDetail_ReadAll = ShiftDetailURL + '/ReadAll';
export const ShiftDetail_ReadById = ShiftDetailURL + '/ReadById';
export const ShiftDetail_ReadByShiftId = ShiftDetailURL + '/ReadByShiftId';



//#region Item Stock API
export const ItemStockURL: string = Products + '/IS';
export const ItemStock_Create = ItemStockURL + '/Create';
export const ItemStock_Update = ItemStockURL + '/Update';
export const ItemStock_Delete = ItemStockURL + '/Delete';
export const ItemStock_ReadAll = ItemStockURL + '/ReadAll';
export const ItemStock_ReadById = ItemStockURL + '/ReadById';
export const ItemStock_ReadByItemId = ItemStockURL + '/ReadByItemId';
export const ItemStock_ReadByTenantId = ItemStockURL + '/ReadByTenantId';
export const ItemStock_GetDetailOverview = ItemStockURL + '/GetDetailOverview';
export const ItemStock_GetLedgerPaginated = ItemStockURL + '/GetLedgerPaginated';
export const ItemStock_GetChartData = ItemStockURL + '/GetChartData';
//#endregion



//region MS Sales Detail
export const MSItemSalesDetailURL: string = ERP + '/MSD'
export const MSItemSalesDetail_Create = MSItemSalesDetailURL + "/Create";
export const MSItemSalesDetail_Update = MSItemSalesDetailURL + "/Update";
export const MSItemSalesDetail_Delete = MSItemSalesDetailURL + "/Delete";
export const MSItemSalesDetail_ReadById = MSItemSalesDetailURL + "/ReadById";
export const MSItemSalesDetail_ReadAll = MSItemSalesDetailURL + "/ReadAll";
export const MSItemSalesDetail_ReadByInvoiceId = MSItemSalesDetailURL + "/ReadByInvoiceId";
export const MSItemSalesDetail_ReadByItemId = MSItemSalesDetailURL + "/ReadByItemId";
export const MSItemSalesDetail_ReadByMrpId = MSItemSalesDetailURL + "/ReadByMrpId";
export const MSItemSalesDetail_ReadByPriceId = MSItemSalesDetailURL + "/ReadByPriceId";
//endRegion

//Credit Note Other charges
export const CreditNoteOtherChargesURL: string = Billing + '/CNOC';
export const CreditNoteOtherCharges_create = CreditNoteOtherChargesURL + "/Create";
export const CreditNoteOtherCharges_update = CreditNoteOtherChargesURL + "/Update";
export const CreditNoteOtherCharges_delete = CreditNoteOtherChargesURL + "/Delete";
export const CreditNoteOtherCharges_readById = CreditNoteOtherChargesURL + "/ReadById";
export const CreditNoteOtherCharges_readByCreditNoteId = CreditNoteOtherChargesURL + "/ReadByCreditNoteId";
export const CreditNoteOtherCharges_readAll = CreditNoteOtherChargesURL + "/ReadAll";
//endRegion

//Debit Note Other Charges
export const DebitNoteOtherChargesURL: string = Billing + '/DNOC';
export const DebitNoteOtherCharges_create = DebitNoteOtherChargesURL + "/Create";
export const DebitNoteOtherCharges_update = DebitNoteOtherChargesURL + "/Update";
export const DebitNoteOtherCharges_delete = DebitNoteOtherChargesURL + "/Delete";
export const DebitNoteOtherCharges_readById = DebitNoteOtherChargesURL + "/ReadById";
export const DebitNoteOtherCharges_readByDebitNoteId = DebitNoteOtherChargesURL + "/ReadByDebitNoteId";
export const DebitNoteOtherCharges_readAll = DebitNoteOtherChargesURL + "/ReadAll";
//endRegion

//region Service/Item Detail 
export const ItemDetailDatalistURL: string = Products + '/IDD';
export const ItemDetailDatalist_Create = ItemDetailDatalistURL + "/Create";
export const ItemDetailDatalist_Update = ItemDetailDatalistURL + "/Update";
export const ItemDetailDatalist_Delete = ItemDetailDatalistURL + "/Delete";
export const ItemDetailDatalist_ReadById = ItemDetailDatalistURL + "/ReadById";
export const ItemDetailDatalist_ReadByItemId = ItemDetailDatalistURL + "/ReadByItemId";
export const ItemDetailDatalist_ReadAll = ItemDetailDatalistURL + "/ReadAll";
export const ItemDetailDatalist_CreateBulk = ItemDetailDatalistURL + "/CreateBulk";
//endregion

//region Facebook Integration API
export const IndentMasterURL: string = Billing + '/PIM';
export const IndentMaster_Create = IndentMasterURL + '/Create';
export const IndentMaster_Update = IndentMasterURL + '/Update';
export const IndentMaster_Delete = IndentMasterURL + '/Delete';
export const IndentMaster_ReadAll = IndentMasterURL + '/ReadAll';
export const IndentMaster_ReadById = IndentMasterURL + '/ReadById';
export const IndentMaster_ReadByTenantId = IndentMasterURL + '/ReadByTenantId';
export const IndentMaster_SearchByPurIndentNo = IndentMasterURL + '/SearchByPurIndentNo';
export const IndentMaster_GetAvailableIndent = IndentMasterURL + '/GetAvailableIndent';
export const IndentMaster_GetVendorPendingForPO = IndentMasterURL + '/GetVendorPendingForPO';
export const IndentMaster_ReadByMasterId = IndentMasterURL + '/ReadByMasterId';

//endregion

//region Facebook Integration API
export const IndentDetailURL: string = Billing + '/PID';
export const IndentDetail_Create = IndentDetailURL + '/Create';
export const IndentDetail_Update = IndentDetailURL + '/Update';
export const IndentDetail_Delete = IndentDetailURL + '/Delete';
export const IndentDetail_ReadAll = IndentDetailURL + '/ReadAll';
export const IndentDetail_ReadById = IndentDetailURL + '/ReadById';
export const IndentDetail_ReadByIndentId = IndentDetailURL + '/ReadByIndentId';
export const IndentDetail_ReadByItemId = IndentDetailURL + '/ReadByItemId';
export const IndentDetail_ReadByVendorId = IndentDetailURL + '/ReadByVendorId';
export const IndentDetail_ReadByIndentIdForImport = IndentDetailURL + '/ReadByIndentIdForImport';
export const IndentDetail_ReadByIndentAndVendor = IndentDetailURL + '/ReadByIndentAndVendor';
export const IndentDetail_CreateBulk = IndentDetailURL + '/CreateBulk';
export const IndentDetail_UpsertBulk = IndentDetailURL + '/UpsertBulk';
//endregion

//region Indent Master Detail View API
export const IndentMasterDetailViewURL: string = Billing + '/PIMDV';
export const IndentMasterDetailView_ReadByCompanyId = IndentMasterDetailViewURL + '/ReadByCompanyId';
export const IndentMasterDetailView_ReadById = IndentMasterDetailViewURL + '/ReadById';
//endregion



//region Facebook Integration API
export const EPC_FacebookURL: string = EPC + '/FB/FC';
export const EPC_FacebookConfig_Create = EPC_FacebookURL + '/Create';
export const EPC_FacebookConfig_Register = EPC_FacebookURL + '/Register';
export const EPC_FacebookConfig_Update = EPC_FacebookURL + '/Update';
export const EPC_FacebookConfig_Delete = EPC_FacebookURL + '/Delete';
export const EPC_FacebookConfig_ReadAll = EPC_FacebookURL + '/ReadAll';
export const EPC_FacebookConfig_ReadById = EPC_FacebookURL + '/ReadById';
export const EPC_FacebookConfig_ReadByTenantId = EPC_FacebookURL + '/ReadByTenantId';
export const EPC_FacebookConfig_Dashboard = EPC_FacebookURL + '/Dashboard';
export const EPC_FacebookConfig_SyncAllLeads = EPC_FacebookURL + '/SyncAllLeads';
//endregion


//region ItemVendorPrice API
export const ItemVendorPriceURL: string = Billing + '/ITVP';
export const ItemVendorPrice_Create = ItemVendorPriceURL + '/Create';
export const ItemVendorPrice_Upsert = ItemVendorPriceURL + '/Upsert';
export const ItemVendorPrice_Update = ItemVendorPriceURL + '/Update';
export const ItemVendorPrice_Delete = ItemVendorPriceURL + '/Delete';
export const ItemVendorPrice_ReadAll = ItemVendorPriceURL + '/ReadAll';
export const ItemVendorPrice_ReadById = ItemVendorPriceURL + '/ReadById';
export const ItemVendorPrice_ReadByItemId = ItemVendorPriceURL + '/ReadByItemId';
export const ItemVendorPrice_ReadByVendorId = ItemVendorPriceURL + '/ReadByVendorId';
export const ItemVendorPrice_ReadPriceHistory = ItemVendorPriceURL + '/ReadPriceHistory';
//endregion


//#region EmployeeShiftMapping API
export const EmployeeShiftMappingURL: string = HRMS + '/ESM';
export const EmployeeShiftMapping_Create = EmployeeShiftMappingURL + '/Create';
export const EmployeeShiftMapping_Update = EmployeeShiftMappingURL + '/Update';
export const EmployeeShiftMapping_Delete = EmployeeShiftMappingURL + '/Delete';
export const EmployeeShiftMapping_ReadAll = EmployeeShiftMappingURL + '/ReadAll';
export const EmployeeShiftMapping_ReadById = EmployeeShiftMappingURL + '/ReadById';
export const EmployeeShiftMapping_ReadByEmployeeId = EmployeeShiftMappingURL + '/ReadByEmployeeId';
export const EmployeeShiftMapping_ReadByShiftId = EmployeeShiftMappingURL + '/ReadByShiftId';
export const EmployeeShiftMapping_UpsertBulk = EmployeeShiftMappingURL + '/UpsertBulk';
export const EmployeeShiftMapping_ReadEmployeesForAssign = EmployeeShiftMappingURL + '/ReadEmployeesForAssign';
//#endregion


//#region DepotMaster API
export const DepotMasterURL: string = ERP + '/DM';
export const DepotMaster_Create = DepotMasterURL + '/Create';
export const DepotMaster_Update = DepotMasterURL + '/Update';
export const DepotMaster_Delete = DepotMasterURL + '/Delete';
export const DepotMaster_ReadbyId = DepotMasterURL + '/ReadById';
export const DepotMaster_ReadAll = DepotMasterURL + '/ReadAll';
export const DepotMaster_ReadAllPaginated = DepotMasterURL + '/ReadAllPaginated';
export const DepotMaster_ReadByTenant = DepotMasterURL + '/ReadByTenant';
export const DepotMaster_CreateBulk = DepotMasterURL + '/CreateBulk';
//#endregion

//#region EmployeeShiftMapping API
export const StorageMaster_URL: string = Warehouse + '/SM';
export const StorageMaster__Create = StorageMaster_URL + '/Create';
export const StorageMaster__Update = StorageMaster_URL + '/Update';
export const StorageMaster__Delete = StorageMaster_URL + '/Delete';
export const StorageMaster__ReadAll = StorageMaster_URL + '/ReadAll';
export const StorageMaster__ReadById = StorageMaster_URL + '/ReadById';
export const StorageMaster__ReadByTenantId = StorageMaster_URL + '/ReadByTenantId';
export const StorageMaster__ReadByEmployeeId = StorageMaster_URL + '/ReadByEmployeeId';
export const StorageMaster__ReadByShiftId = StorageMaster_URL + '/ReadByShiftId';
//#endregion

//#region MeetingMaster API
export const MeetingsMaster: string = ERP + '/MM'
export const MeetingsMaster_create = MeetingsMaster + '/Create'
export const MeetingsMaster_update = MeetingsMaster + '/Update'
export const MeetingsMaster_delete = MeetingsMaster + '/Delete'
export const MeetingsMaster_readById = MeetingsMaster + '/ReadById'
export const MeetingsMaster_readAll = MeetingsMaster + '/ReadAll'
export const MeetingsMaster_readByMasterId = MeetingsMaster + '/ReadByMasterId'
//#endregion

//#region MeetingDetail API
export const MeetingsDetail: String = ERP + '/MD'
export const MeetingsDetail_create = MeetingsDetail + '/Create'
export const MeetingsDetail_createBulk = MeetingsDetail + '/CreateBulk'
export const MeetingsDetail_update = MeetingsDetail + '/Update'
export const MeetingsDetail_delete = MeetingsDetail + '/Delete'
export const MeetingsDetail_readbyId = MeetingsDetail + '/ReadById'
export const MeetingsDetail_readall = MeetingsDetail + '/ReadAll'
export const MeetingsDetail_readbyMeetingId = MeetingsDetail + '/ReadByMeetingId'
//#endregion



//#region External Integration EWayEInvoice API
const EWayEInvoiceURL: string = ExternalIntegration + '/EWEI'
export const EWayEInvoice_Generate: string = EWayEInvoiceURL + '/Generate';
export const EWayEInvoice_GetRawInvoiceDetails: string = EWayEInvoiceURL + '/GetRawEInvoiceDetails';
export const EWayEInvoice_GetEInvoiceByInvoiceId: string = EWayEInvoiceURL + '/GetEInvoiceByInvoiceId';
export const EWayEInvoice_ReadAllPaginated: string = EWayEInvoiceURL + '/ReadAllPaginated';
export const EWayEInvoice_GenerateEWayBillByIRN: string = EWayEInvoiceURL + '/GenerateEWayBillByIRN';
//#endregion

//region Discussion API
export const Discussion = ERP + '/DCM';
export const Discussion_Create = Discussion + '/Create';
export const Discussion_Update = Discussion + '/Update';
export const Discussion_Delete = Discussion + '/Delete';
export const Discussion_ReadById = Discussion + '/ReadById';
export const Discussion_ReadByMasterId = Discussion + '/ReadByMasterId';
//#endregion

//region Item Planning Master API
export const ItemPlanningMasterURL: string = Products + '/IPM';
export const ItemPlanningMaster_Create = ItemPlanningMasterURL + '/Create';
export const ItemPlanningMaster_Update = ItemPlanningMasterURL + '/Update';
export const ItemPlanningMaster_Delete = ItemPlanningMasterURL + '/Delete';
export const ItemPlanningMaster_ReadById = ItemPlanningMasterURL + '/ReadById';
export const ItemPlanningMaster_ReadAll = ItemPlanningMasterURL + '/ReadAll';
export const ItemPlanningMaster_ReadByItemId = ItemPlanningMasterURL + '/ReadByItemId';
//endregion


//region Item Planning Detail API
export const ItemPlanningDetailURL: string = Products + '/IPD';
export const ItemPlanningDetail_Create = ItemPlanningDetailURL + '/Create';
export const ItemPlanningDetail_Update = ItemPlanningDetailURL + '/Update';
export const ItemPlanningDetail_Delete = ItemPlanningDetailURL + '/Delete';
export const ItemPlanningDetail_ReadById = ItemPlanningDetailURL + '/ReadById';
export const ItemPlanningDetail_ReadByMasterId = ItemPlanningDetailURL + '/ReadByMasterId';
export const ItemPlanningDetail_ReadAll = ItemPlanningDetailURL + '/ReadAll';
//endregion

//region Item Material Planning API
export const ItemMaterialPlanningURL: string = Products + '/IMP';
export const ItemMaterialPlanning_Create = ItemMaterialPlanningURL + '/Create';
export const ItemMaterialPlanning_Update = ItemMaterialPlanningURL + '/Update';
export const ItemMaterialPlanning_Delete = ItemMaterialPlanningURL + '/Delete';
export const ItemMaterialPlanning_ReadById = ItemMaterialPlanningURL + '/ReadById';
export const ItemMaterialPlanning_ReadAll = ItemMaterialPlanningURL + '/ReadAll';
export const ItemMaterialPlanning_ReadByItemId = ItemMaterialPlanningURL + '/ReadByItemId';
export const ItemMaterialPlanning_ReadByPlanId = ItemMaterialPlanningURL + '/ReadByPlanId';
//#endregion


//region Item Process Planning API
export const ItemProcessPlanningURL: string = Products + '/IPP';
export const ItemProcessPlanning_Create = ItemProcessPlanningURL + '/Create';
export const ItemProcessPlanning_Update = ItemProcessPlanningURL + '/Update';
export const ItemProcessPlanning_Delete = ItemProcessPlanningURL + '/Delete';
export const ItemProcessPlanning_ReadById = ItemProcessPlanningURL + '/ReadById';
export const ItemProcessPlanning_ReadAll = ItemProcessPlanningURL + '/ReadAll';
export const ItemProcessPlanning_ReadByPlanId = ItemProcessPlanningURL + '/ReadByPlanId';
//#region Item Process Planning API

// #region Pending AMC API
export const PendingAmc_URL: string = Billing +  '/AP';
export const PendingAmc_Create = PendingAmc_URL + '/Create';
export const PendingAmc_Update = PendingAmc_URL + '/Update';
export const PendingAmc_Delete = PendingAmc_URL + '/Delete';
export const PendingAmc_ReadById = PendingAmc_URL + '/ReadById';
export const PendingAmc_ReadAll = PendingAmc_URL + '/ReadAll';
export const PendingAmc_CreateInvoice = PendingAmc_URL + '/CreateInvoice';
export const PendingAmc_UpdateStatus = PendingAmc_URL + '/UpdateStatus';
// #endregion

//region VendorDefaultOtherCharges API
export const VendorDefaultOtherChargesURL: string = Billing + '/VDOC';
export const VendorDefaultOtherCharges_Create = VendorDefaultOtherChargesURL + '/Create';
export const VendorDefaultOtherCharges_Update = VendorDefaultOtherChargesURL + '/Update';
export const VendorDefaultOtherCharges_Delete = VendorDefaultOtherChargesURL + '/Delete';
export const VendorDefaultOtherCharges_ReadAll = VendorDefaultOtherChargesURL + '/ReadAll';
export const VendorDefaultOtherCharges_ReadById = VendorDefaultOtherChargesURL + '/ReadById';
export const VendorDefaultOtherCharges_ReadByVendorId = VendorDefaultOtherChargesURL + '/ReadByVendorId';
export const VendorDefaultOtherCharges_ReadByTenantId = VendorDefaultOtherChargesURL + '/ReadByTenantId';
//endregion


//region TenantDefaultOtherCharges API
export const TenantDefaultOtherChargesURL: string = Billing + '/TDOC';
export const TenantDefaultOtherCharges_Create = TenantDefaultOtherChargesURL + '/Create';
export const TenantDefaultOtherCharges_Update = TenantDefaultOtherChargesURL + '/Update';
export const TenantDefaultOtherCharges_Delete = TenantDefaultOtherChargesURL + '/Delete';
export const TenantDefaultOtherCharges_ReadAll = TenantDefaultOtherChargesURL + '/ReadAll';
export const TenantDefaultOtherCharges_ReadById = TenantDefaultOtherChargesURL + '/ReadById';
export const TenantDefaultOtherCharges_ReadByTenantId = TenantDefaultOtherChargesURL + '/ReadByTenantId';
//endregion

//region TenantValidationMaster API
export const TenantValidationMasterURL: string = AdvinMaster + '/TVM';
export const TenantValidationMaster_Create = TenantValidationMasterURL + '/Create';
export const TenantValidationMaster_Update = TenantValidationMasterURL + '/Update';
export const TenantValidationMaster_Delete = TenantValidationMasterURL + '/Delete';
export const TenantValidationMaster_ReadAll = TenantValidationMasterURL + '/ReadAll';
export const TenantValidationMaster_ReadById = TenantValidationMasterURL + '/ReadById';
export const TenantValidationMaster_ReadByTenantId = TenantValidationMasterURL + '/ReadByTenantId';
export const TenantValidationMaster_ReadAllPaginated = TenantValidationMasterURL + '/ReadAllPaginated';
//endregion

//region SalesIndentMaster API 
export const SalesIndentMasterURL: string = Billing + '/SIM';
export const SalesIndentMaster_Create = SalesIndentMasterURL + '/Create';
export const SalesIndentMaster_Update = SalesIndentMasterURL + '/Update';
export const SalesIndentMaster_Delete = SalesIndentMasterURL + '/Delete';
export const SalesIndentMaster_ReadAll = SalesIndentMasterURL + '/ReadAll';
export const SalesIndentMaster_ReadById = SalesIndentMasterURL + '/ReadById';
export const SalesIndentMaster_ReadByTenantId = SalesIndentMasterURL + '/ReadByTenantId';
export const SalesIndentMaster_SearchByIndentNo = SalesIndentMasterURL + '/SearchByIndentNo';
//endregion

//region SalesIndentMaster API 
export const SalesIndentDetailURL: string = Billing + '/SID';
export const SalesIndentDetail_Create = SalesIndentDetailURL + '/Create';
export const SalesIndentDetail_Update = SalesIndentDetailURL + '/Update';
export const SalesIndentDetail_Delete = SalesIndentDetailURL + '/Delete';
export const SalesIndentDetail_ReadAll = SalesIndentDetailURL + '/ReadAll';
export const SalesIndentDetail_ReadById = SalesIndentDetailURL + '/ReadById';
export const SalesIndentDetail_ReadByIndentId = SalesIndentDetailURL + '/ReadByIndentId';
export const SalesIndentDetail_ReadByVendorId = SalesIndentDetailURL + '/ReadByVendorId';
export const SalesIndentDetail_ReadByIndentIdForReport = SalesIndentDetailURL + '/ReadByIndentIdForReport';
export const SalesIndentDetail_ReadByIndentAndVendor = SalesIndentDetailURL + '/ReadByIndentAndVendor';
export const SalesIndentDetail_ReadByIndentIdForImport = SalesIndentDetailURL + '/ReadByIndentIdForImport';
export const SalesIndentDetail_UpsertBulk = SalesIndentDetailURL + '/UpsertBulk';
//endregion

// region SalesIndentOtherCharges API
export const SalesIndentOtherChargesURL: string = Billing + '/SIOC';
export const SalesIndentOtherCharges_Create = SalesIndentOtherChargesURL + '/Create';
export const SalesIndentOtherCharges_Update = SalesIndentOtherChargesURL + '/Update';
export const SalesIndentOtherCharges_Delete = SalesIndentOtherChargesURL + '/Delete';
export const SalesIndentOtherCharges_ReadById = SalesIndentOtherChargesURL + '/ReadById';
export const SalesIndentOtherCharges_ReadByIndentId = SalesIndentOtherChargesURL + '/ReadByIndentId';
// endregion

//region TenantSPConfig API
export const TenantSPConfigURL: string = AdvinMaster + '/TSPC';
export const TenantSPConfig_Create = TenantSPConfigURL + '/Create';
export const TenantSPConfig_Update = TenantSPConfigURL + '/Update';
export const TenantSPConfig_Delete = TenantSPConfigURL + '/Delete';
export const TenantSPConfig_ReadById = TenantSPConfigURL + '/ReadById';
export const TenantSPConfig_ReadByTenantTable = TenantSPConfigURL + '/ReadByTenantTable';
export const TenantSPConfig_ReadByUICName = TenantSPConfigURL + '/ReadByUICName';
///endregion

//region LaborTimeTracking API
export const LaborTimeTrackingURL: string = Billing + '/LTT';
export const LaborTimeTracking_Create = LaborTimeTrackingURL + '/Create';
export const LaborTimeTracking_Update = LaborTimeTrackingURL + '/Update';
export const LaborTimeTracking_Delete = LaborTimeTrackingURL + '/Delete';
export const LaborTimeTracking_ReadById = LaborTimeTrackingURL + '/ReadById';
export const LaborTimeTracking_ReadAll = LaborTimeTrackingURL + '/ReadAll';
export const LaborTimeTracking_ReadByTenantId = LaborTimeTrackingURL + '/ReadByTenantId';
export const LaborTimeTracking_ReadByMasterId = LaborTimeTrackingURL + '/ReadByMasterId';
///endregion

//region SalesSettings API
export const SalesSettingsURL: string = Billing + '/SS';
///endregion

//region PaymentFollowup API
export const PaymentFollowupURL: string = Billing + '/PF';
export const PaymentFollowup_ReadInvoicesByTenantId = PaymentFollowupURL + '/ReadInvoicesByTenantId';
export const PaymentFollowup_ReadInvoicesByUserId = PaymentFollowupURL + '/ReadInvoicesByUserId';
export const PaymentFollowup_ReadInvoiceItemsByInvoiceId = PaymentFollowupURL + '/ReadInvoiceItemsByInvoiceId';
export const PaymentFollowup_ReadInvoiceReceiptsByInvoiceId = PaymentFollowupURL + '/ReadInvoiceReceiptsByInvoiceId';
export const PaymentFollowup_ReadFollowUpsByInvoiceId = PaymentFollowupURL + '/ReadFollowUpsByInvoiceId';
export const PaymentFollowup_CreateFollowUp = PaymentFollowupURL + '/CreateFollowUp';
export const PaymentFollowup_Assignment_ReadByTenantId = PaymentFollowupURL + '/Assignment/ReadByTenantId';
export const PaymentFollowup_Assignment_Create = PaymentFollowupURL + '/Assignment/Create';
export const PaymentFollowup_Assignment_Delete = PaymentFollowupURL + '/Assignment/Delete';
export const PaymentFollowup_City_ReadByTenantId = PaymentFollowupURL + '/City/ReadByTenantId';
///endregion


//#region Payroll - PayCalender API
export const PayCalendarURL: string = Payroll + '/PC';
export const PayCalendar_Create = PayCalendarURL + '/Create';
export const PayCalendar_Update = PayCalendarURL + '/Update';
export const PayCalendar_Delete = PayCalendarURL + '/Delete';
export const PayCalendar_ReadAll = PayCalendarURL + '/ReadAll';
export const PayCalendar_ReadById = PayCalendarURL + '/ReadById';
export const PayCalendar_ReadByTenantId = PayCalendarURL + '/ReadByTenantId';
//#endRegion

//#region Payroll - PayPeriod API
export const PayPeriodURL: string = Payroll + '/PP';
export const PayPeriod_Create = PayPeriodURL + '/Create';
export const PayPeriod_Update = PayPeriodURL + '/Update';
export const PayPeriod_Delete = PayPeriodURL + '/Delete';
export const PayPeriod_ReadAll = PayPeriodURL + '/ReadAll';
export const PayPeriod_ReadById = PayPeriodURL + '/ReadById';
export const PayPeriod_ReadByTenantId = PayPeriodURL + '/ReadByTenantId';
export const PayPeriod_ReadByPayCalendarId = PayPeriodURL + '/ReadByPayCalendarId';
export const PayPeriod_CreateBulk = PayPeriodURL + '/CreateBulk';
//#endRegion

//#region Payroll - PayRoll API
export const PayRollURL: string = HRMS + '/PR';
export const PayRoll_Create = PayRollURL + '/Create';
export const PayRoll_Update = PayRollURL + '/Update';
export const PayRoll_Delete = PayRollURL + '/Delete';
export const PayRoll_ReadAll = PayRollURL + '/ReadAll';
export const PayRoll_ReadById = PayRollURL + '/ReadById';
export const PayRoll_ReadByPayPeriodId = PayRollURL + '/ReadByPayPeriodId';
export const PayRoll_ExecuteByPayPeriodId = PayRollURL + '/ExecuteByPayPeriodId';
export const PayRoll_ReadByIndividualId = PayRollURL + '/ReadByIndividualId';
//#endRegion

//#region Payroll - PaySlip API
export const PaySlipURL: string = Payroll + '/PS';
export const PaySlip_Create = PaySlipURL + '/Create';
export const PaySlip_Update = PaySlipURL + '/Update';
export const PaySlip_Delete = PaySlipURL + '/Delete';
export const PaySlip_ReadAll = PaySlipURL + '/ReadAll';
export const PaySlip_ReadById = PaySlipURL + '/ReadById';
export const PaySlip_ReadByEmployeeId = PaySlipURL + '/ReadByEmployeeId';
export const PaySlip_ReadByPayRunId = PaySlipURL + '/ReadByPayRunId';
export const PaySlip_ReadByBankDetailId = PaySlipURL + '/ReadByBankDetailId';
export const PaySlip_UpdatePublishStatus = PaySlipURL + '/UpdatePublishStatus';
//#endRegion

//#region Payroll - PaySlipDetail API
export const PaySlipDetailURL: string = Payroll + '/PSD';
export const PaySlipDetail_Create = PaySlipDetailURL + '/Create';
export const PaySlipDetail_Update = PaySlipDetailURL + '/Update';
export const PaySlipDetail_Delete = PaySlipDetailURL + '/Delete';
export const PaySlipDetail_ReadAll = PaySlipDetailURL + '/ReadAll';
export const PaySlipDetail_ReadById = PaySlipDetailURL + '/ReadById';
export const PaySlipDetail_ReadByComponentId = PaySlipDetailURL + '/ReadByComponentId';
export const PaySlipDetail_ReadByPaySlipId = PaySlipDetailURL + '/ReadByPaySlipId';
//#endRegion
//#region AdvinMaster - TenantDataBackup API
export const TenantDataBackupURL: string = AdvinMaster + '/TDB';
export const TenantDataBackup_GenerateScript = TenantDataBackupURL + '/GenerateScript';
export const TenantDataBackup_ListBackups = TenantDataBackupURL + '/ListBackups';
export const TenantDataBackup_CleanUpTenant = TenantDataBackupURL + '/CleanUpTenant';
export const TenantDataBackup_RestoreBackup = TenantDataBackupURL + '/RestoreBackup';
export const TenantDataBackup_DownloadBackup = TenantDataBackupURL + '/DownloadBackup';
export const TenantDataBackup_Databases = TenantDataBackupURL + '/Databases';
//#endRegion
//#region AdvinMaster - ExportData API
export const ExportDataURL: string = AdvinMaster + '/ED';
export const ExportData_Convert = ExportDataURL + '/Convert';
//#endRegion

//#region ERP - SalesSchemeMaster API
export const SalesSchemeMasterURL: string = ERP + '/SSM';
export const SalesSchemeMaster_create = SalesSchemeMasterURL + '/Create';
export const SalesSchemeMaster_update = SalesSchemeMasterURL + '/Update';
export const SalesSchemeMaster_delete = SalesSchemeMasterURL + '/Delete';
export const SalesSchemeMaster_readById = SalesSchemeMasterURL + '/ReadById';
export const SalesSchemeMaster_readAllPaginated = SalesSchemeMasterURL + '/ReadAllPaginated';
//#endRegion

//#region ERP - SalesSchemeDetail API
export const SalesSchemeDetailURL: string = ERP + '/SSD';
export const SalesSchemeDetail_upsertBulk = SalesSchemeDetailURL + '/UpsertBulk';
export const SalesSchemeDetail_readBySchemeId = SalesSchemeDetailURL + '/ReadBySchemeId';
export const SalesSchemeDetail_readById = SalesSchemeDetailURL + '/ReadById';
export const SalesSchemeDetail_delete = SalesSchemeDetailURL + '/Delete';
//#endRegion

//#region ERP - SalesSchemeApplicability API
export const SalesSchemeApplicabilityURL: string = ERP + '/SSA';
export const SalesSchemeApplicability_upsertBulk = SalesSchemeApplicabilityURL + '/UpsertBulk';
export const SalesSchemeApplicability_readBySchemeId = SalesSchemeApplicabilityURL + '/ReadBySchemeId';
export const SalesSchemeApplicability_delete = SalesSchemeApplicabilityURL + '/Delete';
//#endRegion

//#region ERP - SchemeTenantSettings API
export const SchemeTenantSettingsURL: string = ERP + '/STS';
export const SchemeTenantSettings_upsert = SchemeTenantSettingsURL + '/Upsert';
export const SchemeTenantSettings_readByTenantId = SchemeTenantSettingsURL + '/ReadByTenantId';
//#endRegion

//#region ERP - SalesSchemeAchievement API
export const SalesSchemeAchievementURL: string = ERP + '/SAC';
export const SalesSchemeAchievement_readById = SalesSchemeAchievementURL + '/ReadById';
export const SalesSchemeAchievement_readBySchemeId = SalesSchemeAchievementURL + '/ReadBySchemeId';
export const SalesSchemeAchievement_readNearAchievement = SalesSchemeAchievementURL + '/ReadNearAchievement';
//#endRegion

//#region ERP - SalesSchemeAchievementTransaction API
export const SalesSchemeAchievementTransactionURL: string = ERP + '/SAT';
export const SalesSchemeAchievementTransaction_readByAchievementId = SalesSchemeAchievementTransactionURL + '/ReadByAchievementId';
//#endRegion

//#region ERP - SalesSchemeAchievementDetail API
export const SalesSchemeAchievementDetailURL: string = ERP + '/SAD';
export const SalesSchemeAchievementDetail_readByAchievementId = SalesSchemeAchievementDetailURL + '/ReadByAchievementId';
export const SalesSchemeAchievementDetail_readAllPaginated = SalesSchemeAchievementDetailURL + '/ReadAllPaginated';
export const SalesSchemeAchievementDetail_updateStatus = SalesSchemeAchievementDetailURL + '/UpdateStatus';
//#endRegion

//#region AI - AIReportQueryEngine API (Claude drafting + SQL execution)
export const AIReportQueryEngineURL: string = AI + '/ARQE';
export const AIReportQueryEngine_draftReport = AIReportQueryEngineURL + '/DraftReport';
export const AIReportQueryEngine_runReport = AIReportQueryEngineURL + '/RunReport';
//#endRegion

//#region AI - SpeechToText API (voice input for the AI Report Builder's prompt box)
export const SpeechToTextURL: string = AI + '/STT';
export const SpeechToText_transcribeAudio = SpeechToTextURL + '/TranscribeAudio';
//#endRegion

//#region AdvinMaster - AIReportDefinition API (saved reports)
export const AIReportDefinitionURL: string = AdvinMaster + '/ARD';
export const AIReportDefinition_create = AIReportDefinitionURL + '/Create';
export const AIReportDefinition_update = AIReportDefinitionURL + '/Update';
export const AIReportDefinition_delete = AIReportDefinitionURL + '/Delete';
export const AIReportDefinition_readById = AIReportDefinitionURL + '/ReadById';
export const AIReportDefinition_readAllPaginated = AIReportDefinitionURL + '/ReadAllPaginated';
export const AIReportDefinition_updatePublishStatus = AIReportDefinitionURL + '/UpdatePublishStatus';
//#endRegion

//#region AdvinMaster - AIReportDatasetAccess API (allowed views for tenant/role)
export const AIReportDatasetAccessURL: string = AdvinMaster + '/ARDA';
export const AIReportDatasetAccess_readAllowedViewsByTenantRole = AIReportDatasetAccessURL + '/ReadAllowedViewsByTenantRole';
//#endRegion

//#region AdvinMaster - AIReportRoleAccess API (feature access gate)
export const AIReportRoleAccessURL: string = AdvinMaster + '/ARRA';
export const AIReportRoleAccess_readByTenantIdRoleId = AIReportRoleAccessURL + '/ReadByTenantIdRoleId';
//#endRegion

//#region AdvinMaster - AIReportUsageQuota API (monthly query usage)
export const AIReportUsageQuotaURL: string = AdvinMaster + '/ARUQ';
export const AIReportUsageQuota_readByTenantIdPeriod = AIReportUsageQuotaURL + '/ReadByTenantIdPeriod';
//#endRegion
